//import $ from 'jquery';
import Swal from 'sweetalert2';
import { isEmpty, isUndefined } from 'lodash';
import axios from 'axios';
import moment from 'moment';
import { buildingContractModelGet } from '../models/buildings/buildingContract';
import { GlobalFormats } from '../classes/main/globalFormats';
//import Cryptr from 'cryptr';

require('dotenv').config();
const { REACT_APP_RECAPTCHA_SITE_KEY, REACT_APP_RECAPTCHA_SECRET_KEY, REACT_APP_RECAPTCHAv2_SITE_KEY, REACT_APP_RECAPTCHAv2_SECRET_KEY, NODE_ENV, } = process.env;

export const checkIfUserIsMaster = ({ email = '', languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'checkIfUserIsMaster';
  let response = responseGet();
  try {
    email = email?.toLowerCase()?.trim();
    response.msgType = 1;
    response.msgText = `${globalSettings?.messages?.thisUserNotMaster?.[languageId]}</br>`;
    response.msgText += `Email: <b>${isUndNullEmp({ data: email, subMethod: currentMethod })?.result ? 'Anonymous' : email}</b>`;

    if (!isEmpty(email)) {
      if (email === globalSettings?.app?.users?.admin?.email?.toLowerCase()?.trim()) {
        response.msgType = 0;
        response.msgText = '';
        response.result = globalSettings?.roles?.master;
      } else if (email === globalSettings?.app?.users?.admin2?.email?.toLowerCase()?.trim()) {
        response.msgType = 0;
        response.msgText = '';
        response.result = globalSettings?.roles?.master;
      } else {
        response.isWarning = true;
        response.result = globalSettings?.roles?.user;
      }
    } else {
      response.isWarning = true;
      response.result = globalSettings?.roles?.anonymous;
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}</br>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = globalSettings?.roles?.anonymous;
  }
  return response;
}

export const dataTableLanguaje = ({ languageId = 'en', subMethod = '', }) => {
  switch (languageId) {
    case 'es':
      return {
        decimal: ',',
        thousands: '.',
        sProcessing: 'Procesando...',
        //sLengthMenu: 'Mostrar _MENU_ registros',
        sLengthMenu: 'Mostrar _MENU_',
        sZeroRecords: 'No se encontraron resultados',
        sEmptyTable: 'Ningún dato disponible en esta tabla',
        //sInfo: 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
        sInfo: 'Mostrando _START_ al _END_ de _TOTAL_ registros',
        //sInfoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
        sInfoEmpty: 'Mostrando 0 al 0 de 0 registros',
        //sInfoFiltered: '(filtrado de un total de _MAX_ registros)',
        sInfoFiltered: '',
        sInfoPostFix: '',
        //sSearch: 'Buscar:',
        sSearch: 'Buscar',
        sUrl: '',
        sInfoThousands: ',',
        sLoadingRecords: 'Cargando...',
        oPaginate: {
          sFirst: 'Primero',
          sLast: 'Último',
          sNext: 'Siguiente',
          sPrevious: 'Anterior'
        },
        oAria: {
          sSortAscending: ': Activar para ordenar la columna de manera ascendente',
          sSortDescending: ': Activar para ordenar la columna de manera descendente'
        }
      }

    default:
      return {
        decimal: '.',
        thousands: ',',
        sEmptyTable: 'No data available in table',
        sInfo: 'Showing _START_ to _END_ of _TOTAL_ entries',
        sInfoEmpty: 'Showing 0 to 0 of 0 entries',
        sInfoFiltered: '(filtered from _MAX_ total entries)',
        sInfoPostFix: '',
        sInfoThousands: ',',
        sLengthMenu: 'Show _MENU_ entries',
        sLoadingRecords: 'Loading...',
        sProcessing: 'Processing...',
        sSearch: 'Search:',
        sZeroRecords: 'No matching records found',
        oPaginate: {
          sFirst: 'First',
          sLast: 'Last',
          sNext: 'Next',
          sPrevious: 'Previous'
        },
        oAria: {
          sSortAscending: ': activate to sort column ascending',
          sSortDescending: ': activate to sort column descending'
        }
      }
  }
}

export const getButtonProcess = (id = '', description = '') => {
  let response = responseGet();
  try {
    response.result = `<div class='btn-group dropend'>`;
    response.result += `    <button class='btn btn-light btn-sm dropdown-toggle' type='button' id='dropdownMenu2' data-bs-toggle='dropdown' aria-expanded='false'> `;
    response.result += `        <i class='${globalSettings?.icons?.ellipsisV}'></i> `;
    response.result += `    </button> `;
    response.result += `    <ul class='dropdown-menu' aria-labelledby='dropdownMenu2'> `;
    response.result += `        <li><button `;
    response.result += `                class='dropdown-item' `;
    response.result += `                description='${description}' `;
    response.result += `                href='javascript:void(0)' `;
    response.result += `                id='${id}' `;
    response.result += `                method='edit' `;
    response.result += `                type='button'><i class='${globalSettings?.icons?.edit}'></i> ${globalSettings?.labels?.edit.es}</button></li> `;
    response.result += `        <li><button `;
    response.result += `                class='dropdown-item' `;
    response.result += `                description='${description}' `;
    response.result += `                href='javascript:void(0)' `;
    response.result += `                id='${id}' `;
    response.result += `                method='delete' `;
    response.result += `                type='button'><i class='${globalSettings?.icons?.trash}'></i> ${globalSettings?.labels?.delete.es}</button></li> `;
    response.result += `    </ul> `;
    response.result += `</div>`;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '';
    response.msgText = `Method: getButtonProcess<br/>${ex?.message}`;
  }
  return response;
}

export const getButtonProcessTwo = (id = '', description = '', showDetails = false, showEdit = false, showDelete = false) => {
  let response = responseGet();
  try {
    response.result = `<div class='btn-group dropend'>`;
    response.result += `    <button class='btn btn-light btn-sm dropdown-toggle' type='button' id='dropdownMenu2' data-bs-toggle='dropdown' aria-expanded='false'> `;
    response.result += `        <i class='${globalSettings?.icons?.ellipsisV}'></i> `;
    response.result += `    </button> `;
    response.result += `    <ul class='dropdown-menu' aria-labelledby='dropdownMenu2'> `;
    if (showEdit) {
      response.result += `        <li><button `;
      response.result += `                class='dropdown-item' `;
      response.result += `                description='${description}' `;
      response.result += `                href='javascript:void(0)' `;
      response.result += `                id='${id}' `;
      response.result += `                method='edit' `;
      response.result += `                type='button'><i class='${globalSettings?.icons?.edit}'></i> ${globalSettings?.labels?.edit.es}</button></li> `;
    }
    if (showDetails) {
      response.result += `        <li><button `;
      response.result += `                class='dropdown-item' `;
      response.result += `                description='${description}' `;
      response.result += `                href='javascript:void(0)' `;
      response.result += `                id='${id}' `;
      response.result += `                method='details' `;
      response.result += `                type='button'><i class='fas fa-align-justify'></i> ${globalSettings?.labels?.details.es}</button></li> `;
    }
    if (showDelete) {
      response.result += `        <li><button `;
      response.result += `                class='dropdown-item' `;
      response.result += `                description='${description}' `;
      response.result += `                href='javascript:void(0)' `;
      response.result += `                id='${id}' `;
      response.result += `                method='delete' `;
      response.result += `                type='button'><i class='${globalSettings?.icons?.trash}'></i> ${globalSettings?.labels?.delete.es}</button></li> `;
    }
    response.result += `    </ul> `;
    response.result += `</div>`;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '';
    response.msgText = `Method: getButtonProcessTwo<br/>${ex?.message}`;
  }
  return response;
}

export const getButtonProcessThree = (id = '', description = '', showDetails = false, enabledDetails = false, showEdit = false, enabledEdit = false, showDelete = false, enabledDelete = false) => {
  let response = responseGet();
  try {
    response.result = `<div class='btn-group dropend'>`;
    response.result += `    <button class='btn btn-light btn-sm dropdown-toggle' type='button' id='dropdownMenu2' data-bs-toggle='dropdown' aria-expanded='false'> `;
    response.result += `        <i class='${globalSettings?.icons?.ellipsisV}'></i> `;
    response.result += `    </button> `;
    response.result += `    <ul class='dropdown-menu' aria-labelledby='dropdownMenu2'> `;
    if (showEdit) {
      response.result += `        <li><button `;
      response.result += `                class='dropdown-item' `;
      response.result += `                description='${description}' `;
      if (!enabledEdit) {
        response.result += `                disabled `;
      }
      response.result += `                href='javascript:void(0)' `;
      response.result += `                id='${id}' `;
      response.result += `                method='edit' `;
      response.result += `                type='button'><i class='${globalSettings?.icons?.edit}'></i> ${globalSettings?.labels?.edit.es}</button></li> `;
    }
    if (showDetails) {
      response.result += `        <li><button `;
      response.result += `                class='dropdown-item' `;
      response.result += `                description='${description}' `;
      if (!enabledDetails) {
        response.result += `                disabled `;
      }
      response.result += `                href='javascript:void(0)' `;
      response.result += `                id='${id}' `;
      response.result += `                method='details' `;
      response.result += `                type='button'><i class='fas fa-align-justify'></i> ${globalSettings?.labels?.details.es}</button></li> `;
    }
    if (showDelete) {
      response.result += `        <li><button `;
      response.result += `                class='dropdown-item' `;
      response.result += `                description='${description}' `;
      if (!enabledDelete) {
        response.result += `                disabled `;
      }
      response.result += `                href='javascript:void(0)' `;
      response.result += `                id='${id}' `;
      response.result += `                method='delete' `;
      response.result += `                type='button'><i class='${globalSettings?.icons?.trash}'></i> ${globalSettings?.labels?.delete.es}</button></li> `;
    }
    response.result += `    </ul> `;
    response.result += `</div>`;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '';
    response.msgText = `Method: getButtonProcessTwo<br/>${ex?.message}`;
  }
  return response;
}

export const getButtonProcessFour = (id = '', description = '', showDetails = false, labelDetails = '', enabledDetails = false, showEdit = false, labelEdit = '', enabledEdit = false, showDelete = false, labelDelete = '', enabledDelete = false) => {
  let response = responseGet();
  try {
    response.result = `<div class='btn-group dropend'>`;
    response.result += `<button class='btn btn-light btn-sm dropdown-toggle' type='button' id='dropdownMenu2' data-bs-toggle='dropdown' aria-expanded='false'> `;
    response.result += `<i class='${globalSettings?.icons?.ellipsisV}'></i> `;
    response.result += `</button> `;
    response.result += `<ul class='dropdown-menu' aria-labelledby='dropdownMenu2'> `;
    if (showEdit) {
      response.result += `<li><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledEdit) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='edit' `;
      response.result += `type='button'><i class='${globalSettings?.icons?.edit}'></i> ${labelEdit}</button></li> `;
    }
    if (showDetails) {
      response.result += `<li><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledDetails) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='details' `;
      response.result += `type='button'><i class='fas fa-align-justify'></i> ${labelDetails}</button></li> `;
    }
    if (showDelete) {
      response.result += `<li><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledDelete) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='delete' `;
      response.result += `type='button'><i class='${globalSettings?.icons?.trash}'></i> ${labelDelete}</button></li> `;
    }
    response.result += `</ul> `;
    response.result += `</div>`;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '';
    response.msgText = `Method: getButtonProcessTwo<br/>${ex?.message}`;
  }
  return response;
}

export const buttonProcessGet = ({
  id = '',
  description = '',
  showDetails = false,
  labelDetails = '',
  enabledDetails = false,
  showEdit = false,
  labelEdit = '',
  enabledEdit = false,
  showDelete = false,
  labelDelete = '',
  enabledDelete = false,
  processButtons = [],
  subMethod = '',
}) => {
  const currentMethod = '';
  let response = responseGet();
  try {
    //#region Head
    response.result = `<div class='btn-group dropend'>`;
    response.result += `<button class='btn btn-light btn-sm dropdown-toggle' type='button' id='dropdownMenu2' data-bs-toggle='dropdown' aria-expanded='false'> `;
    response.result += `<i class='${globalSettings?.icons?.ellipsisV}'></i> `;
    response.result += `</button> `;
    response.result += `<ul class='dropdown-menu' aria-labelledby='dropdownMenu2'> `;
    //#endregion Head

    //#region Primay process
    if (showEdit) {
      response.result += `<li><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledEdit) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='edit' `;
      response.result += `type='button'><i class='${globalSettings?.icons?.edit}'></i> ${labelEdit}</button></li> `;
    }
    if (showDetails) {
      response.result += `<li><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledDetails) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='details' `;
      response.result += `type='button'><i class='fas fa-align-justify'></i> ${labelDetails}</button></li> `;
    }
    if (showDelete) {
      response.result += `<li><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledDelete) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='delete' `;
      response.result += `type='button'><i class='${globalSettings?.icons?.trash}'></i> ${labelDelete}</button></li> `;
    }
    //#endregion Primary process

    //#region add new buttons
    if (!isUndNullEmp({ data: processButtons, subMethod: currentMethod, })?.result && processButtons?.length > 0) {
      processButtons?.map((detail) => { // eslint-disable-line array-callback-return
        if (detail?.isVisible) {

          if (detail?.showDivider) {
            response.result += `<li class='dropdown-divider'></li>`;
          }

          response.result += `<li><button `;
          response.result += `class='dropdown-item' `;
          response.result += `description='${description}' `;
          if (!detail?.isEnabled) {
            response.result += `disabled `;
          }
          response.result += `href='javascript:void(0)' `;
          response.result += `id='${id}' `;
          response.result += `method='${detail?.methodName}' `;
          response.result += `type='button'><i class='${detail?.icon}'></i> ${detail?.label}</button></li> `;
        }
      });
    }
    //#region add new buttons

    //#region final data set
    response.result += `</ul> `;
    response.result += `</div>`;
    //#endregion final data set
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const responseGet = () => {
  return {
    error: {
      number: 0,
      msgText: '',
    },
    isSuccess: true,
    isWarning: false,
    msgType: 0,
    //msgText: null,
    msgText: '',
    msgHtml: '',
    result: null,
    resultTwo: null,
    urlGoTo: '',
  };
};

// export const getSettings = (email) => {
//   return {
//     messages: {
//       thisEmailAlreadyOurSystemConfirmAccount: `Este correo electrónico de <b>${email}</b> ya está registrado en nuestro sistema, debe confirmar su cuenta desde su correo electrónico para verificar su identidad y poder acceder a nuestro sistema`,
//     },
//   };
// }

export const getSettings = (email = '') => {
  return {
    messages: {
      thisEmailAlreadyOurSystemConfirmAccount: {
        en: `This email from <b>${email}</b> is already registered in our system, you must confirm your account from your email to verify your identity and be able to access our system`,
        es: `Este correo electrónico de <b>${email}</b> ya está registrado en nuestro sistema, debe confirmar su cuenta desde su correo electrónico para verificar su identidad y poder acceder a nuestro sistema`,
      },
    },
  };
}

const enviroments = Object?.freeze({
  dev: 'development',
  pro: 'production',
  tes: 'test',
});

export const globalSettingsPassword = {
  minLength: 6,
};

export const globalSettings = Object.freeze({
  app: {
    address: 'Urb. La Paz, EL Paraiso. Caracas - Venezuela',
    backend: {
      documents: {
        apartmentReceiptPaymentFiles: 'apartmentReceiptPaymentFiles',
        buildingDocuments: 'documents',
        purchaseFiles: 'purchaseFiles',
        profileImage: 'profileImage',
      },
      methods: {
        accounts: {
          profileGet: 'profileGet',
          contracts: {
            add: 'contractAdd',
            remove: 'contractRemove',
          }
        },
        apartmentReceiptPaymentFileDelete: 'apartmentReceiptPaymentFileDelete',
        apartmentReceiptPaymentFileOpen: 'apartmentReceiptPaymentFileOpen',
        apartmentReceiptWithFullDetails: 'apartmentReceiptWithFullDetails',
        apartments: {
          aliquotErasers: 'aliquotErasers',
          apartmentWithDetails: 'apartmentWithDetails'
        },
        apartmentUsers: {
          getAsync: 'getAsync',
          listCreateAsync: 'apartmentUserListCreateAsync',
        },
        apartmentUsersWithDetails: 'apartmentUsersWithDetails',
        apartmentsWithReceiptsAndBalance: 'apartmentsWithReceiptsAndBalance',
        attachedFiles: 'attachedFiles',
        authUser: 'authUser',
        buildingsByUser: 'buildingsByUser',
        condominiumBoardElectionResults: 'condominiumBoardElectionResults',
        checkUserIsCondominiumBoard: 'checkUserIsCondominiumBoard',
        contractAdd: 'contractAdd',
        delete: 'delete',
        deleteAccount: 'deleteAccount',
        emailConfirmSend: 'emailConfirmSend',
        enableDisableAccount: 'enableDisableAccount',
        expenseConceptVariations: 'expenseConceptVariations',
        expenseTemplates: {
          variationsGet: 'variationsGet',
        },
        fileDelete: 'fileDelete',
        fileUploadAsync: 'fileUploadAsync',
        fileUrlDownloadGet: 'fileUrlDownloadGet',
        getById: 'getById',
        home: {
          dataByBuildingId: 'dataByBuildingId',
          dataByUserId: 'dataByUserId',
        },
        movements: 'movements',
        previousResults: 'previousResults',
        reconciliePaymentDataGet: 'reconciliePaymentDataGet',
        restoreRegister: 'restoreRegister',
        receiptsVariations: 'receiptsVariations',
        sendMessage: 'sendMessage',
        sendEmailWelcome: 'sendEmailWelcome',
        sendEmailVerification: 'sendEmailVerification',
        showRates: 'showRates',
        showVariations: 'showVariations',
        supplierBalance: 'supplierBalance',
        users: {
          roleCheck: 'roleCheck',
        },
        variationsGet: 'variationsGet',
        vote: 'vote',
        wellEmail: 'wellEmail',
      },
      urlAccounts: '/accounts',
      urlApiV1: '/api/v1',
      //#region old code
      //url: 'https://vzlacondominiosbackend.herokuapp.com',
      //url: 'https://vzlacondominiosapi-production.up.railway.app',
      //#endregion old code
      //url: 'https://vzlacondominiosapi.up.railway.app',
      url: NODE_ENV === enviroments?.dev ?
        'http://localhost:3001' :
        NODE_ENV === enviroments?.pro ? 'https://vzlacondominiosapi.up.railway.app' : '',
      urlAbout: '/about',
      urlApartments: '/apartments',
      urlApartmentDetails: '/apartmentDetails',
      urlApartmentEdit: '/apartmentEdit',
      urlApartmentPeoples: '/apartmentPeoples',
      urlApartmentReceipts: '/apartmentReceipts',
      urlApartmentReceiptDetails: '/apartmentReceiptDetails',
      urlApartmentReceiptPayments: '/apartmentReceiptPayments',
      urlApartmentReceiptPaymentFiles: '/apartmentReceiptPaymentFiles',
      urlApartmentUsers: '/apartmentUsers',
      urlBanks: '/banks',
      urlBankAccounts: '/bankAccounts',
      urlBankAccountMovements: '/bankAccountMovements',
      urlBuildings: '/buildings',
      urlBuildingDetails: '/buildingDetails',
      urlBuildingEdit: '/buildingEdit',
      urlBuildingContracts: '/buildingsContracts',
      urlBuildingDocuments: '/buildingDocuments',
      urlBuildingSettings: '/buildingSettings',
      urlBuildingUsers: '/buildingUsers',
      urlChangePassword: '/changePassword',
      urlCoins: '/coins',
      urlCoinRates: '/coinRates',
      urlCountries: '/countries',
      urlCollectionBankAccounts: '/collectionBankAccounts',
      urlCollectionCashes: '/collectionCashes',
      urlCollectionCashMovements: '/collectionCashMovements',
      urlCommonAreas: '/commonAreas',
      urlCondominiumBoardElections: '/condominiumBoardElections',
      urlCondominiumBoardElectionDetails: '/condominiumBoardElectionDetails',
      urlCondominiumBoardElectionEdit: '/condominiumBoardElectionEdit',
      urlCondominiumBoardRoles: '/condominiumBoardRoles',
      urlContact: '/contact',
      urlContactMessage: '/contactMessage',
      urlContactMessages: '/contactMessages',
      //urlDev: 'http://localhost:3001',
      urlExpenseConcepts: '/expenseConcepts',
      urlExpenseTemplates: '/expenseTemplates',
      urlElevators: '/elevators',
      urlFiles: '/files',
      urlForgotPassword: '/forgotPassword',
      urlForgotPasswordMessage: '/forgotPasswordMessage',
      urlInformativeBillboards: '/informativeBillboards',
      urlInventories: '/inventories',
      urlHome: '/home',
      urlLogin: '/login',
      urlNtNr: '/nTnR',
      urlPaymentMethods: '/paymentMethods',
      urlPeopleTypes: '/peopleTypes',
      urlPrivacy: '/privacy',
      urlProfile: '/profile',
      urlPurchases: '/purchases',
      urlPurchaseAdd: '/purchaseAdd',
      urlPurchaseDetail: '/purchaseDetail',
      urlPurchaseEdit: '/purchaseEdit',
      urlPurchasePayments: '/purchasePayments',
      urlReserveCommonAreas: '/reserveCommonAreas',
      urlSettings: '/settings',
      urlSuppliers: '/suppliers',
      urlSupplierCurrentBalance: '/supplierCurrentBalance',
      urlReceipts: '/receipts',
      urlReceiptGenerate: '/receiptGenerate',
      urlReconcilePayments: '/reconcilePayments',
      urlRegisterStatus: '/registerStatus',
      urlReports: '/reports',
      urlRoles: '/roles',
      urlTaxes: '/taxes',
      urlUsers: '/users',
      urlUserRegister: '/registerUser',
      urlVerificationMessage: '/verificationMessage',
      urlWelcomeMessage: '/welcomeMessage',
    },
    ceo: 'T.S.U. - Ing. Carlos H.',
    company: {
      name: 'CHEJ Consultor, C.A.',
      slogan: 'Su requerimiento es nuestro compromiso',
      url: 'https://www.chejconsultor.com.ve/',
    },
    emails: {
      dptoSupport: 'condominios.server@gmail.com',
      primary: 'vzlacondominios@gmail.com',
    },
    files: {
      apartmentReceiptPaymentFileMaxFiles: 2,
      buildingDocumentMaxFiles: 5,
      purchaseMaxFiles: 2,
    },
    fileTypes: {
      images: ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp',],
      filesOne: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',],
      filesTwo: ['application/pdf', 'text/plain',],
      filesThree: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',],
      filesOnlyPdf: ['application/pdf'],
    },
    fileSize: {
      max: 2097152,
    },
    profile: {
      images: {
        quantity: 1,
        maxSize: 2097152,
      },
    },
    name: 'VzLa Condominios',
    reCAPTCHA: {
      reCAPTCHASiteKey: REACT_APP_RECAPTCHA_SITE_KEY,
      reCAPTCHASecretKey: REACT_APP_RECAPTCHA_SECRET_KEY,
      reCaptchaV2SiteKey: REACT_APP_RECAPTCHAv2_SITE_KEY,
      reCaptchaV2SecretKey: REACT_APP_RECAPTCHAv2_SECRET_KEY,
      urlPrivaciConditions: 'https://policies.google.com/terms?hl=es-419',
    },
    processes: {
      about: 'about',
      apartments: 'apartments',
      banks: 'banks',
      buildings: 'buildings',
      buildingDocuments: 'buildingDocuments',
      coins: 'coins',
      collectionCashes: 'collectionCashes',
      collectionBankAccounts: 'collectionBankAccounts',
      concepts: 'concepts',
      condominiumBoardElections: 'condominiumBoardElections',
      condominiumBoardRoles: 'condominiumBoardRoles',
      contact: 'contact',
      countries: 'countries',
      generate: 'generate',
      generated: 'generated',
      home: 'home',
      informativeBillboard: 'informativeBillboard',
      paymentMethods: 'paymentMethods',
      peopleTypes: 'peopleTypes',
      privacy: 'privacy',
      purchases: 'purchases',
      reconcilePayments: 'reconcilePayments',
      reserveCommonAreas: 'reserveCommonAreas',
      roles: 'roles',
      suppliers: 'suppliers',
      taxes: 'taxes',
      templates: 'templates',
      users: 'users',
    },
    reports: {
      bankAccountMovementsPrint: 'bankAccountMovementsPrint',
      collectionCashMovementsPrint: 'collectionCashMovementsPrint',
      electionResultsPrint: 'electionResultsPrint',
      electionPreviousResultsPrint: 'electionPreviousResultsPrint',
      expenseConceptVariationsPrint: 'expenseConceptVariationsPrint',
      processType: {
        supplierCurrentBalanceGet: 'supplierCurrentBalanceGet',
      },
      receiptPrint: 'receiptPrint',
      receiptsVariationsPrint: 'receiptsVariationsPrint',
      supplierCurrentBalancePrint: 'supplierCurrentBalancePrint',
    },
    title: 'VzLa Condominios',
    url: NODE_ENV === enviroments?.dev ?
      'http://localhost:3000' :
      NODE_ENV === enviroments?.pro ? 'https://vzlacondominios.web.app' : '',
    urlGoogleMaps: 'https://maps.google.com/maps?q=Edificio%20Horatius,%20Calle%20Pichincha,%20Caracas,%20Capital%20District&t=&z=18&ie=UTF8&iwloc=&output=embed',
    //url: 'https://vzlacondominios.web.app/',
    users: {
      admin: {
        firstName: 'System',
        lasName: 'Master',
        email: 'condominios.server@gmail.com',
        password: 'Ch123456.',
      },
      admin2: {
        firstName: 'System',
        lasName: 'Master - 02',
        email: 'vzlacondominios@gmail.com',
        password: 'Ch123456.',
      },
    },
    //version: '1.0.0',
    version: '1.1.1',
    viewNames: {
      collection: 'collection',
      condominiumBoard: 'condominiumBoard',
      expenses: 'expenses',
      home: 'home',
      process: 'process',
      receipts: 'receipts',
      settings: 'settings',
    },
    year: 2021,
    zipCode: 1020,
  },
  banks: [
    { code: '0001', name: 'Banco Central de Venezuela', rif: 'G200001100', },
    { code: '0102', name: 'Banco de Venezuela', rif: 'G200001100', },
    { code: '0104', name: 'Banco Venezolano de Crédito', rif: 'J000029709', },
    { code: '0105', name: 'Banco Mercantil', rif: 'J000029610', },
    { code: '0108', name: 'BBVA Provincial', rif: 'J000029679', },
    { code: '0114', name: 'Bancaribe', rif: 'J000029490', },
    { code: '0115', name: 'Banco Exterior', rif: 'J000029504', },
    { code: '0116', name: 'B.O.D.', rif: 'J300619460', },
    { code: '0128', name: 'Banco Caroní', rif: 'J095048551', },
    { code: '0134', name: 'Banesco', rif: 'J070133805', },
    { code: '0137', name: 'Banco Sofitasa', rif: 'J090283846', },
    { code: '0138', name: 'Banco Plaza', rif: 'J002970553', },
    { code: '0146', name: 'Bangente', rif: 'J301442040', },
    { code: '0151', name: 'BFC Banco Fondo Común', rif: 'J000723060', },
    { code: '0156', name: '100% Banco', rif: 'J085007768', },
    { code: '0157', name: 'DELSUR Banco Universal', rif: 'J000797234', },
    { code: '0163', name: 'Banco Del Tesoro', rif: 'G200051876', },
    { code: '0166', name: 'Banco Agrícola de Venezuela', rif: 'G200057955', },
    { code: '0168', name: 'Bancrecer', rif: 'J316374173', },
    { code: '0169', name: 'Mi Banco', rif: 'J315941023', },
    { code: '0171', name: 'Banco Activo', rif: 'J080066227', },
    { code: '0172', name: 'Bancamiga', rif: 'J316287599', },
    { code: '0173', name: 'Banco Internacional de Desarrollo', rif: 'J294640109', },
    { code: '0174', name: 'Banplus', rif: 'J000423032', },
    { code: '0175', name: 'Banco Bicentenario del Pueblo', rif: 'G200091487', },
    { code: '0177', name: 'Banfanb', rif: 'G200106573', },
    { code: '0190', name: 'Citibank', rif: 'J000526621', },
    { code: '0191', name: 'Banco Nacional de Crédito (BNC)', rif: 'J309841327', },
    { code: '0601', name: 'Instituto Municipal de Crédito Popular', rif: 'G200068973', },
  ],
  bank: {
    transactionTypes: [
      //#region old code
      // { id: 'CH', description: 'Cheque', type: 'I', },
      // { id: 'DE', description: 'Depósito', type: 'I', },
      // { id: 'IN', description: 'Interéses', type: 'I', },
      // { id: 'NC', description: 'N. crédito', type: 'I', },
      // { id: 'ND', description: 'N. débito', type: 'E', },
      // { id: 'RC', description: 'Reverso crédito', type: 'E', },
      // { id: 'RD', description: 'Reverso débito', type: 'I', },
      // { id: 'TP', description: 'Trans. (+)', type: 'I', },
      // { id: 'TN', description: 'Trans. (-)', type: 'E', },
      // { id: 'IT', description: 'Imp. Trans. Financ.', type: 'E', },
      //#endregion old code
      { id: 'CH', description: { en: 'Check', es: 'Cheque', }, type: 'I', },
      { id: 'DE', description: { en: 'Deposit', es: 'Depósito', }, type: 'I', },
      { id: 'IN', description: { en: 'Interests', es: 'Interéses', }, type: 'I', },
      { id: 'NC', description: { en: 'C. note', es: 'N. crédito', }, type: 'I', },
      { id: 'ND', description: { en: 'D. note', es: 'N. débito' }, type: 'E', },
      { id: 'RC', description: { en: 'Reverse credit', es: 'Reverso crédito', }, type: 'E', },
      { id: 'RD', description: { en: 'Reverse debit', es: 'Reverso débito' }, type: 'I', },
      { id: 'TP', description: { en: 'Trans. (+)', es: 'Trans. (+)', }, type: 'I', },
      { id: 'TN', description: { en: 'Trans. (-)', es: 'Trans. (-)', }, type: 'E', },
      { id: 'IT', description: { en: 'Finan. Trans. tax', es: 'Imp. Trans. Financ.', }, type: 'E', },
    ],
  },
  bankAccount: {
    types: [
      {
        id: 'C',
        description: {
          en: 'Current',
          es: 'Corriente',
        },
      },
      {
        id: 'S',
        description: {
          en: 'Saving',
          es: 'Ahorro',
        },
      },
    ],
  },
  collections: {
    apartments: 'apartments',
    apartmentPeoples: 'apartmentPeoples',
    apartmentReceipts: 'apartmentReceipts',
    apartmentReceiptDetails: 'apartmentReceiptDetails',
    apartmentReceiptPayments: 'apartmentReceiptPayments',
    apartmentReceiptPaymentFiles: 'apartmentReceiptPaymentFiles',
    apartmentUsers: 'apartmentUsers',
    banks: 'banks',
    bankAccounts: 'bankAccounts',
    bankAccountMovements: 'bankAccountMovements',
    buildings: 'buildings',
    coins: 'coins',
    coinRates: 'coinRates',
    collectionCashes: 'collectionCashes',
    collectionCashMovements: 'collectionCashMovements',
    condominiumBoardElections: 'condominiumBoardElections',
    condominiumBoardElectionDetails: 'condominiumBoardElectionDetails',
    countries: 'countries',
    expenseConcepts: 'expenseConcepts',
    expenseTemplates: 'expenseTemplates',
    expenseConceptVariations: 'expenseConceptVariations',
    paymentMethods: 'paymentMethods',
    peopleTypes: 'peopleTypes',
    properties: {
      alphaCode2: 'alphaCode2',
      alphaCode3: 'alphaCode3',
      amount: 'amount',
      apartmentId: 'apartmentId',
      apartmentReceiptId: 'apartmentReceiptId',
      apartmentReceiptDetailId: 'apartmentReceiptDetailId',
      apartmentReceiptPaymentId: 'apartmentReceiptPaymentId',
      apartmentUserId: 'apartmentUserId',
      balance: 'balance',
      bankAccountId: 'bankAccountId',
      bankId: 'bankId',
      bankOriginId: 'bankOriginId',
      buildingId: 'buildingId',
      code: 'code',
      codeA: 'codeA',
      codeN: 'codeN',
      coinId: 'coinId',
      collectionCashId: 'collectionCashId',
      concilationDate: 'concilationDate',
      conciliationOnly: 'conciliationOnly',
      conciliationRemark: 'conciliationRemark',
      concilationStatus: 'concilationStatus',
      conciliationUserId: 'conciliationUserId',
      commonAreas: 'commonAreas',
      condominiumBoardElectionId: 'condominiumBoardElectionId',
      condominiumBoardRoleId: 'condominiumBoardRoleId',
      confirmNewPassword: 'confirmNewPassword',
      contractId: 'contractId',
      contracts: 'contracts',
      countryId: 'countryId',
      created: 'created',
      currentBalance: 'currentBalance',
      currentBalanceCash: 'currentBalanceCash',
      currentPassword: 'currentPassword',
      dataGet: 'dataGet',
      date: 'date',
      dateEnd: 'dateEnd',
      dateStart: 'dateStart',
      delete: 'delete',
      description: 'description',
      descriptionTwo: 'descriptionTwo',
      detail: 'detail',
      details: 'details',
      detailsBeforeEdited: 'detailsBeforeEdited',
      email: 'email',
      edit: 'edit',
      expenseConceptId: 'expenseConceptId',
      expenseTemplateId: 'expenseTemplateId',
      expDate: 'expDate',
      firebaseUserUpdate: 'firebaseUserUpdate',
      firstName: 'firstName',
      floor: 'floor',
      hierarchy: 'hierarchy',
      id: 'id',
      identifier: 'identifier',
      inactive: 'inactive',
      initialBalance: 'initialBalance',
      initialBalanceCash: 'initialBalanceCash',
      invoiceControlNumber: 'invoiceControlNumber',
      invoiceNumber: 'invoiceNumber',
      isCash: 'isCash',
      isClose: 'isClose',
      isOpen: 'isOpen',
      lastName: 'lastName',
      method: 'method',
      newPassword: 'newPassword',
      number: 'number',
      numeric: 'numeric',
      photoURL: 'photoURL',
      paymentMethodId: 'paymentMethodId',
      percentage: 'percentage',
      phoneNumber: 'phoneNumber',
      price: 'price',
      purchaseId: 'purchaseId',
      purchasePaymentId: 'purchasePaymentId',
      quantity: 'quantity',
      rate: 'rate',
      receiptId: 'receiptId',
      receiptNumberApartment: 'receiptNumberApartment',
      reference: 'reference',
      remark: 'remark',
      rif: 'rif',
      roleId: 'roleId',
      settings: 'settings',
      showBanks: 'showBanks',
      status: 'status',
      supplierId: 'supplierId',
      taxId: 'taxId',
      taxPercentage: 'taxPercentage',
      title: 'title',
      total: 'total',
      type: 'type',
      updatePartial: 'updatePartial',
      userElectionId: 'userElectionId',
      userFullName: 'userFullName',
      userId: 'userId',
      votesPercentage: 'votesPercentage',
      withId: 'withId',
    },
    purchases: 'purchases',
    purchaseDetails: 'purchaseDetails',
    purchasePayments: 'purchasePayments',
    receipts: 'receipts',
    roles: 'roles',
    showBanks: 'showBanks',
    suppliers: 'suppliers',
    taxes: 'taxes',
    users: 'users',
  },
  colors: {
    dangerColorExp: '#DC3545',
    infoColorExp: '#18A2B8',
    primaryColorExp: '#007BFF',
    secondaryColorExp: '#747474',
    successColorExp: '#53a451',
    warningColorExp: '#f7c244',
  },
  coins: [
    { codeA: 'USS', codeN: '998', description: 'US Dollar', },
    { codeA: 'VEF', codeN: '937', description: 'Venezuelan Bolívar', },
  ],
  contracts: {
    length: 12,
  },
  countries: [
    { alphaCode2: 'US', alphaCode3: 'USA', description: 'United States of America', numeric: '840', },
    { alphaCode2: 'VE', alphaCode3: 'VEN', description: 'Venezuela', numeric: '862', },
  ],
  documentNumberLength: {
    invoice: 12,
    quantity: 8,
    percentage: 6,
    price: 15,
    purchase: 12,
  },
  files: {
    png: {
      type: 'image/png',
      extension: 'png',
    },
    jpeg: {
      type: 'image/jpeg',
      extension: 'jpeg',
    },
    jpg: {
      type: 'image/jpg',
      extension: 'jpg',
    },
    bmp: {
      type: 'image/bmp',
      extension: 'bmp',
    },
    word: {
      type: 'application/msword',
      extension: 'doc',
    },
    wordX: {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      extension: 'docx',
    },
    excel: {
      type: 'application/vnd.ms-excel',
      extension: 'xls',
    },
    excelX: {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      extension: 'xlsx',
    },
    powerPoint: {
      type: 'application/vnd.ms-powerpoint',
      extension: 'ppt',
    },
    powerPointX: {
      type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      extension: 'pptx',
    },
  },
  gifs: {
    normal: {
      loading: '/images/loading/loading.gif',
      circle: '/images/loading/circle.gif',
      circle2: '/images/loading/circle2.gif',
    },
    svg: {
      spinner: '/images/loading/spinner.svg',
      spinnerWhite: '/images/loading/spinner-white.svg',
      typing: '/images/loading/typing.svg',
    },
  },
  html: {
    controls: {
      main: {
        menu: {
          profile: {
            img: {
              id: 'mainMenuProfile'
            },
          },
        },
      },
    },
    dataTables: {
      formats: {
        bordered: 'table table-bordered',
        striped: 'table table-striped',
        small: 'table table-sm',
        smBordered: 'table table-sm table-bordered',
        smStriped: 'table table-sm table-striped',
        smStripedBordered: 'table table-sm table-striped table-bordered',
        stripedBordered: 'table table-striped table-bordered',
        tableResponsiveSm: 'table-responsive-sm',
        smBorderedDisplay: 'table table-sm table-bordered display',
      },
    },
    space: {
      formatOne: '&nbsp;',
      formatTwo: '&nbsp;&nbsp;',
      formatThree: '&nbsp;&nbsp;&nbsp;',
      formatFour: '&nbsp;&nbsp;&nbsp;&nbsp;',
      formatFive: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatSix: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatSevent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatEight: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatNine: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatTen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatEleven: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatTwelve: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatThirteen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatFourTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatFiftTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatSixTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatSevenTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
    },
  },
  icons: {
    fasFa: {
      ad: 'fas fa-ad',
      arrowsAltH: 'fas fa-arrows-alt-h',
      arrowsAltV: 'fas fa-arrows-alt-v',
      barCode: 'fas fa-barcode',
      cashRegister: 'fas fa-cash-register',
      cogs: 'fas fa-cogs',
      copyright: 'fas fa-copyright',
      expandArrowsAlt: 'fas fa-expand-arrows-alt',
      lok: 'fas fa-lock',
      lockOpen: 'fas fa-lock-open',
      sortAmountUpAlt: 'fas fa-sort-amount-up-alt',
      tag: 'fas fa-tag',
      tags: 'fas fa-tags',
      weight: 'fas fa-weight',
    },
    angleLeftRight: 'right fas fa-angle-left',
    arrowAltCircleLeft: 'fas fa-arrow-alt-circle-left',
    arrowCircleLeft: 'fas fa-arrow-alt-circle-left',
    arrowCircleRight: 'fas fa-arrow-circle-right',
    arrowCircleUp: 'fas fa-arrow-alt-circle-up',
    award: 'fas fa-award',
    bed: 'fas fa-bed',
    building: 'fas fa-building',
    buildingFa: 'fa fa-building',
    bullhorn: 'fas fa-bullhorn',
    calendarAltFas: 'fas fa-calendar-alt',
    calendarAlt: 'fa fa-calendar-alt',
    car: 'fas fa-car',
    caretDown: 'fas fa-caret-down',
    caretLeft: 'fas fa-caret-left',
    caretRight: 'fas fa-caret-right',
    caretUp: 'fas fa-caret-up',
    certificate: 'fas fa-certificate',
    circleNavIcon: 'far fa-circle nav-icon',
    chartBar: 'fas fa-chart-bar',
    chartColumn: 'fas fa-chart-column',
    chartLine: 'fas fa-chart-line',
    chevronUp: 'fas fa-chevron-up',
    check: 'fa fa-check',
    checkCircle: 'fas fa-check-circle',
    checkSquare: 'fas fa-check-square',
    clock: 'fas fa-clock',
    coins: 'fas fa-coins',
    collectionCash: 'fas fa-cash-register',
    copyFarFa: 'far fa-copy',
    creditCardFas: 'fas fa-credit-card',
    dollarSign: 'fas fa-dollar-sign',
    edit: 'fas fa-edit',
    ellipsisV: 'fas fa-ellipsis-v',
    envelope: 'fas fa-envelope',
    envelopeOpenText: 'fas fa-envelope-open-text',
    eraser: 'fas fa-eraser',
    earthAmericas: 'fas fa-earth-americas',
    eyeIpasswordIpassword: 'far fa-eye ipassword ipassword',
    eyeSlashIpasswordIpassword: 'far fa-eye-slash ipassword ipassword',
    fax: 'fas fa-fax',
    fileContract: 'fas fa-file-contract',
    fileAltFar: 'far fa-file-alt',
    fileAltFas: 'fas fa-file-alt',
    fileFar: 'far fa-file',
    fileFas: 'fas fa-file',
    //fileLines: 'fa fa-file-lines',
    //fileTextFa: 'fas fa-file-text',
    //fileTextFas: 'fas fa-file-text',
    fileInvoice: 'fas fa-file-invoice',
    folderOpen: 'fas fa-folder-open',
    glassCheers: 'fas fa-glass-cheers',
    handHoldingUsd: 'fas fa-hand-holding-usd',
    home: 'fas fa-home',
    houseUser: 'fas fa-house-user',
    icons: 'fas fa-icons',
    idBadge: 'fas fa-id-badge',
    idCard: 'fas fa-id-card',
    invoiceDollar: 'fas fa-file-invoice-dollar',
    key: 'fas fa-key',
    layerGroup: 'fas fa-layer-group',
    levelUp: 'fas fa-level-up-alt',
    list: 'fas fa-list',
    listAlt: 'fas fa-list-alt',
    listOl: 'fas fa-list-ol',
    listTh: 'fas fa-th-list',
    //lock: 'fas fa-lock',
    //lockOpen: 'fas fa-lock-open',
    mapMarker: 'fas fa-map-marker-alt',
    minus: 'fas fa-minus',
    mobileAlt: 'fas fa-mobile-alt',
    moneyBill: 'fa fa-money-bill',
    //moneyBillWave: 'fa fa-money-bill-wave',
    moneyBillWave: 'fas fa-money-bill-wave',
    notEqual: 'fas fa-not-equal',
    paperClip: 'fas fa-paperclip',
    paperPlane: 'fas fa-paper-plane',
    percentage: 'fas fa-percentage',
    piggyBank: 'fas fa-piggy-bank',
    powerOff: 'fas fa-power-off',
    plusCircle: 'fas fa-plus-circle',
    print: 'fas fa-print',
    receipt: 'fas fa-receipt',
    //tag: 'fas fa-tag',
    //tags: 'fas fa-tags',
    textHeight: 'fas fa-text-height',
    trash: 'fas fa-trash-alt',
    toggleOn: 'fas fa-toggle-on',
    save: 'fas fa-save',
    search: 'fas fa-search',
    sign: 'fas fa-sign',
    sortNumericDown: 'fas fa-sort-numeric-down',
    sortNumericUpAlt: 'fas fa-sort-numeric-up-alt',
    spellCheck: 'fas fa-spell-check',
    square: 'fa fa-square',
    stickyNote: 'far fa-sticky-note',
    stream: 'fas fa-stream',
    sync: 'fas fa-sync',
    usd: 'fa fa-dollar-sign',
    undo: 'fas fa-undo',
    university: 'fas fa-university',
    user: 'fas fa-user',
    userCheck: 'fas fa-user-check',
    users: 'fas fa-users',
    usersSlash: 'fas fa-users-slash',
    userEdit: 'fas fa-user-edit',
    userClock: 'fas fa-user-clock',
    userLock: 'fas fa-user-lock',
    userTag: 'fas fa-user-tag',
    voteYea: 'fas fa-vote-yea',
    warningTrinagle: 'fas fa-exclamation-triangle',
  },
  images: {
    aliquotPercentage: '/images/aliquotPercentage.png',
    americanExpressLogo: '/images/americanexpress.png',
    apartmentsLogo: '/images/apartments.png',
    applicant: '/images/applicant.png',
    applicants: '/images/applicants.png',
    appLogo: '/images/appLogo.png',
    ballotBox: '/images/ballotBox.png',
    bankAccountLogo: '/images/bankAccount.png',
    banksLogo: '/images/banks.png',
    bankTransferLogo: '/images/bankTransfer.png',
    buildingContract: '/images/buildingContract.png',
    buildingLogo: '/images/building.png',
    buildings001: '/images/93491522393929597.png',
    buildingsLogo: '/images/buildings.png',
    campaign: '/images/images/campaign.png',
    coinsLogo: '/images/coins.png',
    collectionCashLogo: '/images/collectionCashIcon.png',
    condominiumBoardElections: '/images/elections.png',
    //condominiumBoardRoles: '/images/condominiumBoardRoles.png',
    condominiumBoardRoles: '/images/roles.png',
    countriesLogo: '/images/countries.png',
    documentLogo: '/images/docs.png',
    elevatorsLogo: '/images/elevators.png',
    expenseConceptsLogo: '/images/expenseConcepts.png',
    expenseTemplateLogo: '/images/expenseTemplate.png',
    expenseTemplatesLogo: '/images/expenseTemplates.png',
    familyLogo: '/images/family.png',
    graphBarLogo: 'images/barGraph.png',
    groceryList: '/images/groceryList.png',
    handRailsLogo: '/images/handrails.png',
    informativeBillboard: '/images/billboard.png',
    inventoriesLogo: '/images/inventories.png',
    keyHouse: '/images/keyHouse.png',
    masterCardLogo: '/images/mastercard.png',
    movementsLogo: '/images/movements.png',
    noImageLogo: '/images/noImage.png',
    partyFlags: '/images/partyFlags.png',
    paymentMethodsLogo: '/images/paymentMethods.png',
    payPalLogo: '/images/paypal.png',
    passwordIcon: '/images/passwordIcon.png',
    peopleTypesLogo: '/images/peopleTypes.png',
    paymentsLogo: '/images/payments.png',
    purchasesLogo: '/images/purchases.png',
    invoiceLogo: '/images/invoice.png',
    receiptLogo: '/images/receipt.png',
    receiptsLogo: '/images/receipts.png',
    reconcilePaymentsLogo: '/images/reconcilePayments.png',
    reserved: '/images/reserved.png',
    rolesLogo: '/images/roles.png',
    shoppingCart: '/images/shoppingCart.png',
    settings: '/images/settings.png',
    suppliersLogo: '/images/supplier.png',
    taxesLogo: '/images/taxes.png',
    urlImages: '/images/images',
    urlImagesTwo: '/images/images/',
    userLogo: '/images/user.png',
    usersLogo: '/images/users.png',
    userLogin: '/images/userLogin.png',
    visaLogo: '/images/visa.png',
    zelleLogo: '/images/zelle.png',
  },
  labels: {
    about: {
      en: 'About',
      es: 'Acerca de',
    },
    account: {
      en: 'Account',
      es: 'Cuenta',
    },
    accounts: {
      en: 'Accounts',
      es: 'Cuentas',
    },
    accountReceivable: {
      en: 'Account receivable',
      es: 'Cuenta por cobrar'
    },
    accountsReceivable: {
      en: 'Accounts receivable',
      es: 'Cuentas por cobrar'
    },
    accountPayable: {
      en: 'Account payable',
      es: 'Cuenta por pagar'
    },
    accountsPayable: {
      en: 'Accounts payable',
      es: 'Cuentas por pagar'
    },
    accessAccount: {
      en: 'Access account',
      es: 'Acceder a la cuenta',
    },
    active: {
      en: 'Active',
      es: 'Activa',
    },
    accountInformation: {
      en: 'Account information',
      es: 'Información de la cuenta',
    },
    add: {
      en: 'Add',
      es: 'Agregar',
    },
    addDetail: 'Agregar detalle',
    addPayment: 'Agregar pago',
    address: {
      en: 'Address',
      es: 'Dirección',
    },
    advertising: {
      en: 'Advertising',
      es: 'Publicidad',
    },
    all: {
      en: 'All',
      es: 'Todos',
    },
    aliquot: {
      en: 'aliqout',
      es: 'Alícuota',
    },
    aliquotEraser: {
      en: 'Aliquot eraser',
      es: 'Borrar alícuota',
    },
    aliquotErasers: {
      en: 'Aliquot erasers',
      es: 'Borrar alícuotas',
    },
    aliquots: {
      en: 'aliqouts',
      es: 'Alícuotas',
    },
    aliquotPercentage: {
      en: 'Aliquot percentage',
      es: 'Porcentage alícuota',
    },
    aliquotPercentages: {
      en: 'Aliquot percentages',
      es: 'Porcentage alícuotas',
    },
    alphaCode2: 'Alpha code 2',
    alphaCode3: 'Alpha code 3',
    amount: {
      en: 'Amount',
      es: 'Monto',
    },
    apartment: {
      en: 'Apartment',
      es: 'Apartamento',
    },
    apartmentDebt: {
      en: 'Apartment debt',
      es: 'Deuda por apartamento',
    },
    apartments: {
      en: 'Apartments',
      es: 'Apartamentos',
    },
    apartmentPeople: {
      es: 'Persona del apartamento',
      en: 'Apartment people',
    },
    apartmentPeoples: {
      es: 'Personas del apartamento',
      en: 'Apartment peoples',
    },
    apartmentTenant: {
      es: 'Inquilino del apartamento',
      en: 'apartment tenant',
    },
    apartmentTenants: {
      es: 'Inquilinos del apartamento',
      en: 'Apartment tenants',
    },
    apartmentsPerFloor: {
      en: 'Apartments (per floor)',
      es: 'Apartamentos (por piso)'
    },
    apartmentsPerLowLevel: {
      en: 'Apartments (per low level)',
      es: 'Apartamentos (planta baja)'
    },
    apartmentsPerTopLevel: {
      en: 'Apartments (top level)',
      es: 'Apartamentos (planta alta)'
    },
    apartmentReceiptDetails: 'Detalles del recibo del apartamento',
    apartmentReceiptPayments: 'Pagos de recibo de apartamento',
    applicant: {
      en: 'Applicant',
      es: 'Postulante',
    },
    applicants: {
      en: 'Applicants',
      es: 'Postulantes',
    },
    approvalDone: {
      en: 'Approval done',
      es: 'Aprobación realizada',
    },
    approved: {
      en: 'Approved',
      es: 'Aprobada',
    },
    area: {
      en: 'Area',
      es: 'Área',
    },
    assignedAliquot: {
      en: 'Assigned aliquot',
      es: 'Alícota asignada',
    },
    assignedAliquots: {
      en: 'Assigned aliquots',
      es: 'Alícota asignadas',
    },
    assignedRole: {
      en: 'Assigned role',
      es: 'Role asignado',
    },
    attachments: {
      en: 'Attachments',
      es: 'Documentos adjuntos',
    },
    attemptsAllowed: {
      en: 'Attempts allowed',
      es: 'Intentos permitidos',
    },
    authorized: {
      en: 'Authorized',
      es: 'Autorizado',
    },
    authorizeUser: {
      en: 'Authorize user',
      es: 'Autorizar usuario',
    },
    back: {
      en: 'Back',
      es: 'Volver',
    },
    balance: {
      en: 'Balance',
      es: 'Saldo',
    },
    bank: {
      en: 'Bank',
      es: 'Banco',
    },
    bankAccount: {
      en: 'Bank account',
      es: 'Cuenta bancaria',
    },
    bankAccounts: {
      en: 'Bank accounts',
      es: 'Cuentas bancarias',
    },
    bankAccountMovement: {
      en: 'Bank account (movement)',
      es: 'Cuenta bancaria (movimiento)',
    },
    bankAccountMovements: {
      en: 'Bank account movements',
      es: 'Movimientos de cuenta bancaria',
    },
    banks: {
      en: 'Banks',
      es: 'Bancos',
    },
    barbeque: {
      en: 'Barbeque',
      es: 'Barbacoa',
    },
    bats: {
      en: 'Bats',
      es: 'Murciélagos',
    },
    batsNotAccent: {
      en: 'Bats',
      es: 'Murcielagos',
    },
    base: {
      en: 'Base',
      es: 'Base',
    },
    beagle: {
      en: 'Beagle',
      es: 'Beagle',
    },
    blue: {
      en: 'Blue',
      es: 'Azul',
    },
    brand: {
      en: 'Brand',
      es: 'Marca',
    },
    breastCancer: {
      en: 'Breast cancer',
      es: 'Cáncer de mama',
    },
    breastCancerNotAccent: {
      en: 'Breast cancer',
      es: 'Cancer de mama',
    },
    both: {
      en: 'Both',
      es: 'Ambos',
    },
    building: {
      en: 'Building',
      es: 'Edificio',
    },
    buildings: {
      en: 'Building',
      es: 'Edificios',
    },
    buildingDebt: {
      en: 'Building debt',
      es: 'Deuda por edificio',
    },
    campaign: {
      en: 'Campaign',
      es: 'Campaña',
    },
    candyCane: {
      en: 'Candy cane',
      es: 'Bastón de caramelo',
    },
    candyCaneNotAccent: {
      en: 'Candy cane',
      es: 'Baston de caramelo',
    },
    canceled: {
      en: 'Canceled',
      es: 'Anulado',
    },
    cancel: {
      en: 'Cancel',
      es: 'Cancelar',
    },
    car: {
      en: 'Car',
      es: 'Carro',
    },
    carKey: {
      en: 'Car key',
      es: 'Llave de carro',
    },
    cash: {
      en: 'Cash',
      es: 'Efectivo'
    },
    cashRegisterMovement: {
      en: 'register cash movement',
      es: 'Movimiento de caja',
    },
    cashRegisterMovements: {
      en: 'register cash movements',
      es: 'Movimientos de caja',
    },
    cashRegister: {
      en: 'Cash register',
      es: 'Caja',
    },
    cashRegisters: {
      en: 'Cash registers',
      es: 'Cajas',
    },
    cat: {
      en: 'Cat',
      es: 'Gato',
    },
    cement: {
      en: 'Cement',
      es: 'Cemento',
    },
    code: {
      en: 'Code',
      es: 'Código',
    },
    codeA: {
      en: 'Code A',
      es: 'Código A',
    },
    codeN: {
      en: 'Code N',
      es: 'Código N',
    },
    comment: {
      en: 'Comment',
      es: 'Comentario',
    },
    complain: {
      en: 'Complain',
      es: 'Quejarse',
    },
    control: {
      en: 'Control',
      es: 'Control',
    },
    confirmNewPassword: {
      en: 'Confirm new password',
      es: 'Confirmar nueva contraseña',
    },
    controlNumber: {
      en: 'Control number',
      es: 'Número control',
    },
    consultSupport: {
      en: 'Consult support',
      es: 'Consulta soporte',
    },
    changePassword: {
      en: 'Change password',
      es: 'Cambiar contraseña',
    },
    characters: {
      en: 'Characters',
      es: 'Caracteres',
    },
    checkRegistrationStatus: {
      en: 'Verify registration status',
      es: 'Verificar estado de registro',
    },
    christmasTree: {
      en: 'Christmas tree',
      es: 'Árbol de navidad',
    },
    christmasTreeNotAccent: {
      en: 'Christmas tree',
      es: 'Arbol de navidad',
    },
    city: {
      en: 'City',
      es: 'Ciudad',
    },
    condition: {
      en: 'Condition',
      es: 'Condición',
    },
    confirmEmail: {
      en: 'Confirm email',
      es: 'Confirmar email',
    },
    coin: {
      en: 'Coin',
      es: 'Moneda',
    },
    coins: {
      es: 'Monedas',
      en: 'Coins',
    },
    clickToChangePicture: {
      en: 'Click to change picture',
      es: 'Haga clic para cambiar la imagen ',
    },
    close: {
      en: 'Close',
      es: 'Cerrar',
    },
    closed: {
      en: 'Closed',
      es: 'Cerrado',
    },
    collection: {
      en: 'Collection',
      es: 'Cobranza',
    },
    collectionCash: {
      en: 'Collection cash',
      es: 'Caja',
    },
    collectionCashes: {
      en: 'Collection cashes',
      es: 'Cajas',
    },
    commonArea: {
      en: 'Common area',
      es: 'Área común',
    },
    commonAreas: {
      en: 'Common areas',
      es: 'Áreas comunes',
    },
    concept: {
      en: 'Concept',
      es: 'Concepto',
    },
    concepts: {
      en: 'Concepts',
      es: 'Conceptos'
    },
    conciled: {
      en: 'Conciled',
      es: 'Conciliado',
    },
    condominiumBoard: {
      en: 'Condominium board',
      es: 'Junta condominio',
    },
    condominiumBoardElections: {
      en: 'Condominium board elections',
      es: 'Elecciones junta condominio',
    },
    cone: {
      en: 'Cone',
      es: 'Cono',
    },
    confirmationDone: {
      en: 'Confirmation done',
      es: 'Confirmación hecha',
    },
    confirmPassword: {
      en: 'Password confirm',
      es: 'Confirmar contraseña',
    },
    confirmedEmail: {
      en: 'Confirmed email',
      es: 'Email confirmado',
    },
    contact: {
      en: 'Contact',
      es: 'Contacto'
    },
    contract: {
      en: 'Contract',
      es: 'Contrato',
    },
    contracts: {
      en: 'Contracts',
      es: 'Contratos',
    },
    copy: {
      en: 'Copy',
      //es: 'Copiar',
      es: 'Copia',
    },
    copyright: {
      en: 'Copyright',
      es: 'Derechos de autor',
    },
    correct: {
      en: 'Correct',
      es: 'Corregir',
    },
    cost: {
      en: 'Cost',
      es: 'Costo',
    },
    country: {
      en: 'Country',
      es: 'País',
    },
    countries: {
      es: 'Paises',
      en: 'Countries',
    },
    create: {
      en: 'Create',
      es: 'Crear'
    },
    created: {
      en: 'Created',
      es: 'Creada'
    },
    current: {
      en: 'Current',
      es: 'Corriente',
    },
    createContract: 'Crear contrato',
    currentBalance: {
      en: 'Current balance',
      es: 'Saldo actual',
    },
    currentPassword: {
      en: 'Current password',
      es: 'Contraseña actual',
    },
    dark: {
      en: 'Dark',
      es: 'Oscuro',
    },
    date: {
      en: 'Date',
      es: 'Fecha',
    },
    day: {
      en: 'Day',
      es: 'Día',
    },
    debt: {
      en: 'Debt',
      es: 'Deuda',
    },
    debtApartments: {
      en: 'Debt apartments',
      es: 'Deuda apartamentos',
    },
    delete: {
      en: 'Delete',
      es: 'Eliminar'
    },
    deleted: {
      en: 'Deleted',
      es: 'Eliminado',
    },
    deleteAccount: {
      en: 'Delete account',
      es: 'Eliminar cuenta',
    },
    description: {
      en: 'Description',
      es: 'Descripción'
    },
    destiny: {
      en: 'Destiny',
      es: 'Destino',
    },
    detail: {
      en: 'Detail',
      es: 'Detalle',
    },
    details: {
      en: 'Details',
      es: 'Detalles',
    },
    disabled: {
      en: 'Disabled',
      es: 'Deshabilitado',
    },
    distributeCostsByPercentage: {
      en: 'Distribute costs by percentage',
      es: 'Distribuir costos por porcentaje',
    },
    distributeCostsByAliquotPercentage: {
      en: 'Distribute costs by aliquot percentage',
      es: 'Distribuir costos por porcentaje de alícuota',
    },
    disableAccount: {
      en: 'Disable account',
      es: 'Deshabilitar cuenta',
    },
    document: {
      en: 'Document',
      es: 'Documento',
    },
    documents: {
      en: 'Documents',
      es: 'Documentos',
    },
    dog: {
      en: 'Dog',
      es: 'Perro',
    },
    duplicate: 'Duplicar',
    easterBunny: {
      en: 'Easter bunny',
      es: 'Conejo de pascua',
    },
    edit: {
      en: 'Edit',
      es: 'Editar'
    },
    editPayment: 'Editar pago',
    egress: {
      en: 'Egress',
      es: 'Egreso',
    },
    egresses: {
      en: 'Egresses',
      es: 'Egresos',
    },
    election: {
      en: 'Election',
      es: 'Elección',
    },
    elections: {
      en: 'Elections',
      es: 'Elecciónes',
    },
    elevator: {
      en: 'Elevator',
      es: 'Ascensor',
    },
    elevators: {
      en: 'Elevators',
      es: 'Ascensores'
    },
    email: {
      en: 'Email',
      es: 'Correo',
    },
    //enterRemark: 'Ingresa observación',
    enable: {
      en: 'Enable',
      es: 'Habilitar',
    },
    enableAccount: {
      en: 'Enable account',
      es: 'Habilitar cuenta',
    },
    end: {
      en: 'End',
      es: 'Fin',
    },
    endDate: {
      en: 'End date',
      es: 'Fecha fin',
    },
    enterRemark: {
      es: 'Ingrese un comentario',
      en: 'Enter a remark'
    },
    enterYourEmail: {
      en: 'Enter your email',
      es: 'Introduce tu correo electrónico',
    },
    enterYourEmailCheckStatus: {
      en: 'Enter your email address to check status',
      es: 'Ingrese su correo electrónico para verificar el estado',
    },
    equal: 'Igual',
    eraser: {
      en: 'Eraser',
      es: 'Borrar',
    },
    even: {
      en: 'Even',
      es: 'Par'
    },
    exemptAmount: {
      en: 'Exempt amount',
      es: 'Monto exento',
    },
    expenses: {
      es: 'Gastos',
      en: 'Expenses',
    },
    expenseConcept: {
      en: 'Expense concept',
      es: 'Concepto de gasto',
    },
    expenseConcepts: {
      en: 'Expense concepts',
      es: 'Conceptos de gastos',
    },
    expenseTemplate: {
      en: 'Expense template',
      es: 'Plantilla de gasto'
    },
    expenseTemplates: {
      en: 'Expense templates',
      es: 'Plantillas de gastos'
    },
    faceMask: {
      en: 'Face mask',
      es: 'Mascarilla',
    },
    failedAllowed: {
      en: 'Failed allowed',
      es: 'Fallidos permitidos',
    },
    failedAttemptsAllowed: {
      en: 'Failed attempts allowed',
      es: 'Intentos fallidos permitidos',
    },
    fastDelivery: {
      en: 'Fast delivery',
      es: 'Entrega rápida',
    },
    fastDeliveryNotAccent: {
      en: 'Fast delivery',
      es: 'Entrega rapida',
    },
    fertilizer: {
      en: 'Fertilizer',
      es: 'Fertilizante',
    },
    file: {
      en: 'File',
      es: 'Archivo',
    },
    files: {
      en: 'Files',
      es: 'Archivos',
    },
    filter: 'Filtro',
    filters: {
      en: 'Filters',
      es: 'Filtros',
    },
    finalResults: {
      en: 'Final results',
      es: 'Resultados finales',
    },
    findExpenseTemplate: 'Buscar plantilla de gasto',
    firstName: {
      en: 'First name',
      es: 'Nombres',
    },
    fishBowl: {
      en: 'Fish bowl',
      es: 'Pecera',
    },
    fixed: {
      en: 'Fixed',
      es: 'Fijos',
    },
    floor: {
      en: 'Floor',
      es: 'Piso',
    },
    floors: {
      en: 'Floors',
      es: 'Pisos'
    },
    folder: {
      en: 'Folder',
      es: 'Carpeta',
    },
    folders: {
      en: 'Folders',
      es: 'Carpetas',
    },
    foreign: 'Extranjera',
    forgotYourPassword: {
      en: 'Forgot your password?',
      es: '¿Olvidaste tu contraseña?'
    },
    from: {
      en: 'From',
      es: 'Desde',
    },
    fullVotes: {
      en: 'Full votes',
      es: 'Votos completos',
    },
    gallon: {
      en: 'Gallon',
      es: 'Galón',
    },
    gallonNotAccent: {
      en: 'Gallon',
      es: 'Galon',
    },
    generate: {
      en: 'Generate',
      es: 'Generar',
    },
    generated: {
      en: 'Generated',
      es: 'Generados',
    },
    generateReceipts: {
      en: 'Generate receipts',
      es: 'Generar recibos',
    },
    gray: {
      en: 'Gray',
      es: 'Gris',
    },
    green: {
      en: 'Green',
      es: 'Verde',
    },
    receiptGenerateds: {
      en: 'Receipt generateds',
      es: 'Recibos generados',
    },
    happyBirthday: {
      en: 'Happy birthday',
      es: 'Feliz cumpleaños',
    },
    happyNewYear: {
      en: 'Happy  new year',
      es: 'Feliz año nuevo',
    },
    height: {
      en: 'Height',
      es: 'Alto',
    },
    higher: 'Mayor',
    hello: {
      en: 'Hello',
      es: 'Hola',
    },
    hide: {
      en: 'Hide',
      es: 'Ocultar',
    },
    hideApplicants: {
      en: 'Hide applicants ',
      es: 'Ocultar postulantes',
    },
    hierarchy: {
      en: 'Hierarchy',
      es: 'Jerarquía',
    },
    home: {
      en: 'Home',
      es: 'Inicio'
    },
    identifier: {
      en: 'Identifier',
      es: 'Identificador',
    },
    icon: {
      en: 'Icon',
      es: 'Icono',
    },
    inactive: {
      en: 'Inactive',
      es: 'Inactiva',
    },
    index: {
      en: 'Index',
      es: 'Indice',
    },
    income: {
      en: 'Income',
      es: 'Ingreso',
    },
    incomes: {
      en: 'Incomes',
      es: 'Ingresos',
    },
    informativeBillboard: {
      en: 'Informative billboard',
      es: 'Cartelera informativa',
    },
    initialBalance: {
      en: 'Initial Balance',
      es: 'Saldo inicial',
    },
    information: {
      en: 'Information',
      es: 'Información'
    },
    invalidVotes: {
      en: 'Invalid votes',
      es: 'Votos nulos',
    },
    inventory: {
      en: 'Inventory',
      es: 'Inventario'
    },
    invoiceNumber: {
      e: 'Invoice number',
      es: 'Número factura',
    },
    isCash: {
      en: 'Is Cash',
      es: 'Es efectivo',
    },
    isNational: {
      en: 'is nactional',
      es: 'Es nacional',
    },
    international: 'Internacional',
    invoice: {
      en: 'Invoice',
      es: 'Factura'
    },
    invoices: 'Facturas',
    lastCreated: {
      en: 'Last created',
      es: 'Últimos creados'
    },
    lastLogin: {
      en: 'Last login',
      es: 'Último inicio de sesión',
    },
    lastName: {
      en: 'Last name',
      es: 'Apellidos',
    },
    lastSent: {
      en: 'Last sent',
      es: 'Último enviado',
    },
    legend: {
      en: 'Legend',
      es: 'Leyenda',
    },
    lift: {
      en: 'Lift',
      es: 'Ascensor',
    },
    lightBlue: {
      en: 'Light blue',
      es: 'Celeste',
    },
    list: {
      en: 'List',
      es: 'Lista',
    },
    listening: {
      en: 'Listening',
      es: 'Escuchando',
    },
    loading: {
      en: 'Loading',
      es: 'Cargando',
    },
    login: {
      es: 'Iniciar',
      en: 'Login',
    },
    logOff: {
      es: 'Desconectarse',
      en: 'Log off',
    },
    lockDisabled: {
      en: 'Lock disabled',
      es: 'Bloqueo deshabilitado',
    },
    long: {
      en: 'Long',
      es: 'Largo',
    },
    lowLevel: {
      en: 'Low level',
      es: 'Planta baja'
    },
    key: {
      en: 'key',
      es: 'Llave'
    },
    keys: {
      en: 'keys',
      es: 'Llaves'
    },
    manufactured: {
      en: 'Manufactured',
      es: 'Fabricado',
    },
    matches: {
      en: 'Matches',
      es: 'Partidos',
    },
    maxAttemptsToLock: {
      en: 'Max attempts to lock',
      es: 'Intentos máximo para bloqueo',
    },
    maxWeight: {
      en: 'Max weight',
      es: 'Peso máximo',
    },
    megaphone: {
      en: 'Megaphone',
      es: 'Megáfono',
    },
    megaphoneNotAccent: {
      en: 'Megaphone',
      es: 'Megafono',
    },
    message: {
      en: 'Message',
      es: 'Mensaje',
    },
    method: 'Método',
    model: {
      en: 'Model',
      es: 'Modelo',
    },
    modify: {
      en: 'Modify',
      es: 'Modificar',
    },
    month: {
      en: 'Month',
      es: 'Mes',
    },
    moreInfo: {
      en: 'More info',
      es: 'Más información',
    },
    movement: {
      en: 'Movement',
      es: 'Movimiento',
    },
    movements: {
      en: 'Movements',
      es: 'Movimientos',
    },
    myApartments: {
      en: 'My apartments',
      es: 'Mis apartamentos',
    },
    myBuildings: {
      en: 'My buildings',
      es: 'Mis edificios',
    },
    name: {
      en: 'Name',
      es: 'Nombre',
    },
    national: 'Nacional',
    neto: {
      en: 'Neto',
      es: 'Neto',
    },
    newPassword: {
      en: 'New password',
      es: 'Nueva contraseña',
    },
    no: {
      en: 'No',
      es: 'No',
    },
    noConnection: {
      en: 'No connection',
      es: 'Sin conexión',
    },
    noConnectionNotAccent: {
      en: 'No connection',
      es: 'Sin conexion',
    },
    noNational: 'No nacional',
    noPets: {
      en: 'No pets',
      es: 'Sin mascotas',
    },
    numeric: 'Número',
    number: {
      en: 'Number',
      es: 'Número',
    },
    new: {
      en: 'New',
      es: 'Nuevo',
    },
    news: {
      en: 'News',
      es: 'Noticias',
    },
    newTemplate: {
      en: 'New template',
      es: 'Plantilla nueva',
    },
    nit: {
      en: 'N.I.T.',
      es: 'N.I.T.',
    },
    notes: {
      en: 'Notes',
      es: 'Notes',
    },
    notApproved: {
      en: 'Not approved',
      es: 'No aprobada',
    },
    notFound: {
      en: 'Not found',
      es: 'Página no encontrada',
    },
    notProcessed: {
      es: 'Sin procesar',
      en: 'Not processed',
    },
    occupant: {
      en: 'Occupant',
      es: 'Ocupante',
    },
    occupants: {
      en: 'Occupants',
      es: 'Ocupantes'
    },
    odd: {
      en: 'Odd',
      es: 'Impar'
    },
    of: 'de',
    onlineShop: {
      en: 'Online shop',
      es: 'Tienda online',
    },
    open: {
      en: 'Open',
      es: 'Abrir',
    },
    opened: {
      en: 'Open',
      es: 'Abierto',
    },
    origin: {
      en: 'Origin',
      es: 'Origen',
    },
    other: {
      en: 'Other',
      es: 'Otra',
    },
    others: {
      en: 'Others',
      es: 'Otros',
    },
    owner: {
      en: 'Owner',
      es: 'Propietario',
    },
    paidOut: {
      en: 'Paidout',
      es: 'Pagado',
    },
    palette: {
      en: 'Palette',
      es: 'Paleta',
    },
    parking: 'Estacionamiento',
    parkingStalls: {
      en: 'Parking stalls',
      es: 'Puestos de estacionamiento',
    },
    partiallyProcessed: {
      en: 'Partially processed',
      es: 'Parcialmente procesado',
    },
    partialVotes: {
      en: 'Partial votes',
      es: 'Votos parciales',
    },
    password: {
      en: 'Password',
      es: 'Contraseña',
    },
    patient: {
      en: 'Patient',
      es: 'Paciente',
    },
    paused: {
      en: 'Paused',
      es: 'Pausado',
    },
    payment: {
      en: 'Payment',
      es: 'Pago',
    },
    paymentDetails: {
      en: 'Payment details',
      es: 'Detalles pago',
    },
    payments: {
      en: 'Payments',
      es: 'Pagos',
    },
    paymentMethod: {
      en: 'Payment method',
      es: 'Método de pago',
    },
    paymentMethods: {
      en: 'Payment methods',
      es: 'Métodos de pago',
    },
    paymentSupports: {
      en: 'Payment supports',
      es: 'Soportes de pago',
    },
    paymentSupportsAbbreviation: {
      en: 'Pay. supports',
      es: 'Sop. de pago',
    },
    pending: {
      en: 'pending',
      es: 'Pendiente',
    },
    peopleType: {
      en: 'People type',
      es: 'Tipo de persona',
    },
    peopleTypes: {
      es: 'Tipos de persona',
      en: 'People types',
    },
    percentage: {
      en: 'Percentage',
      es: 'Porcentaje',
    },
    periodBalance: {
      en: 'Period balance',
      es: 'Saldo período',
    },
    personalInformation: {
      en: 'Personal information',
      es: 'Información personal',
    },
    pet: {
      en: 'Pet',
      es: 'Mascota',
    },
    phone: {
      en: 'Phone',
      es: 'Teléfono',
    },
    pig: {
      en: 'Pig',
      es: 'Cerdo',
    },
    pin: {
      en: 'Pin',
      es: 'Alfiler',
    },
    pine: {
      en: 'Pine',
      es: 'Pino',
    },
    phoneNumber: {
      en: 'Phone number',
      es: 'Número de teléfono',
    },
    popcorn: {
      en: 'Popcorn',
      es: 'Palomitas',
    },
    previous: {
      en: 'Previous',
      es: 'Anterior',
    },
    previousBalance: {
      en: 'Previous balance',
      es: 'Saldo anterior',
    },
    previousResults: {
      en: 'Previous results',
      es: 'Resultados previos',
    },
    print: {
      en: 'Print',
      es: 'Imprimir',
    },
    privacyAndConditions: {
      en: 'Privacy and conditions',
      es: 'Privacidad y condiciones',
    },
    promo: {
      en: 'Promo',
      es: 'Promoción',
    },
    promoNotAccente: {
      en: 'Promo',
      es: 'Promocion',
    },
    protectedByReCAPTCHA: {
      en: 'Protected by reCAPTCHA',
      es: 'Protegido por reCAPTCHA',
    },
    postulant: {
      en: 'Postulant',
      es: 'Postulante',
    },
    price: {
      en: 'Price',
      es: 'Precio',
    },
    printReceipt: 'Imprimir recibo',
    privacy: {
      en: 'Privacy',
      es: 'Privacidad'
    },
    process: {
      en: 'Process',
      es: 'Procesos'
    },
    processed: {
      en: 'Processed',
      es: 'Procesada'
    },
    processesCompletedSuccessfully: {
      en: 'Processes completed successfully',
      es: 'Procesos completados con éxito',
    },
    profile: {
      en: 'Profile',
      es: 'Perfil',
    },
    publication: {
      en: 'Publication',
      es: 'Publicación',
    },
    pumpkin: {
      en: 'Pumpkin',
      es: 'Calabaza',
    },
    purchasePayments: 'Pagos de compra',
    purchase: {
      en: 'Purchase',
      es: 'Compra',
    },
    purchases: {
      en: 'Purchases',
      es: 'Compras',
    },
    quantity: {
      en: 'Quantity',
      es: 'Cantidad',
    },
    question: {
      en: 'Question',
      es: 'Pregunta',
    },
    questions: {
      en: 'Questions',
      es: 'Preguntas',
    },
    rate: {
      en: 'Rate',
      es: 'Tasa',
    },
    rates: {
      en: 'Rates',
      es: 'Tasas',
    },
    reason: {
      en: 'Reason',
      es: 'Motivo',
    },
    receipt: {
      en: 'Receipt',
      es: 'Recibo',
    },
    receiptDetail: {
      en: 'Receipt detail',
      es: 'Detalle recibo',
    },
    receiptDetails: {
      en: 'Receipt details',
      es: 'Detalle recibos',
    },
    receipts: {
      en: 'Receipts',
      es: 'Recibos',
    },
    reconcile: {
      en: 'Reconcile',
      es: 'Conciliar',
    },
    reconcilied: {
      en: 'Reconcilied',
      es: 'Conciliado',
    },
    reconciliationInformation: 'Información conciliación',
    reconcilePayments: {
      en: 'Reconcile payments',
      es: 'Conciliar pagos',
    },
    red: {
      en: 'Red',
      es: 'Rojo',
    },
    reference: {
      en: 'Reference',
      es: 'Referencia',
    },
    registry: {
      en: 'Registry',
      es: 'Registro',
    },
    registrationDone: 'Registro hecho',
    remark: {
      en: 'Remark',
      es: 'Observación',
    },
    remainingAliquot: {
      en: 'Remaining aliquot',
      es: 'Alícuota restante',
    },
    rememberMe: {
      en: 'Remember me',
      es: 'Recuérdame'
    },
    registerNewMembership: {
      en: 'Register a new membership',
      es: 'Registrar una nueva membresía',
    },
    registerPayment: {
      en: 'Resgister payment',
      es: 'Registrar pago'
    },
    reserve: {
      en: 'Reserve',
      es: 'Reserva',
    },
    reserves: {
      en: 'Reserves',
      es: 'Reservas',
    },
    reserveCommonArea: {
      en: 'Reserve common area',
      es: 'Reserva área común',
    },
    reserveCommonAreas: {
      en: 'Reserve common areas',
      es: 'Reserva áreas comunes',
    },
    restore: {
      en: 'Restore',
      es: 'Restaurar',
    },
    restoreAccount: {
      en: 'Restore account',
      es: 'Restaurar cuenta',
    },
    restorePassword: {
      en: 'Restore password',
      es: 'Restablecer contraseña',
    },
    restoreRegistry: {
      en: 'Restore registry',
      es: 'Restaurar registro',
    },
    resume: {
      en: 'Resume',
      es: 'Resumen',
    },
    results: {
      en: 'Results',
      es: 'Resultados',
    },
    rif: {
      en: 'R.I.F.',
      es: 'R.I.F.',
    },
    role: {
      en: 'Role',
      es: 'Rol',
    },
    roles: {
      en: 'Roles',
      es: 'Roles',
    },
    roleAssignmentDone: {
      en: 'Role assignment performed',
      es: 'Asignación de rol realizada',
    },
    santa: {
      en: 'Santa',
      es: 'Santa claus',
    },
    save: {
      en: 'Save',
      es: 'Guardar',
    },
    savings: {
      en: 'Savings',
      es: 'Ahorro',
    },
    see: {
      en: 'See',
      es: 'Ver',
    },
    seeApplicants: {
      en: 'See applicants',
      es: 'Ver postulantes',
    },
    seeBillboard: {
      en: 'See billboard',
      es: 'Ver cartelera',
    },
    seesaw: {
      en: 'Seesaw',
      es: 'Balancín',
    },
    seesawNotAccente: {
      en: 'Seesaw',
      es: 'Balancin',
    },
    select: {
      en: 'select',
      es: 'Selecccionar',
    },
    search: {
      en: 'Search',
      es: 'Buscar',
    },
    send: {
      en: 'Send',
      es: 'Enviar',
    },
    sendEmailConfirmation: {
      en: 'Send email confirmation',
      es: 'Enviar correo confirmación',
    },
    sendMessage: {
      en: 'Send message',
      es: 'Enviar mensaje',
    },
    session: 'Sesión',
    sessionUpCase: {
      es: 'SESIÓN',
      en: 'SESSION',
    },
    selectBank: {
      en: 'Select a bank',
      es: 'Selecciona un banco',
    },
    selectBuilding: {
      en: 'Select a building',
      es: 'Selecciona un edificio',
    },
    selectCoinBase: {
      en: 'Select coin base',
      es: 'Seleccione moneda base',
    },
    selectCoinOther: {
      en: 'Select coin other',
      es: 'Seleccione otra moneda',
    },
    selectCountry: {
      en: 'Select a country',
      es: 'Seleccione un país'
    },
    selectMethod: 'Seleccione método',
    selectPaymentMethod: {
      en: 'Select payment method',
      es: 'Seleccione método de pago',
    },
    selectRole: 'Seleccione un rol',
    selectSupplier: {
      en: 'Select a supplier',
      es: 'Selecciona un proveedor'
    },
    serial: {
      en: 'Serial',
      es: 'Serial',
    },
    setting: {
      es: 'Configuración',
      en: 'Setting',
    },
    settings: {
      es: 'Configuraciones',
      en: 'Settings',
    },
    show: {
      en: 'Show',
      es: 'Mostrar',
    },
    showBanks: {
      en: 'Show banks',
      es: 'Mostrar bancos',
    },
    signInToStartYourSession: {
      en: 'Sign in to start your session',
      es: 'Regístrese para iniciar su sesión',
    },
    silent: {
      en: 'Silent',
      es: 'Silencioso',
    },
    size: {
      en: 'Size',
      es: 'Tamaño'
    },
    skull: {
      en: 'Skull',
      es: 'Cráneo',
    },
    skullNotAccente: {
      en: 'Skull',
      es: 'Craneo',
    },
    smartLight: {
      en: 'Smart light',
      es: 'Luz inteligente',
    },
    soreThroat: {
      en: 'Sore throat',
      es: 'Dolor de garganta',
    },
    soup: {
      en: 'Soup',
      es: 'Sopa',
    },
    spotlight: {
      en: 'Spotlight',
      es: 'Iluminar',
    },
    status: {
      en: 'Status',
      es: 'Estado',
    },
    stairs: {
      en: 'Stairs',
      es: 'Escaleras',
    },
    start: {
      en: 'Start',
      es: 'Inicio',
    },
    startDate: {
      en: 'Start date',
      es: 'Fecha inicio',
    },
    streetLight: {
      en: 'Street light',
      es: 'Luz de la calle',
    },
    streetLights: {
      en: 'Street lights',
      es: 'Luces de la calle',
    },
    subject: {
      en: 'Subject',
      es: 'Asunto',
    },
    subMethod: 'Sub método',
    subTotal: {
      en: 'Subtotal',
      es: 'Subtotal',
    },
    success: {
      en: 'Success',
      es: 'Éxito',
    },
    supplier: {
      en: 'Supplier',
      es: 'Proveedor',
    },
    supplierBalance: {
      en: 'Supplier balance',
      es: 'Saldo de proveedor',
    },
    suppliers: {
      en: 'Suppliers',
      es: 'Proveedores'
    },
    support: {
      en: 'Support',
      es: 'Soporte',
    },
    supports: {
      en: 'Supports',
      es: 'Soportes',
    },
    supportDepartment: {
      en: 'Support department',
      es: 'Departamento de soporte',
    },
    swimmingPool: {
      en: 'Swimming pool',
      es: 'Piscina',
    },
    systemAdministratorMustApproveAccount: {
      en: 'A system administrator must be approve your account',
      es: 'Un administrador del sistema debe aprobar su cuenta',
    },
    systemAdministratorAssignedRole: {
      en: 'The system administrator assigned your role',
      es: 'El administrador del sistema le asignó su rol',
    },
    systemAdministratorMustAssignYouRole: {
      en: 'A system administrator must assign a role',
      es: 'Un administrador del sistema debe asignarle un rol',
    },
    table: {
      en: 'Table',
      es: 'Tabla',
    },
    tax: {
      en: 'Tax',
      es: 'Impuesto',
    },
    taxBase: {
      en: 'Tax base',
      es: 'Base imponible',
    },
    taxAbbreviated: {
      en: 'Tax.',
      es: 'Imp.',
    },
    taxes: {
      en: 'Taxes',
      es: 'Impuestos',
    },
    tenant: {
      en: 'Tenant',
      es: 'Inquilino',
    },
    tenants: 'Inquilinos',
    template: {
      en: 'Template',
      es: 'Plantilla',
    },
    templates: {
      en: 'Templates',
      es: 'Plantillas',
    },
    templateTotal: 'Total plantilla',
    theatre: {
      en: 'Theatre',
      es: 'Teatro',
    },
    title: {
      en: 'Title',
      es: 'Título',
    },
    titles: 'Títulos',
    time: {
      en: 'Time',
      es: 'Hora',
    },
    theSystemAdministratorApprovedAccount: {
      en: 'The system administrator approved your account',
      es: 'El administrador del sistema aprobó su cuenta',
    },
    theUserHasAlreadyMadeRegistration: 'El usuario ya se ha registrado',
    to: {
      en: 'To',
      es: 'Hasta',
    },
    toAttach: {
      en: 'To attach',
      es: 'Adjuntar'
    },
    toChoose: {
      en: 'To choose',
      es: 'Elegir',
    },
    today: {
      en: 'Today',
      es: 'Hoy',
    },
    total: {
      en: 'Total',
      es: 'Total',
    },
    topLevel: {
      en: 'Top level',
      es: 'Planta alta'
    },
    toPrint: {
      en: 'To print',
      es: 'Imprimir',
    },
    totalApartments: {
      en: 'Total apartments',
      es: 'Total apartamentos'
    },
    totalExpenseTemplate: {
      en: 'Total expense template',
      es: 'Total plantilla de gasto',
    },
    totalPayments: {
      en: 'Total payments',
      es: 'Total pagos',
    },
    totalVotes: {
      en: 'Total votes',
      es: 'Votos totales',
    },
    trashBin: {
      en: 'Trash bin',
      es: 'Contenedor de basura',
    },
    trash: {
      en: 'Trash',
      es: 'Basura',
    },
    trolley: {
      en: 'Trolley',
      es: 'Carretilla',
    },
    trophy: {
      en: 'Trophy',
      es: 'Trofeo',
    },
    type: {
      en: 'Type',
      es: 'Tipo',
    },
    unreconciled: {
      en: 'Un reconciled',
      es: 'Sin conciliar',
    },
    undefined: {
      en: 'Undefined',
      es: 'Sin definir',
    },
    user: {
      en: 'User',
      es: 'Usuario',
    },
    users: {
      es: 'Usuarios',
      en: 'Users',
    },
    value: {
      en: 'Value',
      es: 'Valor'
    },
    variation: {
      en: 'Variation',
      es: 'Variación',
    },
    variable: {
      en: 'Variable',
      es: 'Variables',
    },
    variations: {
      en: 'Variations',
      es: 'Variaciones',
    },
    verifyAccount: {
      en: 'Verify account',
      es: 'Verificar cuenta',
    },
    verifyEmail: {
      en: 'Verify email',
      es: 'Verificar email',
    },
    version: {
      en: 'Version',
      es: 'Version',
    },
    viewBanks: {
      en: 'View banks',
      es: 'Ver bancos',
    },
    viewCollectionCashes: {
      en: 'View collection cashes',
      es: 'Ver cajas',
    },
    viewDocuments: {
      en: 'View documents',
      es: 'Ver documentos',
    },
    viewInformation: {
      en: 'View information',
      es: 'Ver información',
    },
    viewPayment: 'Ver pago',
    viewReceipts: {
      en: 'View receipts',
      es: 'Ver recibos',
    },
    warning: {
      en: 'Warning',
      es: 'Alerta'
    },
    waitingApproval: {
      en: 'Waiting approval',
      es: 'A la espera de la aprobación',
    },
    waitingAssignRole: {
      en: 'Waiting for role assignment',
      es: 'Esperando para asignar rol',
    },
    waitingConfirmation: {
      en: 'Waiting confirmation',
      es: 'Esperando confirmación',
    },
    waitingPreviousProcesses: {
      en: 'Waiting previous processes',
      es: 'Esperando procesos anteriores',
    },
    weHaveSentCopyToYourEmail: {
      en: 'We have sent a copy to your email',
      es: 'Hemos enviado una copia a tu correo',
    },
    waterTap: {
      en: 'Water tap',
      es: 'Grifo de agua',
    },
    week: {
      en: 'Week',
      es: 'Semana',
    },
    welcome: {
      en: 'Welcome',
      es: 'Bienvenido'
    },
    welcomeTwo: {
      en: 'Welcome',
      es: 'Bienvenid@',
    },
    welcomeEmail: {
      en: 'Welcome email',
      es: 'Correo bienvenida',
    },
    welcomeMessage: {
      en: 'Welcome message',
      es: 'Mensaje de bienvenida',
    },
    width: {
      en: 'Width',
      es: 'Ancho',
    },
    view: {
      en: 'View',
      es: 'Ver'
    },
    viewPurchase: {
      en: 'View purchase',
      es: 'Ver compra',
    },
    viewPurchases: {
      en: 'View purchases',
      es: 'Ver compras',
    },
    wireless: {
      en: 'Wireless',
      es: 'Inalámbrico',
    },
    wirelessNotAccent: {
      en: 'Wireless',
      es: 'Inalambrico',
    },
    vote: {
      en: 'Vote',
      es: 'Votar',
    },
    votes: {
      en: 'Votes',
      es: 'Votos',
    },
    voteTwo: {
      en: 'Vote',
      es: 'Voto',
    },
    year: {
      en: 'Year',
      es: 'Año'
    },
    yellow: {
      en: 'Yellow',
      es: 'Amarillo',
    },
    yes: {
      en: 'Yes',
      es: 'Si'
    },
    youCanNowLogIntoOurSystemWithCredentials: {
      en: 'You can now login to our system with your credentials',
      es: 'Ahora puede iniciar sesión en nuestro sistema con sus credenciales',
    },
    youMustFinishAboveProcessesAccessSystem: {
      en: 'You must complete the above processes to access the system',
      es: 'Debes finalizar los procesos anteriores para acceder al sistema',
    },
    yoursSincerely: {
      en: 'Yours sincerely',
      es: 'Le saluda atentamente',
    },
    zipCode: {
      en: 'Zip code',
      es: 'Código postal',
    },
  },
  languages: {
    en: {
      code: 'en',
      id: 'en',
      format: {
        date: {
          f1: 'm/d/y',
          f2: 'm-d-y',
          f3: 'mm/dd/yy',
          f4: 'mm-dd-yy',
          f5: 'mm/dd/yyyy',
          f6: 'mm-dd-yyyy',
          f7: 'M/D/Y',
          f8: 'M-D-Y',
          f9: 'MM/DD/YY',
          f10: 'MM-DD-YY',
          f11: 'MM/DD/YYYY',
          f12: 'MM-DD-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'HH:mm',
            hhmmss: 'HH:mm:ss',
          },
          type: 24,
        },
      },
      numbers: {
        separators: {
          decimals: '.',
          thousands: ',',
        },
      },
      recaptchat: {
        languageCode: 'en-GB',
      },
    },
    enUS: {
      code: 'en-US',
      id: 'en',
      format: {
        date: {
          f1: 'm/d/y',
          f2: 'm-d-y',
          f3: 'mm/dd/yy',
          f4: 'mm-dd-yy',
          f5: 'mm/dd/yyyy',
          f6: 'mm-dd-yyyy',
          f7: 'M/D/Y',
          f8: 'M-D-Y',
          f9: 'MM/DD/YY',
          f10: 'MM-DD-YY',
          f11: 'MM/DD/YYYY',
          f12: 'MM-DD-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'HH:mm',
            hhmmss: 'HH:mm:ss',
          },
          type: 24,
        },
      },
      numbers: {
        separators: {
          decimals: '.',
          thousands: ',',
        },
      },
      recaptchat: {
        languageCode: 'en',
      },
    },
    es: {
      code: 'es',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
      recaptchat: {
        languageCode: 'es',
      },
    },
    esES: {
      code: 'es-ES',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
      recaptchat: {
        languageCode: 'es',
      },
    },
    esAR: {
      code: 'es-AR',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
      recaptchat: {
        languageCode: 'es-419',
      },
    },
    esCL: {
      code: 'es-CL',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
      recaptchat: {
        languageCode: 'es-419',
      },
    },
    esCO: {
      code: 'es-CO',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
      recaptchat: {
        languageCode: 'es-419',
      },
    },
    esMX: {
      code: 'es-MX',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
      recaptchat: {
        languageCode: 'es-419',
      },
    },
    esUS: {
      code: 'es-US',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
      recaptchat: {
        languageCode: 'es',
      },
    },
    esVE: {
      code: 'es-VE',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
    es419: {
      code: 'es-419',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
      recaptchat: {
        languageCode: 'es-419',
      },
    },
  },
  localStorage: {
    //userId: 'user',
    userId: 'userCondominioSever',
  },
  messages: {
    allAssignedAliquotsWillBeDeleted: {
      en: 'All assigned aliquots will be deleted',
      es: 'Se van a borrar todas las alícuotas asignadas',
    },
    allAssignedContractsHaveExpired: {
      en: 'All assigned contracts have expired',
      es: 'Todos los contratos asignados están vencidos',
    },
    allowedCharacters: {
      en: 'Allowed characters',
      es: 'Caracteres permitidos',
    },
    allRightsReserved: {
      en: 'All rights reserved',
      es: 'Reservados todos los derechos',
    },
    AnExactCopyWillBeGenerated: {
      en: 'An exact copy will be generated',
      es: 'Se va a generar una copia exacta',
    },
    AreYouSureAboutThis: {
      en: 'Are you sure about this?',
      es: '¿Estás seguro de esto?',
    },
    areYouSureDeleteThis: {
      en: 'Are you sure delete this?',
      es: '¿Estás seguro de eliminar esto?'
    },
    areYouSureToLogOut: {
      en: 'Are you sure to logout?',
      es: '¿Estás seguro de cerrar sesión?',
    },
    areYouSureYouWantToCloseThisDocument: {
      en: 'Are you sure you want to close this document?',
      es: '¿Estas seguro que desea cerrar este documento?',
    },
    cannotBeLocated: {
      en: 'Cannot be located',
      es: 'No puede ser localizado',
    },
    cannotChangeToCreatedStatus: {
      en: 'Cannot change to created status',
      es: 'No puede cambiar a estatus creada',
    },
    closeReceiptMessages: {
      en: 'If you close this document <b>you will not be able to modify</b> the receipts for apartments, however <b>you can open</b> this document again and edit the receipts',
      es: 'Si cierra este documento <b>no podra modificar</b> los recibos por apartamentos, sin embargo <b>puede abrir</b> nuevamente este documento y editar los recibos',
    },
    charactersRemaining: {
      en: 'Characters remaining',
      es: 'Caracteres restantes',
    },
    contactTheSupportDepartment: {
      en: 'Contact the support department',
      es: 'Contactar con el departamento de soporte',
    },
    contactMessage001: {
      en: 'We have successfully received your message, we will contact you shortly by replying to your email',
      es: 'Hemos recibido satisfactoriamente tu mensaje, pronto nos pondremos en contacto contigo respondiendo a tu correo',
    },
    contactMessage002: {
      en: 'We detail below the information sent by you',
      es: 'Detallamos a continuación la información enviada por ti',
    },
    dateToMustBeGreaterThanDateFrom: {
      en: 'Date <b>to</b> must be greater than date <b>from</b>',
      es: 'Fecha <b>hasta</b> debe ser mayor a fecha <b>desde</b>',
    },
    deleteGeneratedReceiptsAndRegenerateThem: {
      en: 'Delete generated receipts and regenerate them',
      es: 'Elimine los recibos generados y vuelva a generarlos',
    },
    deletingAssignedAliquots: {
      en: 'Deleting assigned aliquots',
      es: 'Borrando alicuotas asignadas',
    },
    didNotSelectAnyApplicant: {
      en: 'Did not select any applicant',
      es: 'No eligió ningún postulante',
    },
    documentDeletedSuccessFully: {
      en: 'Document deleted successfully',
      es: 'Documento elimado satisfactoriamente',
    },
    doYouWantAuthorizeTheUser: {
      en: 'Do you want authorize the user?',
      es: '¿Desea autorizar al usuario?',
    },
    doYouWantConfirmTheEmail: {
      en: 'Do you want confirm the email?',
      es: '¿Desea confirmar el correo electrónico?'
    },
    doYouWantToInitializeTheVote: {
      en: 'Do you want to initialize the vote?',
      es: '¿Desea inicializar el voto?',
    },
    doYouWantToRestoreDeletedRegistry: {
      en: 'Do you want to restore deleted registry?',
      es: '¿Desea restaurar el registro eliminado?',
    },
    doYouWantToRestoreTheRecordViewTheAddedCommentOrCancel: {
      en: 'Do you want to restore the record, view the added comment or cancel?',
      es: '¿Desea restaurar el registro, ver el comentario agregado o cancelar?',
    },
    doYouWantToEnableTheAccountSeeTheAddedCommentOrCancel: {
      en: 'Do you want to enable the account, see the added comment or cancel?',
      es: '¿Desea habilitar la cuenta, ver el comentario agregado o cancelar?',
    },
    doYouWantRemoveTheConfirmationFromEmail: {
      en: 'Do you want remove the confirmation from email?',
      es: '¿Desea eliminar la confirmación del correo electrónico?',
    },
    doYouWantRemoveTheUserAuthorization: {
      en: 'Do you want remove the user authorization?',
      es: '¿Desea eliminar la autorización de usuario?',
    },
    doYouWantRestoreTheRegistry: {
      es: '¿Desea restaurar el registro?',
      en: 'Do you want restore the registry?',
    },
    doYouWantSendTheConfirmationEmail: {
      en: 'Do you want to send the confirmation email?',
      es: '¿Desea enviar el correo electrónico de confirmación?',
    },
    doYouWantToEnableTheAccount: {
      en: 'Do you want to enable the account?',
      es: '¿Desea habilitar la cuenta?',
    },
    doYouWantToDisableTheAccount: {
      en: 'Do you want to disable the account?',
      es: '¿Desea deshabilitar la cuenta?',
    },
    doYouWantToSendTheWelcomeEmail: {
      en: 'Do you want to send the welcome email?',
      es: '¿Quiere enviar el correo de bienvenida?',
    },
    doYouWishContinue: {
      en: 'Do you wish continue?',
      es: '¿Desea continuar?',
    },
    errorWhileSavingDataRevertingProcess: 'Error al guardar datos, revirtiendo proceso',
    executed: {
      en: 'Executed',
      es: 'Ejecutado',
    },
    executedVote: {
      en: 'Executed vote',
      es: 'Voto ejecutado',
    },
    expiredToken: {
      en: 'Expired token',
      es: 'Token expirado',
    },
    fileDeletedSuccessFully: {
      en: 'File deleted successfully',
      es: 'Archivo eliminado satisfactoriamente',
    },
    forgotPasswordSubTitle01: {
      en: 'You must enter your <b>email address</b> to send the password recovery instructions',
      es: 'Debe ingresar su <b>correo electrónico</b> para enviar las instrucciones de recuperación de contraseña',
    },
    forgotPasswordSubTitle02: {
      en: 'The e-mail address must be previously <b>registered in our system</b>, otherwise no information will be sent',
      es: 'El correo electrónico debe estar previamente <b>registrado en nuestro sistema</b>, de lo contrario no se enviará información',
    },
    forwardThisEmailAgainImmediatelyToTheFollowingAddress: {
      en: 'Forward this email again immediately to the following address',
      es: 'Reenvía este correo electrónico de nuevo inmediatamente a la siguiente dirección',
    },
    gettingApartments: 'Obteniendo apartamentos, favor espere...',
    generatingReceipt: 'Generando recibo',
    giveFeedback: {
      en: 'Give feedback',
      es: 'Dar opinion',
    },
    goTo: {
      en: 'Go to',
      es: 'Ir a',
    },
    howDoYouWantToViewTheInformation: {
      en: 'How do you want to view the information?',
      es: '¿Cómo desea ver la información?',
    },
    ifForAnyReasonThisEmailWasSentIncorrectly: {
      en: 'If for any reason this email was sent incorrectly',
      es: 'Si por alguna razón este correo electrónico se envió de manera incorrecta',
    },
    ifTheStatusIsClosed: {
      en: 'If thye status is closed',
      es: 'Si el estatus es cerrado',
    },
    incompleteVote: {
      en: 'Incomplete vote',
      es: 'Voto incompleto',
    },
    insufficientFunds: {
      en: 'Insufficient funds',
      es: 'Fondos insuficientes',
    },
    invalidContract: {
      en: 'Invalid contract',
      es: 'Contrato inválido',
    },
    invalidVote: {
      en: 'Invalid vote',
      es: 'Voto nulo',
    },
    inTheInvoiceDetils: {
      en: 'In the invoice detail',
      es: 'En el detalle de la factura',
    },
    inThePurchaseDetils: {
      en: 'In the purchase detail',
      es: 'En el detalle de la compra',
    },
    itRelatedOtherTables: {
      en: 'It related other tables',
      es: 'Está relacionado con otras tablas',
    },
    itIsRequired: {
      en: 'It is required',
      es: 'Es requerido',
    },
    itIsRecommendedSendConfirmationEmailAfter24HoursFromTheLastSent: {
      en: 'It is recommended to send a confirmation email after 24 hours from the last sent',
      es: 'Se recomienda enviar un correo de confirmación pasado 24 horas del ultimo enviado',
    },
    itWasNotYouWhoRequestedThePasswordChange: {
      en: 'It was not you who requested the password change',
      es: 'No fue usted quien solicitó el cambio de contraseña',
    },
    lastReceiptGenerated: {
      en: 'Last receipt generated',
      es: 'Último recibo generado',
    },
    letUsKnowWhatYouThinkOfOurLatestUpdates: {
      en: 'Let us know what you think of our latest updates',
      es: 'Háganos saber lo que piensa de nuestras últimas actualizaciones',
    },
    maximunWeightAllowed: {
      en: 'Maximum weight allowed',
      es: 'Peso máximo permitido',
    },
    mustBeGreaterThan: {
      en: 'Must be greater than',
      es: 'Debe ser mayor a',
    },
    mustBeGreaterThanOrEqualTo: {
      en: 'Must be greater then or equal to',
      es: 'Debe ser mayor o igual a',
    },
    mustBeEnabled: {
      en: 'Must be <b>enabled</b>',
      es: 'Debe estar <b>habilitado(a)</b>',
    },
    newPasswordAndNewPasswordConfirmNotMatch: {
      en: 'The <b>new password</b> and <b>new password confirm</b> fields do not match',
      es: 'La <b>nueva contraseña</b> y <b>la confirmación de la nueva contraseña</b> no coinciden',
    },
    noMethodSelected: {
      en: 'No method selected',
      es: 'Ningún método seleccionado',
    },
    notAllPaymentsHaveBeenReconciledYet: {
      en: 'Not all payments have been reconciled yet',
      es: 'Aún no se han conciliado todos los pagos'
    },
    noFundsAvailable: {
      en: 'No funds available',
      es: 'No hay fondos disponible'
    },
    NotExecuted: {
      en: 'Not executed',
      es: 'No ejecutado',
    },
    notRegisteredUsersYet: {
      en: 'Not registered users yet',
      es: 'No hay usuarios registrados aún'
    },
    numberAllowed: {
      en: 'Number allowed',
      es: 'Cantidad permitida',
    },
    objectStructureError: {
      en: 'Object structure error',
      es: 'Error estructura de objeto',
    },
    onceClosedYouWillNotBeAbleToOpenOrEditIt: {
      en: 'Once closed you will not be able to open or edit it',
      es: 'Una vez cerrado no podra abrirlo ni editarlo',
    },
    onlyMaximumNumberOfFilesIsAllowed: {
      en: 'Only a maximum number of files is allowed',
      es: 'Sólo está permitido un máximo de archivos',
    },
    onlyMaximumNumberOfFilesPerDocumentIsAllowed: {
      en: 'Only a maximum number of files per document is allowed',
      es: 'Sólo está permitido un máximo de archivos por documento',
    },
    onlyDocumentsWithStatusCanBeModified: {
      en: 'Only documents with status can be modified',
      es: 'Sólo se pueden modificar documentos con estatus',
    },
    onlyTheFollowingFilesAreAllowed: {
      en: 'Only the following files are allowed',
      es: 'Soló se permiten los siguientes archivos',
    },
    onlyOneTypeTaxAndExemptIsAllowed: {
      en: 'Only one type tax and exempt is allowed',
      es: 'Sólo está permitido un tipo impuesto y exento',
    },
    onlyOneUserPerApartmentIsAllowed: {
      en: 'Only one user per apartment is allowed',
      es: 'Solo está permitido un usuario por apartamento',
    },
    onlyOwnersCanAddPaymentInformationToReceipts: {
      en: 'Only owners can add payment information to receipts',
      es: 'Sólo los propietarios pueden agregar información de pagos a los recibos',
    },
    openReceiptMessage: {
      en: 'If you open this document <b>you can modify the receipts</b> for apartments',
      es: 'Si abre este documento <b>podrá modificar los recibos</b> por apartamentos',
    },
    pageNotFound: 'Página no encontrada',
    passwordMinimunCharacters: {
      en: `Minimum <b>${globalSettingsPassword?.minLength}</b> characters`,
      es: `Mínimo <b>${globalSettingsPassword?.minLength}</b> caracteres`,
    },
    passwordAndPasswordConfirmNotMatch: {
      en: 'The <b>Password</b> and <b>Confirm Password</b> fields do not match',
      es: 'Los campos <b>Contraseña</b> y <b>Confirmar contraseña</b> no coinciden',
    },
    paymentAmountIsGreaterThatBalanceMessage: {
      en: 'The payment cannot be more than the <b>balance</b><br/>It must be <b>less than</b> or <b>equal to it</b>',
      es: 'El pago no puede ser mayor al <b>saldo</b><br/>Debe ser <b>menor</b> o <b>igual</b>',
    },
    pleaseAcceptTheCaptcha: {
      en: 'Please accept the captcha',
      es: 'Por favor acepta el captcha',
    },
    pleaseContactTheSupportDepartment: {
      en: 'Please contact the support department',
      es: 'Por favor contacte al departamento de soporte',
    },
    pleaseContactTheCondoBoard: {
      en: 'Please contact the condominium board',
      es: 'Por favor contacte a la junta de condominio',
    },
    pleaseTryAgain: {
      en: 'Please try again',
      es: 'Por favor vuelva a intentar',
    },
    pleaseEnterDifferentOne: {
      en: 'Please enter different one',
      es: 'Favor ingrese otro diferente'
    },
    processing: {
      //en: 'Processing, please wait...',
      //es: 'Procesando, favor espere...',
      en: 'Processing, please wait',
      es: 'Procesando, favor espere',
    },
    //processesCompletedSuccessfully: 'Proceso completado satisfactoriamente',
    processesCompletedSuccessfully: {
      en: 'Processes completed successfully',
      es: 'Proceso completado satisfactoriamente'
    },
    registerNewUserTittle01: {
      en: 'Perfect, you just need to verify your account',
      es: 'Perfecto, solo necesitas verificar tu cuenta',
    },
    registerNewUserMessages: ({ firstName = '', lastName = '', email = '', paragraph = 0, languageId = 'en', }) => {
      let msgText = ``;
      switch (paragraph) {
        case 1:
          switch (languageId) {
            case 'es':
              msgText = `Estimado <b>${firstName} ${lastName}</b>, por seguridad y para completar el proceso de registro debe ingresar a su cuenta de correo electrónico: `;
              msgText += `<b>${email}</b> y verifique su cuenta <b>(haciendo clic en el enlace que le enviamos)</b>, una vez que la cuenta esté verificada podrá `;
              msgText += `acceder a nuestro sistema. Si no puede ver el correo en la <b>Bandeja de entrada</b>, verifique el buzón de <b>Spam</b> o <b>Correo no deseado</b>. `;
              msgText += `Si no recibe el correo electrónico de confirmación, comuníquese con el `;
              msgText += `<a href='mailto:${globalSettings?.app?.emails?.dptoSupport}?subject=${globalSettings?.labels?.registry?.[languageId]}%20${globalSettings?.labels?.new?.[languageId]}%20${globalSettings?.labels?.user?.[languageId]}%20(${globalSettings?.labels?.message?.[languageId]})'><b>${globalSettings?.labels?.supportDepartment?.[languageId]}</b></a>`;
              return msgText;
            //break;
            default:
              msgText = `Dear <b>${firstName} ${lastName}</b>, for security and to complete the registration process you must enter your email account: `;
              msgText += `<b>${email}</b> and verify your account <b>(by clicking on the link we sent you)</b>, once the account is verified you will be able to `;
              msgText += `access our system. If you cannot see the mail in your <b>Inbox</b>, check your <b>Spam</b> or <b>Junk Mail</b> mailbox. `;
              msgText += `If you do not receive the confirmation email, please contact `;
              msgText += `<a href='mailto:${globalSettings?.app?.emails?.dptoSupport}?subject=${globalSettings?.labels?.registry?.[languageId]}%20${globalSettings?.labels?.new?.[languageId]}%20${globalSettings?.labels?.user?.[languageId]}%20(${globalSettings?.labels?.message?.[languageId]})'><b> ${globalSettings?.labels?.supportDepartment?.[languageId]}</b></a>`;
              return msgText;
            //break;
          }
        //break;
        default:
          return msgText;
        //break;
      }
    },
    restorePasswordMessage01: {
      en: 'To <b>reset</b> your account password, please click the button below and enter your new password',
      es: 'Para <b>restablecer</b> la contrasena de tu cuenta, por favor haz clic en el siguiente botón e ingresa tu nueva contraseña',
    },
    relatedThisReceipt: {
      en: 'Related to this receipt',
      es: 'Relacionados con este recibo',
    },
    selectApartment: {
      en: 'Select an apartment',
      es: 'Selecciona un apartamento',
    },
    selectApplicant: {
      en: 'Select an applicant',
      es: 'Selecciona un postulante',
    },
    selectBank: {
      en: 'Select a bank',
      es: 'Selecciona un banco',
    },
    selectBankAccount: {
      en: 'Select a bank account',
      es: 'Selecciona una cuenta bancaria',
    },
    selectCashRegister: {
      en: 'Select a cash register',
      es: 'Selecciona una caja',
    },
    selectCoin: {
      en: 'Select coin',
      es: 'Selecciona moneda',
    },
    selectCommonArea: {
      en: 'Select a common area',
      es: 'Selecciona un área común',
    },
    selectFloor: {
      en: 'Select floor',
      es: 'Seleccione piso',
    },
    selectIcon: {
      en: 'Select an icon',
      es: 'Selecciona un icono',
    },
    selectPeopleType: 'Seleccione tipo de persona',
    selectRole: {
      en: 'Select a role',
      es: 'Seleccione un rol',
    },
    selectStatus: {
      en: 'Select status',
      es: 'Selecciona estatus',
    },
    selectTax: {
      en: 'Select tax',
      es: 'Selecciona impuesto',
    },
    selectType: {
      en: 'Selct type',
      es: 'Selecciona tipo',
    },
    suspectedElectronicIdentityTheft: {
      en: 'Suspected electronic identity theft',
      es: 'Sospecha de robo de identidad electrónica',
    },
    //systemAdministratorMustApproveYourAccount: 'Un <b>administrador</b> del sistema debe aprobar su <b>cuenta</b>',
    systemAdministratorMustApproveYourAccount: {
      en: 'A <b>system administrator</b> must approve your <b>account</b>',
      es: 'Un <b>administrador</b> del sistema debe aprobar su <b>cuenta</b>',
    },
    systemAdministratorMustAssignYouRole: {
      en: 'A <b>system administrator</b> must assign you a <b>role</b>',
      es: 'Un <b>administrador</b> del sistema debe asignarle un <b>rol</b>',
    },
    theBuildingHasNoAssignedContracts: {
      en: 'The building has no assigned contracts',
      es: 'El edificio no tiene contratos asignados',
    },
    theEmailAlreadyByAnotherAccount: {
      en: 'The <b>email address</b> is already in use by another account',
      es: 'La <b>dirección de correo electrónico</b> está ya en uso por otra cuenta',
    },
    theFileCannotBeLocated: {
      en: 'The file cannot be located',
      es: 'El archivo no se puede localizar',
    },
    theNumberOfReceiptsGeneratedIsDifferentThanTheNumberOfApartmentsCreated: {
      en: 'The number of receipts generated is different than the number of apartments created.',
      es: 'La cantidad de recibos generados es diferente a la cantidad de apartamentos creados',
    },
    theseFieldsCanNotBeTheSame: {
      en: 'These fields can not be the same',
      es: 'Estos campos no pueden ser iguales',
    },
    thisEmailWasSentToYouFrom: {
      en: 'This email was sent to you from',
      es: 'Este correo electrónico le fue enviado desde',
    },
    thisInformationHasAlreadyBeenRecorded: {
      en: 'This information has already been recorded',
      es: 'Esta información ya fue registrada'
    },
    theInternalPurchaseNumberHasAlReadyBeenUsedAnotherDocument: 'El número de compra interno ya fue utilizado en otro documento',
    theInstructionsPasswordRecoveryWereSentEmail: {
      en: 'Instructions for <b>password recovery</b> have been sent to your email',
      es: 'Las instrucciones para la <b>recuperación de la contraseña</b> se enviaron a su correo electrónico',
    },
    thereIsNoDataShow: {
      en: 'There is no data show',
      es: 'No hay data que mostrar',
    },
    thereIsNoUserRecordCorrespondingToTheProvidedEmail: {
      en: 'There is no user record corresponding to the provided email',
      es: 'No existe registro de usuario correspondiente al correo electrónico facilitado',
    },
    thereIsNoUserRecordCorrespondingToTheProvidedIdentifier: {
      en: 'There is no user record corresponding to the provided identifier',
      es: 'No hay un registro de usuario correspondiente al identificador proporcionado',
    },
    theOnlyAndBestProgramInCondominiumManagement: {
      en: 'The only and best program in condominium management',
      es: 'El único y mejor programa en gestión de condominios',
    },
    thereAreApartmentsThatAreNotOnTheReceiptsGenerated: {
      en: 'There are apartments that are not on the receipts generated',
      es: 'Existen apartamentos que no están en los recibos generados',
    },
    theRecordCannotBeLocated: {
      es: 'El registro no puede ser localizado',
      en: 'The record cannot be located',
    },
    theSumOfTheAliquotsShouldBe: {
      en: 'The sum of the aliquots should be',
      es: 'La sumatoria de las alicuotas deberá ser',
    },
    theUserHasAlreadyMadeRegistration: {
      en: 'The user has already made registration',
      es: 'El usuario ya se ha registrado',
    },
    theUserHasConfirmedTheAccount: {
      en: 'The user has confirmed the account',
      es: 'El usuario ha confirmado la cuenta',
    },
    thePasswordHasBeenUpdatedSuccessfully: {
      en: 'The data has been updated successfully',
      es: 'la contraseña ha sido actualizada con éxito',
    },
    theMovementCannotBeGreaterThanTheBalance: {
      en: 'The movement cannot be greater than the <b>balance</b>',
      es: 'El movimiento no puede ser mayor al <b>saldo</b>',
    },
    theSupplierControlNumberAlreadySssignedAnotherInvoiceFromTheSameSupplier: {
      en: 'The supplier control number already assigned another invoice from the same supplier',
      es: 'El número de control del proveedor ya esta asignado a otra factura del mismo proveedor'
    },
    theSupplierInvoiceNumberAlreadyAssignedAnotherInvoiceFromTheSameSupplier: {
      en: 'The supplier invoice number already assigned another invoice from the same supplier',
      es: 'El número de factura del proveedor ya esta asignado a otra factura del mismo proveedor'
    },
    theUserWithTheProvidedPhoneNumberAlreadyExists: {
      en: 'The user with the provided <b>phone number</b> already exists',
      es: 'El usuario con el <b>número de teléfono</b> proporcionado ya existe',
    },
    TheTotalSumOfTheAliquotsCannotBeGreaterThanOneHundred: {
      en: 'The total sum of the aliquots cannot be greater than <b>100</b>',
      es: 'La sumatoria total de las alicuotas no puede ser mayor a <b>100</b>'
    },
    theValueMustBeGreaterThanOrEqualToZeroAndLessThanOneHundred: {
      en: 'The value must be greater than or equal to <b>0</b> and less than <b>100</b>',
      es: 'El valor debe ser mayor o igual a <b>0</b> y menor a <b>100</b>',
    },
    theyCanOnlyCreateMaximumLimitRecords: {
      en: 'They can only create a maximum limit of records',
      es: 'Sólo pueden crear un límite máximo de registros',
    },
    thisContractIsAlreadyAdded: {
      en: 'This contract is already added',
      es: 'Este contrato ya está agregado',
    },
    thisEmailAlreadyOurSystemConfirmAccount: {
      en: `This email is already registered in our system, you must confirm your account from your email to verify your identity and be able to access our system`,
      es: `Este correo electrónico ya está registrado en nuestro sistema, debe confirmar su cuenta desde su correo electrónico para verificar su identidad y poder acceder a nuestro sistema`,
    },
    thisFieldRequired: {
      en: 'This <b>field</b> is <b>required</b>',
      es: 'Este <b>campo</b> es <b>obligatorio</b>',
    },
    thisProcessIrreversibleDoYouWishContinue: {
      en: 'This process is irreversible.<br/>Do you want to continue?',
      es: 'Este proceso es irreversible.<br/>¿Desea continuar?'
    },
    thisProcessAppliesOnlyToCreatedRecords: {
      en: 'This process applies only to created records',
      es: 'Este proceso aplica sólo a registros creados',
    },
    thisProcessAppliesOnlyToCreatedRecordsAndOpen: {
      en: 'This process applies only to <b>created</b> records and <b>open</b>',
      es: 'Este proceso aplica sólo a registros <b>creados</b> y <b>abierto</b>',
    },
    thisProcessAppliesOnlyToNewOrCreatedRecords: {
      en: 'This process applies only to new or created records',
      es: 'Este proceso aplica sólo a registros nuevos o creados',
    },
    thisProcessAppliesOnlyToRecordsWithBalanceGreaterThanZero: {
      en: 'This process applies only to records with balance greater than zero',
      es: 'Este proceso aplica sólo a <b>registros</b> con saldo mayor a <b>0.00</b>',
    },
    thisProcessOnlyAppliesUnreconciledRecords: {
      en: 'This process only applies unreconciled records',
      es: 'Este proceso solo aplica a registros no conciliados',
    },
    thisUserDoesNotExist: {
      en: 'THis user does not exist',
      es: 'Este usuario no existe',
    },
    thisUserNotMaster: {
      en: 'This user is not an administrator',
      es: 'Este usuario no es administrador',
    },
    tokenMissingOrInvalid: {
      en: 'Token missing or invalid',
      es: 'No existe el token o es inválido',
    },
    toPreventUnwantedAccessToOurWebSystemWithYourCredentials: {
      en: 'To prevent <b>unwanted</b> access to our web system with your credentials',
      es: 'Para evitar accesos <b>no deseados</b> a nuestro sistema web con sus credenciales',
    },
    toRunThisProcess: {
      en: 'To run this process',
      es: 'Para ejecutar este proceso',
    },
    userOrPasswordIncorrect: {
      en: '<b>User</b> or <b>password</b> incorrect',
      es: '<b>Usuario</b> o <b>contraseña</b> incorrecta',
    },
    userUpdatedSuccessfully: {
      en: 'User updated successfully',
      es: 'Usuario actualizado con éxito',
    },
    verificationEmail: {
      en: 'Verification email',
      es: 'Correo de verificación',
    },
    verificationMessage01: {
      en: 'We need you to please <b>verify your account</b> to validate that <b>you are the owner of the email</b> you used to register your credentials in our system. <b>To verify your account, click on the following button</b>, then one of our support and customer service analysts will send you <b>a welcome email</b> and you will be able to access our system',
      es: 'Necesitamos que por favor <b>verifiques tu cuenta</b> para validar que eres el <b>propietario del correo electrónico</b> que usaste para el registro de tus credenciales en nuestro sistema. <b>Para verificar tu cuenta has clic en el siguiente botón</b>, luego uno de nuestros analistas de soporte y atención al cliente te enviara un <b>correo de bienvenida</b> y podrás acceder a nuestro sistema',
    },
    voteNotExecuted: {
      en: 'Vote not executed',
      es: 'Voto no ejecutado',
    },
    weCouldNotFindThePageYouWereLookingFor: 'No pudimos encontrar la página que buscaba',
    welcomeMessage01: {
      en: '<b>Welcome</b>, your account was verified and enabled by one of our support and customer service analysts. <b>You can now log in to our system</b> and enjoy all the benefits we offer you to keep organized all the information regarding the condominium you want to manage or use as a user',
      es: '<b>Bienvenid@</b>, tu cuenta fue verificada y habilitada por uno de nuestros analistas de soporte y atención al cliente. <b>Ya puedes iniciar sesión en nuestro sistema</b> y disfrutar de todas las bondades que te ofrecemos para mantener organizada toda la información referente al condominio que deseas administrar o emplear como usuario',
    },
    viewInBrowser: {
      en: 'View in browser',
      es: 'Ver en el navegador',
    },
    welcomeEmail: {
      en: 'Welcome email',
      es: 'Correo de bienvenida',
    },
    youCanOnlyChangeTheStatus: {
      en: 'You can only change the status',
      es: 'Solo puede modificar el estatus',
    },
    youCanOnlyRunThisProcess: {
      en: 'You can only run this process',
      es: 'Solo puede ejecutar este proceso',
    },
    youCannotModifyAnElectionWithClosedStatus: {
      en: 'You cannot modify an election with closed status',
      es: 'No puede modificar una elección con estado cerrado',
    },
    youCannotModifyTheAmountOfReceiptWithAssignedPayments: {
      en: 'You cannot modify the amount of a receipt with assigned payments',
      es: 'No puede modificar el monto de un recibo con pagos asignados',
    },
    youCannotModifyTheAmountOfReceiptWithAssignedApartmentReceiptDetails: {
      en: 'You cannot modify the amount of a receipt with assigned apartment receipt details',
      es: 'No se puede modificar el monto de un recibo con detalles de recibo por apartamento asignados',
    },
    youHaveNotSelectedRoles: {
      en: 'You have not selected roles',
      es: 'No ha seleccionado roles',
    },
    youHaveRequestedToResetYourPassword: {
      en: 'You have requested to reset your password',
      es: 'Has solicitado restablecer tu contraseña',
    },
    yourAccountHasBeenDeleted: {
      en: 'Your <b>account</b> has been <b>deleted</b>',
      es: 'Su <b>cuenta</b> ha sido <b>eliminada</b>',
    },
    yourAccountHasBeenDisabled: {
      en: 'your <b>account</b> has been <b>disabled</b>',
      es: 'Su <b>cuenta</b> ha sido <b>deshabilitada</b>',
    },
    yourAccountIsNowActivate: {
      en: 'Your account is now activate',
      es: 'Tu cuenta ya está activa',
    },
    yourAccountIsAlmostActive: {
      en: 'Your account is almost active',
      es: 'Tu cuenta está casi activa',
    },
    youCannotAlterDocumentWithStatus: {
      en: 'You cannot alter document with status',
      es: 'No puede alterar un documento con status',
    },
    youCannotDeleteThisRecord: {
      en: 'You cannot delete this Record',
      es: 'No puede eliminar este registro',
    },
    youCannotEditThisRecord: {
      en: 'You cant not edit this record',
      es: 'No puede editar este registro',
    },
    youCannotMakeAnOutflowTypeMovementWithTheCashBalanceLessThanOrEqualTo: {
      en: 'You cannot make an <b>out</b> flow type movement with the cash <b>balance</b> less than or equal to',
      es: 'No puede hacer un movimiento de tipo <b>egreso</b> con el <b>saldo</b> de la caja menor o igual a',
    },
    youCannotMakeAnOutflowTypeMovementWithTheBalanceLessThanOrEqualTo: {
      en: 'You cannot make an <b>out</b> flow type movement with <b>balance</b> less than or equal to',
      es: 'No puede hacer un movimiento de tipo <b>egreso</b> con <b>saldo</b> menor o igual a',
    },
    youCannotModifyReconciledPayment: {
      en: 'You cannot modify a reconciled payment',
      es: 'No puede modificar un pago conciliado',
    },
    youCanNotOpenAnOpenDocument: {
      en: 'You cannot open an open document',
      es: 'No puede abrir un documento abierto',
    },
    youCanNotCloseAClosedDocument: {
      en: 'You cannot close a closed document',
      es: 'No puede cerrar un documento cerrado',
    },
    youCannotModifyAnElectionWithExecutedVotes: {
      en: 'You cannot modify an election with executed votes',
      es: 'No puede modificar una elección con votos ejecutados',
    },
    youCannotAddInformationToReconciledPayment: {
      en: 'You cannot add information to a reconciled payment',
      es: 'No puede agregar información a un pago conciliado',
    },
    youCannotModifyTheInformationOfReconciledPayment: {
      en: 'You cannot modify the information of a reconciled payment',
      es: 'No puede modificar la información de un pago conciliado',
    },
    youCannotModifyTheStatusWithoutAddingDetails: {
      en: 'You cannot modify the status without adding details',
      es: 'No puede modificar el status sin agregar detalles',
    },
    youCannotRemoveInformationFromReconciledPayment: {
      en: 'You cannot remove information from a reconciled payment',
      es: 'No puede eliminar información de un pago conciliado',
    },
    youCannotOpenAnElectionIfThereAreOpenOrPausedElections: {
      en: 'You cannot open an election if there are open or paused elections',
      es: 'No puede abrir una elección si hay elecciónes abiertas o en pausa',
    },
    youCannotPrintReceiptsWithBalanceGreaterThanZero: {
      en: 'You cannot print receipts with a balance greater than <b>0.00</b>',
      es: 'No puede imprimir recibos con saldo mayor a <b>0.00</b>'
    },
    youDoNotHaceAnyAssignedContracts: {
      en: 'You do not have any ssigned contracts',
      es: 'No tiene ningún contrato asignado',
    },
    youDoNotHaveSufficientPrivilegesToRunThisProcess: {
      en: 'You do not have sufficient privileges to run this process',
      es: 'No tiene suficientes privilegios para ejecutar este proceso',
    },
    youMustAddAtLeastOneFile: {
      en: 'You must add at least one file',
      es: 'Debes agregar al menos un archivo'
    },
    youMustAddComment: {
      en: 'You must add a comment',
      es: 'Debes agregar un comentario',
    },
    youMustAddLeastConcept: {
      en: 'You must add least 1 concept',
      es: 'Debes agregar al menos 1 <b>concepto</b>'
    },
    youMustAssignTheAliquotPercentagesToEachApartment: {
      en: 'You must assign the aliquot percentages to each apartment',
      es: 'Debe asignar los porcentajes de alícuota a cada apartamento',
    },
    youMustCreateLeastOneApartment: {
      en: 'You must create least one apartment',
      es: 'Debes crear al menos un apartamento',
    },
    youMustCreateLeastOneBank: {
      en: 'You must create at least one bank',
      es: 'Debes crear al menos un banco',
    },
    youMustCreateLeastOneBankAccount: {
      en: 'You must create at least one bank account',
      es: 'Debes crear al menos una cuenta bancaria',
    },
    youMustCreateLeastOneCoin: {
      en: 'You must create at least one coin',
      es: 'Debes crear al menos una moneda',
    },
    youMustCreateLeastOneCollectionCash: {
      en: 'You must create at least one collection cash',
      es: 'Debes crear al menos una caja',
    },
    youMustCreateLeastOneCommonArea: {
      en: 'You must create at least one common area',
      es: 'Debes crear al menos un área común',
    },
    youMustCreateLeastOneCountry: {
      en: 'You must create at least one country',
      es: 'Debes crear al menos un país',
    },
    youMustCreateLeastOneElevator: {
      en: 'You must create at least one elevator',
      es: 'Debes crear al menos un elevador',
    },
    youMustCreateLeastOneExpenseTemplate: {
      en: 'You must create at least one expense template',
      es: 'Debes crear al menos una plantilla de gasto',
    },
    youMustCreateLeastOneExpenseConcept: {
      en: 'You must create at least one expense concept',
      es: 'Debes crear al menos un concepto de gasto',
    },
    youMustCreateLeastOneInventory: {
      en: 'You must create at least one inventory',
      es: 'Debes crear al menos un inventario',
    },
    youMustCreateLeastOnePaymentMethod: {
      en: 'You must create at least one payment method',
      es: 'Debes crear al menos un método de pago',
    },
    youMustCreateLeastOnePeopleTypes: {
      en: 'You must create at least one people type',
      es: 'Debes crear al menos un tipo de persona',
    },
    youMustCreateLeastOneSupplier: {
      en: 'You must create least one supplier',
      es: 'Debes crear al menos un proveedor',
    },
    youMustCreateLeastOneTax: {
      en: 'You must create at least one tax',
      es: 'Debes crear almenos un impuesto'
    },
    youMustConfirmYourEmailAccountCompleteRegistration: {
      en: 'You must confirm your email account to complete the registration',
      es: 'Debe confirmar su cuenta de correo electrónico para completar el registro',
    },
    youMustDefineAtLeastOneFloorOfTheBuilding: {
      en: 'You must define at least one floor of the building',
      es: 'Debes definir al menos un piso del edificio',
    },
    youMustDefineFileTypes: {
      en: 'You must define file types',
      es: 'Debes definir tipo de archivos',
    },
    youMustEnterValidDate: {
      en: 'You must enter a valid date',
      es: 'Debes ingresar una fecha válida',
    },
    youMustEnterValidEmail: {
      en: 'You must enter a valid <b>email</b>',
      es: 'Debes ingresar un <b>correo electrónico</b> válido'
    },
    youMustEnterValidPassword: {
      es: 'Debe ingresar una <b>contraseña</b> válida',
      en: 'You must enter a valid <b>password</b>',
    },
    youMustEnterValidNewPassword: {
      en: 'You must enter a valid <b>new password</b>',
      es: 'Debes ingresar una <b>nueva contraseña</b> válida',
    },
    youMustEnterValidNewPasswordConfirm: {
      en: 'You must enter a valid <b>new password confirm</b>',
      es: 'Debes ingresar una <b>nueva confirmación de contraseña</b> válida',
    },
    youMustEnterValidPhoneNumber: {
      en: 'You must enter a valid <b>phone number</b>',
      es: 'Debes ingresar un <b>número de teléfono</b> válido'
    },
    youMustEnterValidPasswordConfirm: {
      en: 'You must enter a valid <b>password confirm</b>',
      es: 'Debes ingresar una <b>confirmación de contraseña</b> válida',
    },
    youMustLogin: {
      en: 'You must login',
      es: 'Debes iniciar sesión',
    },
    youMustLogInAccessThisSection: {
      en: 'You must log in access this section',
      es: 'Debe iniciar sesión para acceder a esta sección',
    },
    youMustPayTheEntireBill: {
      en: 'You must pay the entire bill',
      es: 'Debe pagar la totalidad del recibo',
    },
    youMustSelectAnExpenseTemplate: 'Debes seleccionar una plantilla de gasto',
    youMustSelectBuilding: {
      en: 'You must select a building',
      es: 'Debes seleccionar un edificio',
    },
    youMustSelectRegisterCash: {
      en: 'You must select a register cash',
      es: 'Debes seleccionar una caja',
    },
    youMustSelectConcept: {
      en: 'You must select concept',
      es: 'Debes seleccionar un concepto',
    },
    youMustSelectCountry: {
      en: 'You must select a country',
      es: 'Debes seleccionar un país'
    },
    youMustSelectRecord: {
      en: 'You must select a record',
      es: 'Debes seleccionar un registro',
    },
    youMustRemoveTheAttachmentsBeforeDeletingTheDocument: {
      en: 'You must remove the attachments<br/>Before deleting the document',
      es: 'Debes eliminar los archivos adjuntos<br/>Antes de eliminar el documento',
    },
    youMustRemoveTheAttachedDocumentsBeforeRemovingThePayment: {
      en: 'You must remove the attached documents<br/>Before removing the payment',
      es: 'Debe eliminar los documentos adjuntos<br/>Antes de eliminar el pago',
    },
    youSuspectThatTheyWantToEnterOurWebSystemWithYourCredentials: {
      en: 'You suspect that they want to enter our web system with your credentials',
      es: 'Sospecha que quieren ingresar a nuestro sistema web con sus credenciales',
    },
    yourFeedbackIsImportant: {
      en: 'Your feedback is important',
      es: 'Su comentario es importante',
    },
    youWillNeedToLogInAgainWithTheUpdatedPassword: {
      en: 'You will need to log in again with the updated password',
      es: 'Debera iniciar sesion nuevamente con la contraseña actualizada',
    },
    YourMessageHasBeenSent: {
      en: 'Your message has been sent',
      es: 'Tu mensaje ha sido enviado',
    },
    yourMessageHasBeenSentSuccessfully: {
      en: 'Your message has been sent successfully',
      es: 'Su mensaje se ha enviado satisfactoriamente',
    },
    yourSessionHasExpired: {
      en: 'Your session has expired',
      es: 'Su sesión ha expirado',
    },
    yourVoteWillBeRegisteredAsNull: {
      en: 'Your vote will be registered as null',
      es: 'Su voto será registrado como nulo',
    }
  },
  movement: {
    transactionTypes: [
      {
        id: 'E',
        description: {
          en: 'Egress',
          es: 'Egreso',
        },
      },
      {
        id: 'I',
        description: {
          en: 'Income',
          es: 'Ingreso',
        },
      },
    ],
  },
  numberPositions: {
    decimalPlaces: 2,
  },
  peopleType: {
    consierge: 'Conserjería',
    condominium: 'Condominio',
    owner: 'Propietario',
    renter: 'Arrendador',
    roomer: 'Inquilino',
  },
  react: {
    CssfxLoading: {
      barWave: 'BarWave',
      bouncingBalls: 'BouncingBalls',
      coin: 'Coin',
      circularProgress: 'CircularProgress',
      fadingBalls: 'FadingBalls',
      fadingDots: 'FadingDots',
      fillingBottle: 'FillingBottle',
      flippingSquare: 'FlippingSquare',
      hypnosis: 'Hypnosis',
      messaging: 'Messaging',
      ring: 'Ring',
      spin: 'Spin',
      spinStretch: 'SpinStretch',
      twinSpin: 'TwinSpin',
    },
    firebase: {
      auth: {
        errors: {
          authEmailNotFound: 'auth/email-not-found',
          authUserNotFound: 'auth/user-not-found',
          authWrongPassword: 'auth/wrong-password',
          authPhoneNumberAlreadyExists: 'auth/phone-number-already-exists',
          authEmailAlreadyExists: 'auth/email-already-exists',
        },
      },
      operators: {
        equalTo: '==',
        arrayContains: 'array-contains',
        arrayContainsAny: 'array-contains-any',
        greaterThan: '>',
        greaterThanOrEqualTo: '>=',
        in: 'in',
        lessThan: '<',
        lessThanOrEqualTo: '<=',
        notEqualTo: '!=',
        notIn: 'not-in',
      },
    },
    html: {
      button: {
        classes: {
          disabled: 'btn disabled',
          progress: 'btn-progress',
        },
      },
      dropDown: {
        active: 'dropdown active',
        normal: 'dropdown',
      },
      li: {
        active: 'active text-primary',
        normal: '',
      },
      spaces: {
        one: '&nbsp;',
        two: '&nbsp;&nbsp;',
        three: '&nbsp;&nbsp;&nbsp;',
      },
      overlay: {
        darkTextWhite: 'overlay dark text-white',
        textMued: 'overlay text-muted',
        textWhite: 'overlay text-white',
      },
      spinner: {
        borderSm: 'spinner-border spinner-border-sm',
      },
    },
    loadingComponents: {
      audio: 'audio',
      ballTriangle: 'ball_triangle',
      bars: 'bars',
      circles: 'circles',
      grid: 'grid',
      hearts: 'hearts',
      oval: 'oval',
      puff: 'puff',
      rings: 'rings',
      spinningCircles: 'spinning_circles',
      tailSpin: 'tail_spin',
      threeDots: 'three_dots',
    },
    tempusDominus: {
      buttons: {
        showToday: true,
        showClear: false,
        showClose: true,
      },
      icons: {
        time: 'fas fa-clock',
        date: 'fas fa-calendar',
        up: 'fas fa-arrow-up',
        down: 'fas fa-arrow-down',
        previous: 'fas fa-chevron-left',
        next: 'fas fa-chevron-right',
        today: 'fas fa-calendar-check-o',
        clear: 'fas fa-trash',
        close: 'fas fa-times'
      },
      //#region old code
      // tooltips: {
      //   today: 'Hoy',
      //   clear: 'Inicializar selección',
      //   close: 'Cerrar selector',
      //   selectMonth: 'Seleccionar mes',
      //   prevMonth: 'Mes anterior',
      //   nextMonth: 'Próximo mes',
      //   selectYear: 'Seleccionar año',
      //   prevYear: 'Año anterior',
      //   nextYear: 'Año siguiente',
      //   selectDecade: 'Selecciondar decada',
      //   prevDecade: 'Década anterior',
      //   nextDecade: 'Década siguiente',
      //   prevCentury: 'Siglo anterior',
      //   nextCentury: 'Siglo siguiente',
      //   pickHour: 'Seleccionar hora',
      //   incrementHour: 'Incrementar hora',
      //   decrementHour: 'Disminuir hora',
      //   pickMinute: 'Seleccionar minuto',
      //   incrementMinute: 'ncrementar minuto',
      //   decrementMinute: 'Disminuir minuto',
      //   pickSecond: 'Seleccionar segundo',
      //   incrementSecond: 'Incrementar segundo',
      //   decrementSecond: 'Disminuir segundo',
      //   togglePeriod: 'Alternar período',
      //   selectTime: 'Seleccionar hora',
      //   selectDate: 'Seleccionar fecha'
      // },
      //#endregion old code
      tooltips: ({ languageId = 'en' }) => {
        switch (languageId) {
          case 'es':
            return {
              today: 'Hoy',
              clear: 'Inicializar selección',
              close: 'Cerrar selector',
              selectMonth: 'Seleccionar mes',
              prevMonth: 'Mes anterior',
              nextMonth: 'Próximo mes',
              selectYear: 'Seleccionar año',
              prevYear: 'Año anterior',
              nextYear: 'Año siguiente',
              selectDecade: 'Selecciondar decada',
              prevDecade: 'Década anterior',
              nextDecade: 'Década siguiente',
              prevCentury: 'Siglo anterior',
              nextCentury: 'Siglo siguiente',
              pickHour: 'Seleccionar hora',
              incrementHour: 'Incrementar hora',
              decrementHour: 'Disminuir hora',
              pickMinute: 'Seleccionar minuto',
              incrementMinute: 'Incrementar minuto',
              decrementMinute: 'Disminuir minuto',
              pickSecond: 'Seleccionar segundo',
              incrementSecond: 'Incrementar segundo',
              decrementSecond: 'Disminuir segundo',
              togglePeriod: 'Alternar período',
              selectTime: 'Seleccionar hora',
              selectDate: 'Seleccionar fecha',
            };
          default:
            return {
              today: 'Today',
              clear: 'Clear',
              close: 'Close',
              selectMonth: 'Select month',
              prevMonth: 'Prev. month',
              nextMonth: 'Next month',
              selectYear: 'Select year',
              prevYear: 'Prev. year',
              nextYear: 'Next year',
              selectDecade: 'Select decade',
              prevDecade: 'Prev. decade',
              nextDecade: 'Next decade',
              prevCentury: 'Prev. century',
              nextCentury: 'Next century',
              pickHour: 'Select hour',
              incrementHour: 'Increment hour',
              decrementHour: 'Decrement hour',
              pickMinute: 'Pick minute',
              incrementMinute: 'Increment minute',
              decrementMinute: 'Decrement minute',
              pickSecond: 'Pick second',
              incrementSecond: 'Increment second',
              decrementSecond: 'Decrement second',
              togglePeriod: 'Toggle period',
              selectTime: 'Select time',
              selectDate: 'Select date',
            };
        }
      },
      format: {
        date: {
          dmy: 'd/m/y',
          dmyTwo: 'd-m-y',
          mdy: 'm/d/y',
          mdyTwo: 'm-d-y',
          ymd: 'y/m/d',
          ymdTwo: 'y-m-d',
          DMY: 'D/M/Y',
          DMYTwo: 'D-M-Y',
          DDMMYY: 'DD/MM/YY',
          DDMMYYTwo: 'DD-MM-YY',
          DDMMYYYY: 'DD/MM/YYYY',
          DDMMYYYYTwo: 'DD-MM-YYYY',
          MMDDYYYY: 'MM/DD/YYYY',
          MMDDYYYYTwo: 'MM-DD-YYYY',
          YYYYMMDD: 'YYYY/MM/DD',
          YYYYMMDDTwo: 'YYYY-MM-DD',
        },
        time: {
          hhmm: 'hh:mm',
          hhmmss: 'hh:mm:ss',
          hhmmA: 'hh:mm A',
          hhmmssA: 'hh:mm:ss A',
          HHmm: 'HH:mm',
          HHmmss: 'HH:mm:ss',
          hhmma: 'hh:mm a',
          hhmmssa: 'hh:mm:ss a',
        }
      },
      //#region old code
      // formatDatedmy: 'd/m/y',
      // formatDatedmyTwo: 'd-m-y',
      // formatDatemdy: 'm/d/y',
      // formatDatemdyTwo: 'm-d-y',
      // formatDateymd: 'y/m/d',
      // formatDateymdTwo: 'y-m-d',
      // formatDateDMY: 'D/M/Y',
      // formatDateDDMMYY: 'DD/MM/YY',
      // formatDateDDMMYYYY: 'DD/MM/YYYY',
      // formatDateDDMMYYYYTwo: 'DD-MM-YYYY',
      // formatDateMMDDYYYY: 'MM/DD/YYYY',
      // formatDateMMDDYYYYTwo: 'MM-DD-YYYY',
      // formatDateYYYYMMDD: 'YYYY/MM/DD',
      // formatDateYYYYMMDDTwo: 'YYYY-MM-DD',
      // formatTimehhmmA: 'hh:mm A',
      //#endregion old code
    },
    sweetAlert2: {
      icons: {
        error: 'error',
        info: 'info',
        question: 'question',
        success: 'success',
        warning: 'warning',
      },
      images: {
        information: '/images/sweetalert2/informationIcon.png',
        success: '/images/sweetalert2/successIcon.png',
      },
    },
  },
  roles: {
    master: 'master',
    admin: 'admin',
    //anonymous: 'anonymous',
    anonymous: '',
    user: 'user',
  },
  sweetAlert2: {
    dismiss: {
      backdrop: 'backdrop',
      cancel: 'cancel',
    },
  },
  timers: {
    threeNanoSeconds: 300,
    fourNanoSeconds: 400,
    fiveNanoSeconds: 500,
    oneSecond: 1000,
    twoSeconds: 2000,
    tenSeconds: 10000,
    twentySeconds: 20000,
    thirtySeconds: 30000,
    fourthySeconds: 40000,
    fiftySeconds: 50000,
    sixtySeconds: 60000,
  },
});

export const statusListGet = ({ type = 'S', languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'statusListGet';
  let response = responseGet();
  try {
    switch (type) {
      case 'I':
        response.result = [
          { id: 0, description: globalSettings?.labels?.created?.[languageId], },
          { id: 1, description: globalSettings?.labels?.opened?.[languageId], },
          { id: 2, description: globalSettings?.labels?.paused?.[languageId], },
          { id: 3, description: globalSettings?.labels?.closed?.[languageId], },
        ];
        break;
      case 'S':
        response.result = [
          { id: '0', description: globalSettings?.labels?.created?.[languageId], },
          { id: '1', description: globalSettings?.labels?.opened?.[languageId], },
          { id: '2', description: globalSettings?.labels?.paused?.[languageId], },
          { id: '3', description: globalSettings?.labels?.closed?.[languageId], },
        ];
        break;
      default:
        response.result = [];
        break;
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = [];
    console?.error(response);
  }
  return response;
}

export const navSetting = {
  navItemMenuOpen: 'nav-item menu-open',
  navItem: 'nav-item',
  navLinkActive: 'nav-link active',
  navLink: 'nav-link',
};

//#region old code
// export const sendMessage = (msgType = 0, msgText = '', timer = 0, confirmButton = false, showProgressBar = false, swal = null, update = '',) => {
//   const localSwal = (isNull(swal) || isUndefined(swal) ? Swal : swal);
//   if (!isNull(msgText) && !isEmpty(msgText)) {
//     msgText = msgText.replace('\n', '<br/>');
//   }
//   if (msgType === -2) {
//     //Swal.close();
//     localSwal.close();
//   } else {
//     let msgTitle;
//     let swalProperty;
//     let timerInterval;
//     switch (msgType) {
//       case -1:
//         msgType = 'error';
//         msgTitle = 'Error';
//         break;
//       case 0:
//         msgType = 'success';
//         msgTitle = globalSettings?.labels?.success;
//         break;
//       case 1:
//         msgType = 'warning';
//         msgTitle = globalSettings?.labels?.warning.es;
//         break;
//       case 2:
//         msgType = 'info';
//         msgTitle = globalSettings?.labels?.information.es;
//         break;
//       default:
//         msgType = 'question';
//         msgTitle = globalSettings?.labels?.question.es;
//         break;
//     }

//     if (showProgressBar) {
//       swalProperty = {
//         icon: msgType,
//         title: msgTitle,
//         html: msgText,
//         timer: timer !== null ? timer : null,
//         confirmButtonColor: globalSettings?.colors?.successColorExp,
//         showConfirmButton: confirmButton,
//         timerProgressBar: showProgressBar,
//         didOpen: () => {
//           localSwal.showLoading();
//           timerInterval = setInterval(() => {
//             //const content = Swal.getContent()
//             //if (content) {
//             //    const b = content.querySelector('strong')
//             //    if (b) {
//             //        //b.textContent = Swal.getTimerLeft()
//             //        percent = ((Swal.getTimerLeft() / parseInt(timer)) * 100).toFixed(0);
//             //        b.textContent = percent
//             //    }
//             //}
//           }, 100)
//         },
//         willClose: () => {
//           clearInterval(timerInterval)
//         }
//       };

//       // Swal.fire(swalProperty).then((result) => {
//       //   /* Read more about handling dismissals below */
//       //   if (result.dismiss === Swal.DismissReason.timer) {
//       //       console.log('I was closed by the timer')
//       //   }
//       // });

//     } else {
//       swalProperty = {
//         icon: msgType,
//         title: msgTitle,
//         html: msgText,
//         timer: timer !== null ? timer : null,
//         confirmButtonColor: globalSettings?.colors?.successColorExp,
//         showConfirmButton: confirmButton,
//         timerProgressBar: showProgressBar,
//         didOpen: () => {
//           localSwal.hideLoading();
//         },
//       };
//     }

//     if (!isEmpty(update)) {
//       delete swalProperty.timer;
//       delete swalProperty.timerProgressBar;
//       delete swalProperty.didOpen;

//       swalProperty.html = update;
//       localSwal.update(swalProperty);
//     } else {
//       localSwal.fire(swalProperty);
//     }

//     return localSwal;
//   }
// };
//#endregion old code

export const sendMessage = ({ msgType = 0, msgText = '', timer = 0, confirmButton = false, showProgressBar = false, swal = null, update = '', languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'sendMessage';
  let response = responseGet();
  const swalLocal = (isUndNullEmp({ data: swal, subMethod: currentMethod, })?.result ? Swal : swal);
  try {

    if (!isUndNullEmp({ data: msgText, subMethod: currentMethod, })?.result) {
      msgText = msgText.replace('\n', '<br/>');
    }
    if (msgType === -2) {
      //Swal.close();
      swalLocal.close();
    } else {
      let msgTitle;
      let swalProperty;
      let timerInterval;
      switch (msgType) {
        case -1:
          msgType = 'error';
          msgTitle = globalSettings?.labels?.error?.[languageId];
          break;
        case 0:
          msgType = 'success';
          msgTitle = globalSettings?.labels?.success?.[languageId];
          break;
        case 1:
          msgType = 'warning';
          msgTitle = globalSettings?.labels?.warning?.[languageId];
          break;
        case 2:
          msgType = 'info';
          msgTitle = globalSettings?.labels?.information?.[languageId];
          break;
        default:
          msgType = 'question';
          msgTitle = globalSettings?.labels?.question?.[languageId];
          break;
      }

      if (showProgressBar) {
        swalProperty = {
          icon: msgType,
          title: msgTitle,
          html: msgText,
          timer: timer !== null ? timer : null,
          confirmButtonColor: globalSettings?.colors?.successColorExp,
          showConfirmButton: confirmButton,
          timerProgressBar: showProgressBar,
          didOpen: () => {
            swalLocal.showLoading();
            timerInterval = setInterval(() => {
              //#region old code
              //const content = Swal.getContent()
              //if (content) {
              //    const b = content.querySelector('strong')
              //    if (b) {
              //        //b.textContent = Swal.getTimerLeft()
              //        percent = ((Swal.getTimerLeft() / parseInt(timer)) * 100).toFixed(0);
              //        b.textContent = percent
              //    }
              //}
              //#endregion old code
            }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
        };
        //#region old code
        // Swal.fire(swalProperty).then((result) => {
        //   /* Read more about handling dismissals below */
        //   if (result.dismiss === Swal.DismissReason.timer) {
        //       console.log('I was closed by the timer')
        //   }
        // });
        //#endregion old code
      } else {
        swalProperty = {
          icon: msgType,
          title: msgTitle,
          html: msgText,
          timer: timer !== null ? timer : null,
          confirmButtonColor: globalSettings?.colors?.successColorExp,
          showConfirmButton: confirmButton,
          timerProgressBar: showProgressBar,
          didOpen: () => {
            swalLocal.hideLoading();
          },
        };
      }

      if (!isUndNullEmp({ data: update, subMethod: currentMethod, })?.result) {
        delete swalProperty.timer;
        delete swalProperty.timerProgressBar;
        delete swalProperty.didOpen;

        swalProperty.html = update;
        swalLocal.update(swalProperty);
      } else {
        swalLocal.fire(swalProperty);
      }
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}</br>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    console?.error(response);
  }
  return swalLocal;
};

export const sendMessageCloseCurrentWindowAsync = async ({
  msgType = 0,
  msgText = '',
  msgTitle = '',
  closeWindow = false,
  urlGoTo = '',
  auth = null,
  isLogout = false,
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'sendMessageCloseCurrentWindowAsync';
  let response = responseGet();
  try {
    //#region Logout
    if (!isUndNullEmp({ data: urlGoTo, subMethod: currentMethod, })?.result) {
      if (urlGoTo === globalSettings?.app?.backend?.urlLogin && !isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result) {
        auth?.logout({
          subMethod: currentMethod,
        });
      } else if (!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && isLogout) {
        auth?.logout({
          subMethod: currentMethod,
        });
      }
    }
    //#endregion Logout

    //#region show message
    const swal = Swal;
    if (!isUndNullEmp({ data: msgText, subMethod: currentMethod, })?.result) {
      msgText = msgText?.replaceAll('\n', '<br/>');
    }

    if (msgType === -2) {
      swal.close();
    } else {
      //let msgTitle;
      let swalProperty;

      switch (msgType) {
        case -1:
          //msgType = 'error';
          msgType = globalSettings?.react?.sweetAlert2?.icons?.error;
          //msgTitle = 'Error';
          msgTitle = !isUndNullEmp({ data: msgTitle, subMethod: currentMethod, })?.result ? msgTitle : 'Error';
          break;
        case 0:
          //msgType = 'success';
          msgType = globalSettings?.react?.sweetAlert2?.icons?.success;
          //msgTitle = globalSettings?.labels?.success?.[languageId];
          msgTitle = !isUndNullEmp({ data: msgTitle, subMethod: currentMethod, })?.result ? msgTitle : globalSettings?.labels?.success?.[languageId];
          break;
        case 1:
          //msgType = 'warning';
          msgType = globalSettings?.react?.sweetAlert2?.icons?.warning;
          //msgTitle = globalSettings?.labels?.warning?.[languageId];
          msgTitle = !isUndNullEmp({ data: msgTitle, subMethod: currentMethod, })?.result ? msgTitle : globalSettings?.labels?.warning?.[languageId];
          break;
        case 2:
          //msgType = 'info';
          msgType = globalSettings?.react?.sweetAlert2?.icons?.info;
          //msgTitle = globalSettings?.labels?.information?.[languageId];
          msgTitle = !isUndNullEmp({ data: msgTitle, subMethod: currentMethod, })?.result ? msgTitle : globalSettings?.labels?.information?.[languageId];
          break;
        default:
          //msgType = 'question';
          msgType = globalSettings?.react?.sweetAlert2?.icons?.question;
          //msgTitle = globalSettings?.labels?.question?.[languageId];
          msgTitle = !isUndNullEmp({ data: msgTitle, subMethod: currentMethod, })?.result ? msgTitle : globalSettings?.labels?.question?.[languageId];
          break;
      }

      swalProperty = {
        icon: msgType,
        title: msgTitle,
        html: msgText,
        timer: 0,
        confirmButtonColor: globalSettings?.colors?.successColorExp,
        showConfirmButton: true,
        timerProgressBar: 0,
        didOpen: () => {
          swal?.hideLoading();
        },
      };
      //#endregion show message

      //#region Close window / redirect page
      const { dismiss, isConfirmed, } = await swal?.fire(swalProperty);
      if (dismiss === globalSettings?.sweetAlert2?.dismiss?.backdrop || isConfirmed) {
        //window.close();
        if (closeWindow) {
          window?.close();
        } else if (!isUndNullEmp({ data: urlGoTo, subMethod: currentMethod, })?.result) {
          if (urlGoTo === globalSettings?.app?.backend?.urlLogin && !isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result) {
            //auth.logout();
          } else if (!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && isLogout) {
            //auth.logout();
          }
          window.location.href = urlGoTo;
        }
      } else {
        response.msgType = 1;
        response.isWarning = true;
        response.result = { dismiss, isConfirmed };
      }
      //#endregion Close window / redirect page
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}</br>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    console?.error(response);
  }
  return response;
};

export const setBadgeBoolean = (type = true) => {
  switch (type) {
    case true:
      return `<span class='badge badge-success'>${globalSettings?.labels?.yes.es}</span>`;
    //break;
    default:
      return `<span class='badge badge-secondary'>${globalSettings?.labels?.no.es}</span>`;
    //break;
  }
}

export const setBadgeStatus = ({ type = 0, languageId = 'en', subMethod = '', }) => {
  switch (type) {
    case -1:
      return `<span class='badge badge-info'>${globalSettings?.labels?.new?.[languageId]}</span>`;
    case 0:
      return `<span class='badge badge-warning'>${globalSettings?.labels?.opened?.[languageId]}</span>`;
    case 1:
      return `<span class='badge badge-success'>${globalSettings?.labels?.closed?.[languageId]}</span>`;
    case 2:
      return `<span class='badge badge-secondary'>${globalSettings?.labels?.undefined?.[languageId]}</span>`;
    default:
      return `<span class='badge badge-default'>${globalSettings?.labels?.closed?.[languageId]}</span>`;
  }
}

export const setBadgeStatusGeneric = ({ type = 0, value = '', subMethod = '' }) => {
  //const currentMethod = 'setBadgeStatusGeneric';
  switch (type) {
    case -1:
      return `<span class='badge badge-danger'>${value}</span>`;
    case 0:
      return `<span class='badge badge-success'>${value}</span>`;
    case 1:
      return `<span class='badge badge-warning'>${value}</span>`;
    case 2:
      return `<span class='badge badge-primary'>${value}</span>`;
    case 3:
      return `<span class='badge badge-info'>${value}</span>`;
    case 4:
      return `<span class='badge badge-default'>${value}</span>`;
    default:
      return `<span class='badge badge-secondary'>${value}</span>`;
  }
}

export const badgeStatusGenericSetTwo = ({ type = 0, value = '', }) => {
  switch (type) {
    case -1:
      return `<span class='badge badge-danger'>${value}</span>`;
    case 0:
      return `<span class='badge badge-primary'>${value}</span>`;
    case 1:
      return `<span class='badge badge-success'>${value}</span>`;
    case 2:
      return `<span class='badge badge-warning'>${value}</span>`;
    case 3:
      return `<span class='badge badge-info'>${value}</span>`;
    case 4:
      return `<span class='badge badge-default'>${value}</span>`;
    default:
      return `<span class='badge badge-secondary'>${value}</span>`;
  }
}

export const getCheckboxGeneric = (type = 0, value = false, id = '', label = '', title = '', readOnly = false) => {
  let localCheckBoxGeneric = ``;

  switch (type) {
    case 0:
      localCheckBoxGeneric = `<div class='icheck-primary d-inline'> `;
      break;
    default:
      localCheckBoxGeneric = `<div class='icheck-primary d-inline'> `;
      break;
  }

  localCheckBoxGeneric += `<input `;
  if (value) {
    localCheckBoxGeneric += `checked `;
  }
  localCheckBoxGeneric += `id='${id}' `;
  localCheckBoxGeneric += `title='${title}' `;
  localCheckBoxGeneric += `readOnly=${readOnly} `;
  localCheckBoxGeneric += `type='checkbox' /> `;
  localCheckBoxGeneric += `<label htmlFor='${id}' title='${title}'>${label}</label> `;
  localCheckBoxGeneric += `</div> `;
  return localCheckBoxGeneric;
}

export const dateTimeFormatSet = ({ seconds = 0, type = '', format = 0, secondsShow = false, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'dateTimeFormatSet';
  let response = responseGet();
  try {
    //#region variables
    let formatDateTime = ''
    const dateTime = seconds > 0 ? new Date(seconds * 1000) : new Date();
    //#endregion variables

    //#region date
    switch (type) {
      //case 'd-m-y':
      case globalSettings?.react?.tempusDominus?.format?.date?.dmyTwo:
        //formatDateTime = 'DD-MM-YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYYTwo;
        break;
      //case 'm-d-y':
      case globalSettings?.react?.tempusDominus?.format?.date?.mdyTwo:
        //formatDateTime = 'MM-DD-YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.MMDDYYYYTwo;
        break;
      //case 'y-m-d':
      case globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo:
        //formatDateTime = 'YYYY-MM-DD';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.YYYYMMDDTwo;
        break;
      //case 'd/m/y':
      case globalSettings?.react?.tempusDominus?.format?.date?.dmy:
        //formatDateTime = 'DD/MM/YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
        break;
      //case 'm/d/y':
      case globalSettings?.react?.tempusDominus?.format?.date?.mdy:
        //formatDateTime = 'MM/DD/YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.MMDDYYYY;
        break;
      //case 'y/m/d':
      case globalSettings?.react?.tempusDominus?.format?.date?.ymd:
        //formatDateTime = 'YYYY/MM/DD';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.YYYYMMDD;
        break;
      case '':
        formatDateTime = '';
        break;
      default:
        //formatDateTime = 'MM/DD/YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.MMDDYYYY;
        break;
    }
    //#endregion date

    //#region old code
    // switch (format) {
    //   case 24:
    //     formatDateTime += ' - HH:mm:ss';
    //     break;
    //   case 12:
    //     formatDateTime += ' - hh:mm:ss a';
    //     break;
    //   default:
    //     formatDateTime += '';
    //     break;
    // }
    //#endregion old code

    //#region time
    switch (type) {
      case '':
        switch (format) {
          case 0:
            formatDateTime += '';
            break;
          case 24:
            //formatDateTime += 'HH:mm:ss';
            //formatDateTime += globalSettings?.react?.tempusDominus?.format?.time?.HHmmss;
            formatDateTime += secondsShow ? globalSettings?.react?.tempusDominus?.format?.time?.HHmmss : globalSettings?.react?.tempusDominus?.format?.time?.HHmm;
            break;
          default:
            //formatDateTime += 'hh:mm:ss a';
            //formatDateTime += globalSettings?.react?.tempusDominus?.format?.time?.hhmmssa;
            formatDateTime += secondsShow ? globalSettings?.react?.tempusDominus?.format?.time?.hhmmssa : globalSettings?.react?.tempusDominus?.format?.time?.hhmma;
            break;
        };
        break;
      default:
        switch (format) {
          case 0:
            formatDateTime += '';
            break;
          case 24:
            //formatDateTime += ' - HH:mm:ss';
            formatDateTime += ` - ${secondsShow ? globalSettings?.react?.tempusDominus?.format?.time?.HHmmss : globalSettings?.react?.tempusDominus?.format?.time?.HHmm}`;
            break;
          default:
            //formatDateTime += ' - hh:mm:ss a';
            formatDateTime += ` - ${secondsShow ? globalSettings?.react?.tempusDominus?.format?.time?.hhmmssa : globalSettings?.react?.tempusDominus?.format?.time?.hhmma}`;
            break;
        };
        break;
    }
    //#endregion time

    //#region old code
    // let dateTimeFormat = moment(dateTime)?.format(formatDateTime);
    // return dateTimeFormat;
    //#endregion old code

    response.result = moment(dateTime)?.format(formatDateTime);
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = `${ex?.message}`;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText = `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const dateTimeFormatSetTwo = ({ date = '', type = '', format = 0, addTime = false, secondsShow = true, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'dateTimeFormatSetTwo';
  let response = responseGet();
  try {
    //#region variables
    let formatDateTime = ''
    //const dateTime = new Date(!isUndefined(addTime) && addTime ? (date + 'T12:00:00') : date);
    const dateTime = new Date((!isUndefined(addTime) && addTime && date.indexOf('T') < 0) ? (date + 'T12:00:00') : date);
    //#endregion variables

    //#region date
    switch (type) {
      //case 'd-m-y':
      case globalSettings?.react?.tempusDominus?.format?.date?.dmyTwo:
        //formatDateTime = 'DD-MM-YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYYTwo;
        break;
      //case 'm-d-y':
      case globalSettings?.react?.tempusDominus?.format?.date?.mdyTwo:
        //formatDateTime = 'MM-DD-YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.MMDDYYYYTwo;
        break;
      //case 'y-m-d':
      case globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo:
        //formatDateTime = 'YYYY-MM-DD';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.YYYYMMDDTwo;
        break;
      //case 'd/m/y':
      case globalSettings?.react?.tempusDominus?.format?.date?.dmy:
        //formatDateTime = 'DD/MM/YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
        break;
      //case 'm/d/y':
      case globalSettings?.react?.tempusDominus?.format?.date?.mdy:
        //formatDateTime = 'MM/DD/YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.MMDDYYYY;
        break;
      //case 'y/m/d':
      case globalSettings?.react?.tempusDominus?.format?.date?.ymd:
        //formatDateTime = 'YYYY/MM/DD';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.YYYYMMDD;
        break;
      case '':
        formatDateTime = '';
        break;
      default:
        //formatDateTime = 'MM/DD/YYYY';
        formatDateTime = globalSettings?.react?.tempusDominus?.format?.date?.MMDDYYYY;
        break;
    }
    //#endregion date

    //#region time
    switch (type) {
      case '':
        switch (format) {
          case 0:
            formatDateTime += '';
            break;
          case 24:
            //formatDateTime += 'HH:mm:ss';
            //formatDateTime += globalSettings?.react?.tempusDominus?.format?.time?.HHmmss;
            formatDateTime += secondsShow ? globalSettings?.react?.tempusDominus?.format?.time?.HHmmss : globalSettings?.react?.tempusDominus?.format?.time?.HHmm;
            break;
          default:
            //formatDateTime += 'hh:mm:ss a';
            //formatDateTime += globalSettings?.react?.tempusDominus?.format?.time?.hhmmssa;
            formatDateTime += secondsShow ? globalSettings?.react?.tempusDominus?.format?.time?.hhmmssa : globalSettings?.react?.tempusDominus?.format?.time?.hhmma;
            break;
        };
        break;
      default:
        switch (format) {
          case 0:
            formatDateTime += '';
            break;
          case 24:
            //formatDateTime += ' - HH:mm:ss';
            formatDateTime += ` - ${secondsShow ? globalSettings?.react?.tempusDominus?.format?.time?.HHmmss : globalSettings?.react?.tempusDominus?.format?.time?.HHmm}`;
            break;
          default:
            //formatDateTime += ' - hh:mm:ss a';
            formatDateTime += ` - ${secondsShow ? globalSettings?.react?.tempusDominus?.format?.time?.hhmmssa : globalSettings?.react?.tempusDominus?.format?.time?.hhmma}`;
            break;
        };
        break;
    }
    //#endregion time

    //#region old code
    // let dateTimeFormat = moment(dateTime).format(formatDateTime);
    // return dateTimeFormat;
    //#endregion old code

    response.result = moment(dateTime)?.format(formatDateTime);
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = `${ex?.message}`;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText = `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const dateTimeFormatGlobalSet = ({
  date = undefined,
  type = globalSettings?.react?.tempusDominus?.format?.date?.mdy,
  format = 0,
  addTime = false,
  secondsShow = true,
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'dateTimeFormatGlobalSet';
  let response = responseGet();
  try {
    if (!isUndNullEmp({ data: date?.seconds, subMethod: currentMethod, })?.result) {
      //response.result = dateTimeFormatSet(date.seconds, type, format);
      response = dateTimeFormatSet({
        seconds: date?.seconds,
        type: type,
        format: format,
        secondsShow: secondsShow,
        languageId: languageId,
        subMethod: currentMethod,
      });
    } else {
      //response.result = dateTimeFormatSetTwo(date, type, format, addTime);
      response = dateTimeFormatSetTwo({
        date: date,
        type: type,
        format: format,
        addTime: addTime,
        secondsShow: secondsShow,
        languageId: languageId,
        subMethod: currentMethod,
      });
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    //response.result = format;
    response.result = `${ex?.message}`;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText = `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

// export const setDefaultConditionals = () => {
//   conditionals = [];
//   //conditional = {};
//   conditional.field = '';
//   conditional.operator = '';
//   conditional.value = '';

//   ordersBy = [];
//   orderBy.field = '';
//   orderBy.value = '';
// };

export const getStatusDocumentByType = (documentStatus = 0) => {
  let response = responseGet();
  try {
    switch (documentStatus) {
      case 0:
        response.result = globalSettings?.labels?.new.es;
        break;
      case 1:
        response.result = globalSettings?.labels?.notProcessed.es;
        break;
      case 2:
        response.result = globalSettings?.labels?.partiallyProcessed;
        break;
      case 3:
        response.result = globalSettings?.labels?.processed;
        break;
      case 4:
        response.result = globalSettings?.labels?.canceled;
        break;
      default:
        response.result = globalSettings?.labels?.undefined?.es;
        break;
    }
    return response;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '';
    response.msgText = `Method: getStatusDocumentByType<br/>${ex?.message}`;
  }
  return response;
}

//#region old code
// export const numberTruncator = (number = 0.00, decimalPlaces = globalSettings?.numberPositions?.decimalPlaces) => {
//     let response = responseGet();
//     try {
//         let localNumber = Math.pow(10, decimalPlaces);
//         response.result = ~~(number * localNumber) / localNumber;
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.result = numberSet('0.00', 'd');
//         response.msgText = `Method: numberTruncator<br/>${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const numberTruncator = (number = 0.00, decimalPlaces = globalSettings?.numberPositions?.decimalPlaces) => {
//   let response = responseGet();
//   try {
//     //#region variables

//     let localNumber = Math.pow(10, decimalPlaces);

//     //#endregion variables

//     //#region process

//     //console.log({number, localNumber, decimalPlaces});
//     response.result = Math.floor(number * localNumber) / localNumber;

//     //#endregion process
//   } catch (ex) {
//     response.msgType = -1;
//     response.isSuccess = false;
//     response.result = numberSet('0.00', 'd');
//     response.msgText = `Method: numberTruncator<br/>${ex?.message}`;
//   }
//   return response;
// }
//#endregion old code

export const numberTruncator = ({ number = 0.00, decimalPlaces = globalSettings?.numberPositions?.decimalPlaces, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'numberTruncator';
  let response = responseGet();
  try {
    //#region variables
    let numberLocal = Math.pow(10, decimalPlaces);
    //#endregion variables

    //#region process
    //console.log({number, numberLocal, decimalPlaces});
    response.result = Math.floor(number * numberLocal) / numberLocal;
    //#endregion process
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = 'check error';
    console?.error(response);
  }
  return response;
}

//#region old code
// export const setSeparatorsNumbers = (number = 0) => {
//   let newNumber = '';
//   try {
//     const decimalPlaces = globalSettings?.numberPositions?.decimalPlaces;
//     const decimalSeparator = '.';
//     const thousendSeparator = ',';
//     let numberString = !isUndefined(number) ? (!isNaN(number) ? number.toString() : number) : '';
//     let decimals = decimalPlaces;
//     let flat = 1;
//     const decimalPosition = numberString.indexOf('.');

//     if (decimals !== 0) {
//       if (decimalPosition < 0) {
//         numberString += `${decimalSeparator}${repeat('0', decimals)}`;
//       } else {
//         const localDecimals = numberString.substr((decimalPosition + 1), decimalPlaces);
//         if (localDecimals.length !== decimalPlaces) {
//           numberString += `${repeat('0', (decimalPlaces - localDecimals.length))}`;
//         }
//       }
//     }

//     for (var index = numberString.length + 1; index >= 0; index--) {
//       if (flat === (decimals + 6) || flat === (decimals + 9) || flat === (decimals + 12)) {
//         newNumber = `${thousendSeparator}${numberString.substr(index, 1)}` + newNumber;
//       } else {
//         newNumber = numberString.substr(index, 1) + newNumber;
//       }
//       flat++;
//     }

//     // 
//     if (newNumber.substr(0, 1) === ',') {
//       newNumber = newNumber.substr(1);
//     }
//     if (newNumber.indexOf('-,') >= 0) {
//       newNumber = newNumber.replace('-,', '-');
//     }

//   } catch (ex) {
//     sendMessage(-1, ex?.message, null, true, null);
//   }
//   return newNumber;
// }
//#endregion old code

//#region old code
// export const setSeparatorsNumbersTwo = (number = 0) => {
//   let newNumber = '';
//   try {
//     //const decimalPlaces = globalSettings?.numberPositions?.decimalPlaces;
//     const decimalPlaces = 0;
//     const decimalSeparator = '.';
//     const thousendSeparator = ',';
//     let numberString = !isUndefined(number) ? (!isNaN(number) ? number.toString() : number) : '';
//     let decimals = decimalPlaces;
//     let flat = 1;
//     const decimalPosition = numberString.indexOf('.');

//     if (decimals !== 0) {
//       if (decimalPosition < 0) {
//         numberString += `${decimalSeparator}${repeat('0', decimals)}`;
//       } else {
//         const localDecimals = numberString.substr((decimalPosition + 1), decimalPlaces);
//         if (localDecimals.length !== decimalPlaces) {
//           numberString += `${repeat('0', (decimalPlaces - localDecimals.length))}`;
//         }
//       }
//     }

//     for (var index = numberString.length + 1; index >= 0; index--) {
//       if (flat === (decimals + 5) || flat === (decimals + 8) || flat === (decimals + 11)) {
//         newNumber = `${thousendSeparator}${numberString.substr(index, 1)}` + newNumber;
//       } else {
//         newNumber = numberString.substr(index, 1) + newNumber;
//       }
//       flat++;
//     }

//     // 
//     if (newNumber.substr(0, 1) === ',') {
//       newNumber = newNumber.substr(1);
//     }
//     if (newNumber.indexOf('-,') >= 0) {
//       newNumber = newNumber.replace('-,', '-');
//     }

//   } catch (ex) {
//     sendMessage(-1, ex?.message, null, true, null);
//   }
//   return newNumber;
// }
//#endregion old code

//#region old code
// export const separatorsNumbersSet = (number = 0) => {
//   let response = responseGet();
//   try {
//     let newNumber = '';
//     const decimalPlaces = globalSettings?.numberPositions?.decimalPlaces;
//     const decimalSeparator = '.';
//     const thousendSeparator = ',';
//     let numberString = !isUndefined(number) ? (!isNaN(number) ? number.toString() : number) : '';
//     let decimals = decimalPlaces;
//     let flat = 1;
//     const decimalPosition = numberString.indexOf('.');

//     if (decimals !== 0) {
//       if (decimalPosition < 0) {
//         numberString += `${decimalSeparator}${repeat('0', decimals)}`;
//       } else {
//         const localDecimals = numberString.substr((decimalPosition + 1), decimalPlaces);
//         if (localDecimals.length !== decimalPlaces) {
//           numberString += `${repeat('0', (decimalPlaces - localDecimals.length))}`;
//         }
//       }
//     }

//     for (var index = numberString.length + 1; index >= 0; index--) {
//       if (flat === (decimals + 6) || flat === (decimals + 9) || flat === (decimals + 12)) {
//         newNumber = `${thousendSeparator}${numberString.substr(index, 1)}` + newNumber;
//       } else {
//         newNumber = numberString.substr(index, 1) + newNumber;
//       }
//       flat++;
//     }

//     // 
//     if (newNumber.substr(0, 1) === ',') {
//       newNumber = newNumber.substr(1);
//     }
//     if (newNumber.indexOf('-,') >= 0) {
//       newNumber = newNumber.replace('-,', '-');
//     }
//     response.result = newNumber;
//   } catch (ex) {
//     response.isSuccess = false;
//     response.msgType = -1;
//     response.result = '0.00';
//     response.msgText = `Method: separatorsNumbersSet<br/>`;
//     response.msgText += `Error: ${ex?.message}`;
//   }
//   return response;
// }
//#endregion old code

//#region old code
// export const separatorsNumbersSet = ({number = 0, withDecimals = true, languageId = 'en', subMethod = '', }) => {
//   const currentMethod = 'separatorsNumbersSet';
//   let response = responseGet();
//   try {
//     let newNumber = '';
//     const decimalPlaces = withDecimals ? globalSettings?.numberPositions?.decimalPlaces : 0;
//     const decimalSeparator = '.';
//     const thousendSeparator = ',';
//     let numberString = !isUndefined(number) ? (!isNaN(number) ? number.toString() : number) : '';
//     let decimals = decimalPlaces;
//     let flat = 1;
//     const decimalPosition = numberString.indexOf('.');

//     if (decimals !== 0) {
//       if (decimalPosition < 0) {
//         numberString += `${decimalSeparator}${repeat('0', decimals)}`;
//       } else {
//         const localDecimals = numberString.substr((decimalPosition + 1), decimalPlaces);
//         if (localDecimals.length !== decimalPlaces) {
//           numberString += `${repeat('0', (decimalPlaces - localDecimals.length))}`;
//         }
//       }
//     }

//     for (var index = numberString.length + 1; index >= 0; index--) {
//       if (flat === (withDecimals ? decimals + 6 : 5) || flat === (withDecimals ? decimals + 9 : 8) || flat === (withDecimals ? decimals + 12 : 11)) {
//         newNumber = `${thousendSeparator}${numberString.substr(index, 1)}` + newNumber;
//       } else {
//         newNumber = numberString.substr(index, 1) + newNumber;
//       }
//       flat++;
//     }

//     // 
//     if (newNumber.substr(0, 1) === ',') {
//       newNumber = newNumber.substr(1);
//     }
//     if (newNumber.indexOf('-,') >= 0) {
//       newNumber = newNumber.replace('-,', '-');
//     }
//     response.result = newNumber;
//   } catch (ex) {
//     response.msgType = -1;
//     response.isSuccess = false;
//     response.msgText = `Method: ${currentMethod}<br/>`;
//     if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
//         response.msgText += `Sub method: ${subMethod}<br/>`;
//     }
//     response.msgText += `Error: ${ex?.message}`;
//     response.result = '0.00';
//   }
//   return response;
// }
//#endregion old code

export const separatorsNumbersSet = ({
  number = 0,
  withDecimals = true,
  consoleLogErrorShow = true,
  subMethod = '',
}) => {
  let response = responseGet();
  const currentMethod = 'separatorsNumbersSet';
  try {
    //#region variables
    let languageObj = globalFormat();
    languageObj = languageObjGet({ subMethod: currentMethod })?.result;
    let numberObj = {
      str: !isUndNull({ data: number, subMethod: currentMethod, })?.result ? (!isNaN(number) ? number?.toString() : number) : '',
      new: '',
      decimals: '',
    };
    const decimalPlaces = withDecimals ? globalSettings?.numberPositions?.decimalPlaces : 0;
    const decimalSeparator = languageObj?.numbers?.separators?.decimals || '.';
    const thousandSeparator = languageObj?.numbers?.separators?.thousands || ',';
    //let decimalPlaces = decimalPlaces;
    let flat = 1;
    const decimalPosition = numberObj?.str?.indexOf('.');
    //#endregion variables

    //#region check decimal separators
    numberObj.str = numberObj?.str?.replace('.', decimalSeparator);
    //#endregion check decimal separators

    //#region check decimals / decimal places
    if (decimalPlaces !== 0) {
      if (decimalPosition < 0) {
        numberObj.str += `${decimalSeparator}${'0'?.repeat(decimalPlaces)}`;
      } else {
        const decimalsLocal = numberObj?.str?.slice((decimalPosition + 1), (decimalPlaces + (decimalPosition + 1)));
        if (decimalsLocal.length !== decimalPlaces) {
          numberObj.str += `${'0'?.repeat(decimalPlaces - decimalsLocal.length)}`;
        }
      }
    }
    //#endregion check decimals / decimal places

    //#region remove decimals info (excedent)
    if (!withDecimals && decimalPosition > 0) {
      numberObj.str = numberObj?.str?.slice(0, decimalPosition);
    } else if (withDecimals && decimalPosition > 0 && decimalPlaces > 0) {
      numberObj.decimals = numberObj?.str.slice(decimalPosition + 1);
      if (numberObj?.decimals?.length > decimalPlaces) {
        //console?.log(numberObj?.decimals);
        numberObj.str = numberObj?.str?.slice(0, ((decimalPosition + 1) + decimalPlaces));
      }
    }
    //#endregion Remove decimals info (excedent)

    for (var index = numberObj?.str?.length + 1; index >= 0; index--) {
      if (flat === (withDecimals ? decimalPlaces + 6 : 5) || flat === (withDecimals ? decimalPlaces + 9 : 8) || flat === (withDecimals ? decimalPlaces + 12 : 11)) {
        numberObj.new = `${thousandSeparator}${numberObj?.str?.slice(index, (index + 1))}` + numberObj.new;
      } else {
        numberObj.new = numberObj?.str?.slice(index, (index + 1)) + numberObj.new;
      }
      flat++;
    }

    if (numberObj.new?.slice(0, 1) === thousandSeparator) {
      numberObj.new = numberObj.new?.slice(1);
    }

    if (numberObj.new?.indexOf(`-${thousandSeparator}`) >= 0) {
      numberObj.new = numberObj.new?.replace(`-${thousandSeparator}`, '-');
    }

    response.result = numberObj.new;
  } catch (ex) {
    response.isSuccess = false;
    response.msgType = -1;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    if (consoleLogErrorShow) {
      console?.error(response);
    }
    response.result = 'check error';
  }
  return response;
}

//#region old code
// export const setNumber = (number = 0, type = 'd') => {
//   switch (type) {
//     case 'd':
//       return parseFloat(Number(number).toFixed(globalSettings?.numberPositions?.decimalPlaces));
//     default:
//       return parseInt(Number(number));
//   }
// }
//#endregion old code

//#region old code
// export const setNumberTwo = (number = 0, type = 'd') => {
//   let localNumber;
//   let localZero = '0';
//   localZero = `${localZero}.${localZero.repeat(globalSettings?.numberPositions?.decimalPlaces)}`;
//   let localZeroNumber = parseFloat(Number(localZero).toFixed(globalSettings?.numberPositions?.decimalPlaces));

//   switch (type) {
//     case 'd':
//       localNumber = parseFloat(Number(number).toFixed(globalSettings?.numberPositions?.decimalPlaces));
//       //localNumber = Number(number).toFixed(globalSettings?.numberPositions?.decimalPlaces);
//       return (isNaN(localNumber) ? localZeroNumber : localNumber);
//     default:
//       localNumber = parseInt(Number(number));
//       return (isNaN(localNumber) ? 0 : localNumber);
//   }
// }
//#endregion old code

//#region old code
// export const setNumberThree = (number = 0, type = 'd') => {
//   const currentMethod = 'setNumberThree';
//   let response = responseGet();
//   try {
//     let localNumber;
//     let localZero = '0';
//     let localDecimalPlaces = globalSettings?.numberPositions?.decimalPlaces;
//     localZero = `${localZero}.${localZero.repeat(localDecimalPlaces)}`;
//     let localZeroNumber = parseFloat(Number(localZero).toFixed(localDecimalPlaces));

//     switch (type) {
//       case 'd':
//         localNumber = parseFloat(Number(number).toFixed(localDecimalPlaces));
//         //return (isNaN(localNumber) ? localZeroNumber : localNumber);
//         response.result = (isNaN(localNumber) ? localZeroNumber : localNumber);
//         break;
//       default:
//         localNumber = parseInt(Number(number));
//         //return (isNaN(localNumber) ? 0 : localNumber);
//         response.result = (isNaN(localNumber) ? 0 : localNumber);
//         break;
//     }
//   } catch (ex) {
//     response.msgType = -1;
//     response.isSuccess = false;
//     response.result = 0.00;
//     response.msgText = `Method: ${currentMethod}<br/>Error: ${ex?.message}`;
//   }
//   return response;
// }
//#endregion old code

//#region old code
// export const numberSet = (number = 0, type = 'd') => {
//   let response = responseGet();
//   try {
//     //#region variables

//     let localNumber;
//     let localZero = '0';
//     let localDecimalPlaces = globalSettings?.numberPositions?.decimalPlaces;
//     //#region old code

//     //let localTruncateDecimalPlaces = 6;

//     //#endregion old code
//     let localTruncateDecimalPlaces = 15;
//     localZero = `${localZero}.${localZero.repeat(localDecimalPlaces)}`;
//     let localZeroNumber = parseFloat(Number(localZero).toFixed(localDecimalPlaces));

//     //#endregion variables

//     //#region Procesos

//     switch (type) {
//       case 'd':
//         response = countDecimals(number);
//         if (!response?.isSuccess || response?.isWarning) {
//           return response;
//         }

//         //localNumber = parseFloat(Number(number).toFixed(localDecimalPlaces));
//         localNumber = parseFloat(Number(number).toFixed(localTruncateDecimalPlaces));
//         //#region old code

//         // if (number === 58000005) {
//         //   console.log({ number, type });
//         //   console.log({ n: 1, localNumber, t: numberTruncator(localNumber, localDecimalPlaces).result });
//         // }

//         //#endregion old code

//         if (localDecimalPlaces !== response.result) {
//           //response.result = (isNaN(localNumber) ? localZeroNumber : localNumber);
//           response.result = (isNaN(localNumber) ? localZeroNumber : numberTruncator(localNumber, localDecimalPlaces).result);
//         } else {
//           response.result = (isNaN(localNumber) ? localZeroNumber : localNumber);
//         }
//         break;
//       default:
//         localNumber = parseInt(Number(number));
//         //return (isNaN(localNumber) ? 0 : localNumber);
//         response.result = (isNaN(localNumber) ? 0 : localNumber);
//         break;
//     }

//     //#endregion Procesos
//   } catch (ex) {
//     response.msgType = -1;
//     response.isSuccess = false;
//     response.result = 0.00;
//     response.msgText = `Method: numberSet<br/>Error: ${ex?.message}`;
//   }
//   return response;
// }
//#endregion old code

export const numberSet = ({ number = undefined, type = 'd', languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'numberSet';
  let response = responseGet();
  try {
    //#region variables
    let numberLocal;
    let zero = '0';
    let decimalPlaces = globalSettings?.numberPositions?.decimalPlaces;
    //let localTruncateDecimalPlaces = 5;
    let truncateDecimalPlaces = 7;
    zero = `${zero}.${zero.repeat(decimalPlaces)}`;
    let zeroNumber = parseFloat(Number(zero)?.toFixed(decimalPlaces));
    //#region variables

    //#region old code
    switch (type) {
      case 'd':
        numberLocal = parseFloat(Number(number)?.toFixed(truncateDecimalPlaces));
        response.result = (isNaN(number) ? zeroNumber : numberTruncator({ number: numberLocal, decimalPlaces: decimalPlaces, languageId: languageId, subMethod: currentMethod, })?.result);
        break;
      default:
        numberLocal = parseInt(Number(number));
        response.result = (isNaN(numberLocal) ? 0 : numberLocal);
        break;
    }
    //#endregion old code
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = 'check error';
    console?.error(response);
  }
  return response;
}

export const isNumber = ({ number = undefined, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'isNumber';
  let response = responseGet();
  try {
    //#region variables
    //#region old code
    // const amountTypeObj = {
    //     a: Number(number) !== NaN,
    //     b: number !== null,
    //     c: !(typeof number === 'string'),
    //     d: !(typeof number === 'object'),
    // };
    //#endregion old code
    const amountTypeObj = {
      a: !isNaN(number),
      //b: !isNull(number),
      b: number !== null,
      c: !(typeof number === 'string'),
      d: !(typeof number === 'object'),
    };
    //#endregion variables

    //#region methods
    response.result = amountTypeObj?.a && amountTypeObj?.b && amountTypeObj?.c && amountTypeObj?.d;
    //#endregion methods
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = false;
    console?.error(response);
  }
  return response;
}

export const countDecimals = (number = 0.00) => {
  let response = responseGet();
  try {
    if (Math.floor(number.valueOf()) === number.valueOf()) {
      response.result = 0;
      return response;
    }

    var localNumberStr = number.toString();
    if (localNumberStr.indexOf(".") !== -1 && localNumberStr.indexOf("-") !== -1) {
      response.result = localNumberStr.split("-")[1] || 0;
      return response;
    } else if (localNumberStr.indexOf(".") !== -1) {
      response.result = localNumberStr.split(".")[1].length || 0;
      return response;
    }
    response.result = localNumberStr.split("-")[1] || 0;
  } catch (ex) {
    response.result = 0;
    response.msgType = -1;
    response.isSuccess = false;
    response.result = 0.00;
    response.msgText = `Method: countDecimals<br/>Error: ${ex?.message}`;
  }
  return response;
}

//export const checkDecimalPlaces = (number = 0.00, decimalPlaces = globalSettings?.numberPositions?.decimalPlaces) => {
export const checkDecimalPlaces = ({ number = 0.00, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'checkDecimalPlaces';
  let response = responseGet();
  try {
    //#region variables
    const numberObj = {
      str: typeof number === 'number' ? number?.toString() : '0.00',
      strFinal: '',
      repeat: 10,
      indexOf: 0,
    };
    //#endregion variables

    //#region methods
    numberObj.indexOf = numberObj?.str?.indexOf('.');

    if (numberObj?.indexOf < 0) {
      numberObj.strFinal = `${numberObj?.str}.${'0'.repeat(numberObj?.repeat)}1`;
    } else {
      numberObj.strFinal = `${numberObj?.str}${'0'.repeat(numberObj?.repeat)}1`;
    }

    response.result = Number(numberObj?.strFinal);
    //#endregion methods
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = 0.00;
    console?.error(response);
  }
  return response;
}

export const styles = {
  appLogoHeader: {
    //aspectRatio: 1,
    //flex: 1,
    height: 46,
    width: 40,
  },

  appLogoHome: {
    width: '250px',
    maxWidth: '100%',
    height: 'auto',
  },

  appLogoHomeUserLogged: {
    width: '75px',
    maxWidth: '50%',
    height: 'auto',
  },

  cardHeaderLogo: {
    height: 30,
    width: 30,
  },

  // inputMsgAlert: {
  //   fontSize: 12,
  //   color: "orangered"
  // },

  profileUserPicture: {
    aspectRatio: 1,
    flex: 1,
    height: 110,
    width: 110,
  },

  receiptPrintLogo: {
    height: 40,
    width: 40,
  },

  labelMsgAlert: {
    fontSize: 12,
    color: 'orangered'
  },

  labelMsgWarning: {
    fontSize: 12,
    color: '#F5BB0E',
  },

  labelMsgInfo: {
    fontSize: 12,
    color: '#18A2B8'
  },

  labelMsgPrimary: {
    fontSize: 12,
    color: '#007BFF'
  },

  leftMenuUserPicture: {
    aspectRatio: 1,
    flex: 1,
    height: 40,
    width: 40,
  },

  loginBox: {
    margin: '0 auto'
  },

  paragrapJustify: {
    textIndent: 4,
    textAlign: 'justify'
  },
};

export const validateEmail = ({ email = '', }) => {
  const re = /^(([^<>()\\[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email)
}

export const validatePhoneNumber = ({ phoneNumber = '', }) => {
  //const re = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  const re = /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{1,4}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  return re.test(phoneNumber);
}

export const validateDecimals = ({ e = {}, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'validateDecimals';
  let response = responseGet();
  const state = { input: '' };
  try {
    let start = 0;
    start = e.target.selectionStart;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, '');
    val = val.replace(/^(0|\.)/, '');
    //const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const match = /(\d{0,15})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    e.target.value = value;
    //this.setState({ input: value });
    state.input = value;
    if (val.length > 0) {
      e.target.value = Number(value)?.toFixed(globalSettings?.numberPositions?.decimalPlaces);
      e.target.setSelectionRange(start, start);
      //this.setState({ input: Number(value).toFixed(2) });
      state.input = Number(value)?.toFixed(globalSettings?.numberPositions?.decimalPlaces);
      //}
    } else {
      state.input = numberSet({ number: 'undefined', type: 'd', languageId: languageId, subMethod: currentMethod, })?.result;
    }

    state.input = isNaN(e.target.value) ? numberSet({ number: 'undefined', type: 'd', languageId: languageId, subMethod: currentMethod, })?.result : state.input;
    //return state.input;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    console?.error(response);
    state.input = `${currentMethod} - error`;
  }
  return state?.input;
};

export const replaceMessages = (type = 0, message = '') => {
  let response = responseGet();
  try {
    //#region  old code
    // //#region Messages

    // response.result = message.replaceAll(globalSettings?.messages?.thisInformationHasAlreadyBeenRecorded.en, globalSettings?.messages?.thisInformationHasAlreadyBeenRecorded.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.pleaseEnterDifferentOne.en, globalSettings?.messages?.pleaseEnterDifferentOne.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.onlyDocumentsWithStatusCanBeModified.en, globalSettings?.messages?.onlyDocumentsWithStatusCanBeModified.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.paymentAmountIsGreaterThatBalanceMessage.en, globalSettings?.messages?.paymentAmountIsGreaterThatBalanceMessage.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youMustCreateLeastOneApartment.en, globalSettings?.messages?.youMustCreateLeastOneApartment.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.thisProcessAppliesOnlyToCreatedRecordsAndOpen.en, globalSettings?.messages?.thisProcessAppliesOnlyToCreatedRecordsAndOpen.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotAlterDocumentWithStatus.en, globalSettings?.messages?.youCannotAlterDocumentWithStatus.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.thisProcessOnlyAppliesUnreconciledRecords.en, globalSettings?.messages?.thisProcessOnlyAppliesUnreconciledRecords.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.objectStructureError.en, globalSettings?.messages?.objectStructureError.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theMovementCannotBeGreaterThanTheBalance.en, globalSettings?.messages?.theMovementCannotBeGreaterThanTheBalance.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.itIsRequired.en, globalSettings?.messages?.itIsRequired.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotMakeAnOutflowTypeMovementWithTheCashBalanceLessThanOrEqualTo.en, globalSettings?.messages?.youCannotMakeAnOutflowTypeMovementWithTheCashBalanceLessThanOrEqualTo.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotMakeAnOutflowTypeMovementWithTheBalanceLessThanOrEqualTo.en, globalSettings?.messages?.youCannotMakeAnOutflowTypeMovementWithTheBalanceLessThanOrEqualTo.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.noMethodSelected.en, globalSettings?.messages?.noMethodSelected.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.thereIsNoDataShow.en, globalSettings?.messages?.thereIsNoDataShow.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotAddInformationToReconciledPayment.en, globalSettings?.messages?.youCannotAddInformationToReconciledPayment.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotModifyReconciledPayment.en, globalSettings?.messages?.youCannotModifyReconciledPayment.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotRemoveInformationFromReconciledPayment.en, globalSettings?.messages?.youCannotRemoveInformationFromReconciledPayment.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotModifyTheInformationOfReconciledPayment.en, globalSettings?.messages?.youCannotModifyTheInformationOfReconciledPayment.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youMustRemoveTheAttachedDocumentsBeforeRemovingThePayment.en, globalSettings?.messages?.youMustRemoveTheAttachedDocumentsBeforeRemovingThePayment.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youMustRemoveTheAttachmentsBeforeDeletingTheDocument.en, globalSettings?.messages?.youMustRemoveTheAttachmentsBeforeDeletingTheDocument.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.pleaseTryAgain.en, globalSettings?.messages?.pleaseTryAgain.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youMustDefineFileTypes.en, globalSettings?.messages?.youMustDefineFileTypes.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.onlyTheFollowingFilesAreAllowed.en, globalSettings?.messages?.onlyTheFollowingFilesAreAllowed.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.maximunWeightAllowed.en, globalSettings?.messages?.maximunWeightAllowed.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.onlyMaximumNumberOfFilesPerDocumentIsAllowed.en, globalSettings?.messages?.onlyMaximumNumberOfFilesPerDocumentIsAllowed.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.onlyMaximumNumberOfFilesIsAllowed.en, globalSettings?.messages?.onlyMaximumNumberOfFilesIsAllowed.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.onlyOneTypeTaxAndExemptIsAllowed.en, globalSettings?.messages?.onlyOneTypeTaxAndExemptIsAllowed.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.numberAllowed.en, globalSettings?.messages?.numberAllowed.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.userOrPasswordIncorrect.en, globalSettings?.messages?.userOrPasswordIncorrect.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.areYouSureDeleteThis.es, globalSettings?.messages?.areYouSureDeleteThis.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.yourAccountHasBeenDeleted.en, globalSettings?.messages?.yourAccountHasBeenDeleted.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.yourAccountHasBeenDisabled.en, globalSettings?.messages?.yourAccountHasBeenDisabled.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.pleaseContactTheSupportDepartment.en, globalSettings?.messages?.pleaseContactTheSupportDepartment.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theRecordCannotBeLocated.en, globalSettings?.messages?.theRecordCannotBeLocated.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theUserWithTheProvidedPhoneNumberAlreadyExists.en, globalSettings?.messages?.theUserWithTheProvidedPhoneNumberAlreadyExists.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theBuildingHasNoAssignedContracts.en, globalSettings?.messages?.theBuildingHasNoAssignedContracts.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theEmailAlreadyByAnotherAccount.en, globalSettings?.messages?.theEmailAlreadyByAnotherAccount.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.thisEmailAlreadyOurSystemConfirmAccount.en, globalSettings?.messages?.thisEmailAlreadyOurSystemConfirmAccount.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.thereIsNoUserRecordCorrespondingToTheProvidedEmail.en, globalSettings?.messages?.thereIsNoUserRecordCorrespondingToTheProvidedEmail.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theInstructionsPasswordRecoveryWereSentEmail.en, globalSettings?.messages?.theInstructionsPasswordRecoveryWereSentEmail.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.systemAdministratorMustApproveYourAccount.en, globalSettings?.messages?.systemAdministratorMustApproveYourAccount.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.systemAdministratorMustAssignYouRole.en, globalSettings?.messages?.systemAdministratorMustAssignYouRole.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotPrintReceiptsWithBalanceGreaterThanZero.en, globalSettings?.messages?.youCannotPrintReceiptsWithBalanceGreaterThanZero.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youMustPayTheEntireBill.en, globalSettings?.messages?.youMustPayTheEntireBill.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.notAllPaymentsHaveBeenReconciledYet.en, globalSettings?.messages?.notAllPaymentsHaveBeenReconciledYet.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.relatedThisReceipt.en, globalSettings?.messages?.relatedThisReceipt.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.pleaseContactTheCondoBoard.en, globalSettings?.messages?.pleaseContactTheCondoBoard.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.tokenMissingOrInvalid.en, globalSettings?.messages?.tokenMissingOrInvalid.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youMustLogin.en, globalSettings?.messages?.youMustLogin.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.expiredToken.en, globalSettings?.messages?.expiredToken.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.yourSessionHasExpired.en, globalSettings?.messages?.yourSessionHasExpired.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotDeleteThisRecord.en, globalSettings?.messages?.youCannotDeleteThisRecord.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.itRelatedOtherTables.en, globalSettings?.messages?.itRelatedOtherTables.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.noFundsAvailable.en, globalSettings?.messages?.noFundsAvailable.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotOpenAnElectionIfThereAreOpenOrPausedElections.en, globalSettings?.messages?.youCannotOpenAnElectionIfThereAreOpenOrPausedElections.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotModifyAnElectionWithExecutedVotes.en, globalSettings?.messages?.youCannotModifyAnElectionWithExecutedVotes.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCanOnlyChangeTheStatus.en, globalSettings?.messages?.youCanOnlyChangeTheStatus.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.cannotChangeToCreatedStatus.en, globalSettings?.messages?.cannotChangeToCreatedStatus.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotModifyAnElectionWithClosedStatus.en, globalSettings?.messages?.youCannotModifyAnElectionWithClosedStatus.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCanOnlyRunThisProcess.en, globalSettings?.messages?.youCanOnlyRunThisProcess.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.ifTheStatusIsClosed.en, globalSettings?.messages?.ifTheStatusIsClosed.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.allowedCharacters.en, globalSettings?.messages?.allowedCharacters.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youDoNotHaceAnyAssignedContracts.en, globalSettings?.messages?.youDoNotHaceAnyAssignedContracts.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess.en, globalSettings?.messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youMustDefineAtLeastOneFloorOfTheBuilding.en, globalSettings?.messages?.youMustDefineAtLeastOneFloorOfTheBuilding.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theyCanOnlyCreateMaximumLimitRecords.en, globalSettings?.messages?.theyCanOnlyCreateMaximumLimitRecords.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theSupplierInvoiceNumberAlreadyAssignedAnotherInvoiceFromTheSameSupplier.en, globalSettings?.messages?.theSupplierInvoiceNumberAlreadyAssignedAnotherInvoiceFromTheSameSupplier.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theSupplierControlNumberAlreadySssignedAnotherInvoiceFromTheSameSupplier.en, globalSettings?.messages?.theSupplierControlNumberAlreadySssignedAnotherInvoiceFromTheSameSupplier.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotModifyTheAmountOfReceiptWithAssignedPayments.en, globalSettings?.messages?.youCannotModifyTheAmountOfReceiptWithAssignedPayments.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youCannotModifyTheAmountOfReceiptWithAssignedApartmentReceiptDetails.en, globalSettings?.messages?.youCannotModifyTheAmountOfReceiptWithAssignedApartmentReceiptDetails.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.onlyOwnersCanAddPaymentInformationToReceipts.en, globalSettings?.messages?.onlyOwnersCanAddPaymentInformationToReceipts.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.itIsRecommendedSendConfirmationEmailAfter24HoursFromTheLastSent.en, globalSettings?.messages?.itIsRecommendedSendConfirmationEmailAfter24HoursFromTheLastSent.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.thereIsNoUserRecordCorrespondingToTheProvidedIdentifier.en, globalSettings?.messages?.thereIsNoUserRecordCorrespondingToTheProvidedIdentifier.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.TheTotalSumOfTheAliquotsCannotBeGreaterThanOneHundred.en, globalSettings?.messages?.TheTotalSumOfTheAliquotsCannotBeGreaterThanOneHundred.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.cannotBeLocated.en, globalSettings?.messages?.cannotBeLocated.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.toRunThisProcess.en, globalSettings?.messages?.toRunThisProcess.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.youMustAssignTheAliquotPercentagesToEachApartment.en, globalSettings?.messages?.youMustAssignTheAliquotPercentagesToEachApartment.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theSumOfTheAliquotsShouldBe.en, globalSettings?.messages?.theSumOfTheAliquotsShouldBe.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.theNumberOfReceiptsGeneratedIsDifferentThanTheNumberOfApartmentsCreated.en, globalSettings?.messages?.theNumberOfReceiptsGeneratedIsDifferentThanTheNumberOfApartmentsCreated.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.deleteGeneratedReceiptsAndRegenerateThem.en, globalSettings?.messages?.deleteGeneratedReceiptsAndRegenerateThem.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.thereAreApartmentsThatAreNotOnTheReceiptsGenerated.en, globalSettings?.messages?.thereAreApartmentsThatAreNotOnTheReceiptsGenerated.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.invalidContract.en, globalSettings?.messages?.invalidContract.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.allAssignedContractsHaveExpired.en, globalSettings?.messages?.allAssignedContractsHaveExpired.es);
    // response.result = response.result.replaceAll(globalSettings?.messages?.onlyOneUserPerApartmentIsAllowed.en, globalSettings?.messages?.onlyOneUserPerApartmentIsAllowed.es);

    // //#endregion Messages

    // //#region Tables

    // //#region old code

    // // response.result = response.result.replaceAll('apartmentPeoples', globalSettings?.labels?.apartmentPeoples);
    // // response.result = response.result.replaceAll('apartmentReceiptDetails', globalSettings?.labels?.apartmentReceiptDetails);
    // // response.result = response.result.replaceAll('apartmentReceiptPayments', globalSettings?.labels?.apartmentReceiptPayments);
    // // response.result = response.result.replaceAll('purchasePayments', globalSettings?.labels?.purchasePayments);

    // //#endregion old code

    // //#endregion Tables

    // //#region old code

    // // switch (type) {
    // //   case 0:
    // //     //response.result = response.result.replaceAll(globalSettings?.messages?.theRecordCannotBeLocated.en, globalSettings?.messages?.theRecordCannotBeLocated.es);
    // //     //response.result = response.result.replaceAll(globalSettings?.messages?.pleaseTryAgain.en, globalSettings?.messages?.pleaseTryAgain.es);
    // //     break;
    // //   case 1:
    // //     // response.result = response.result.replaceAll('Floor', globalSettings?.labels?.floor.es);
    // //     // response.result = response.result.replaceAll('Identifier', globalSettings?.labels?.identifier.es);
    // //     break;
    // //   case 2:
    // //     // response.result = response.result.replaceAll('First name', globalSettings?.labels?.firstName.es);
    // //     // response.result = response.result.replaceAll('Last name', globalSettings?.labels?.lastName.es);
    // //     //response.result = response.result.replaceAll('Email', globalSettings?.labels?.email.es);
    // //     break;
    // //   case 3:
    // //     // response.result = response.result.replaceAll('You cannot delete this Record', globalSettings?.messages?.youCannotDeleteThisRecord);
    // //     // response.result = response.result.replaceAll('It related other tables', globalSettings?.messages?.itRelatedOtherTables.es);
    // //     // response.result = response.result.replaceAll('Table', globalSettings?.labels?.table.es);
    // //     break;
    // //   case 4:
    // //     // response.result = response.result.replaceAll('Concept', globalSettings?.labels?.concept.es);
    // //     // response.result = response.result.replaceAll('Quantity', globalSettings?.labels?.quantity.es);
    // //     // response.result = response.result.replaceAll('Price', globalSettings?.labels?.price.es);
    // //     // response.result = response.result.replaceAll('Must be greater than', globalSettings?.messages?.mustBeGreaterThan.es);
    // //     break;
    // //   case 5:
    // //     // response.result = response.result.replaceAll('The supplier control number already assigned another invoice from the same supplier', globalSettings?.messages?.theSupplierControlNumberAlreadySssignedAnotherInvoiceFromTheSameSupplier);
    // //     // response.result = response.result.replaceAll('The supplier invoice number already assigned another invoice from the same supplier', globalSettings?.messages?.theSupplierInvoiceNumberAlreadyAssignedAnotherInvoiceFromTheSameSupplier);
    // //     // response.result = response.result.replaceAll('The internal purchase number has already been used another document', globalSettings?.messages?.theInternalPurchaseNumberHasAlReadyBeenUsedAnotherDocument);
    // //     // response.result = response.result.replaceAll(globalSettings?.labels?.date.en, globalSettings?.labels?.date.es);
    // //     // response.result = response.result.replaceAll(globalSettings?.labels?.invoice.en, globalSettings?.labels?.invoice.es);
    // //     // response.result = response.result.replaceAll(globalSettings?.labels?.number.en, globalSettings?.labels?.number.es);
    // //     break;
    // //   default:
    // //     break;
    // // }

    // //#endregion old code

    // //#region Replace (Labels)

    // response.result = response.result.replace(globalSettings?.labels?.number.en, globalSettings?.labels?.number.es);
    // //response.result = response.result.replace(new RegExp('\\bAmount\\b'), globalSettings?.labels?.amount.es);
    // response.result = response.result.replaceAll('Apartment people', globalSettings?.labels?.apartmentPeople);
    // response.result = response.result.replaceAll('Apartment tenant', globalSettings?.labels?.apartmentTenant);
    // //response.result = response.result.replaceAll('Bank account', globalSettings?.labels?.bankAccount.es);
    // //response.result = response.result.replaceAll('Bank accounts', globalSettings?.labels?.bankAccounts.es);
    // response.result = response.result.replace(`\\${globalSettings?.labels?.bankAccounts.es}\\b`, globalSettings?.labels?.bankAccounts.es);
    // //response.result = response.result.replaceAll('Bank', globalSettings?.labels?.bank.es);
    // response.result = response.result.replace(`\\${globalSettings?.labels?.bank.es}\\b`, globalSettings?.labels?.bank.es);
    // //response.result = response.result.replaceAll('Banks', globalSettings?.labels?.banks.es);
    // response.result = response.result.replace(`\\${globalSettings?.labels?.banks.es}\\b`, globalSettings?.labels?.banks.es);
    // response.result = response.result.replaceAll('Control number', globalSettings?.labels?.controlNumber.es);
    // //response.result = response.result.replaceAll('Description', globalSettings?.labels?.description.es);
    // response.result = response.result.replace(`\\${globalSettings?.labels?.description.es}\\b`, globalSettings?.labels?.description.es);
    // //response.result = response.result.replace(new RegExp('\\bEgress\\b'), globalSettings?.labels?.egress.es);
    // response.result = response.result.replaceAll('Expense concept', globalSettings?.labels?.expenseConcept.es);
    // response.result = response.result.replaceAll('Expense template', globalSettings?.labels?.expenseTemplate.es);
    // //response.result = response.result.replaceAll('Method', globalSettings?.labels?.method);
    // //response.result = response.result.replace(new RegExp('\\bMethod\\b'), globalSettings?.labels?.method);
    // //response.result = response.result.replace(new RegExp('\\bSub method\\b'), globalSettings?.labels?.subMethod);

    // //response.result = response.result.replaceAll('Not processed', globalSettings?.labels?.notProcessed.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.notProcessed.en}\\b`), globalSettings?.labels?.notProcessed.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.purchase.en, globalSettings?.labels?.purchase.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.purchase.en}\\b`), globalSettings?.labels?.purchase.es);
    // //response.result = response.result.replaceAll('Payment', globalSettings?.labels?.payment.es);
    // //response.result = response.result.replace(new RegExp('\\bPayment\\b'), globalSettings?.labels?.payment.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.status.en, globalSettings?.labels?.status.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.status.en}\\b`), globalSettings?.labels?.status.es);
    // //response.result = response.result.replaceAll('Suppliers', globalSettings?.labels?.suppliers.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.suppliers.en, globalSettings?.labels?.suppliers.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.supplier.en, globalSettings?.labels?.supplier.es);
    // //response.result = response.result.replace(new RegExp('\\bType\\b'), globalSettings?.labels?.type.es);
    // //response.result = response.result.replaceAll('Cash registers', globalSettings?.labels?.cashRegisters.es);
    // //response.result = response.result.replace(new RegExp('\\bCash registers\\b'), globalSettings?.labels?.cashRegisters.es);
    // //response.result = response.result.replaceAll('Cash register', globalSettings?.labels?.cashRegister.es);
    // //response.result = response.result.replace(new RegExp('\\bCash register\\b'), globalSettings?.labels?.cashRegister.es);
    // //response.result = response.result.replaceAll('Movements', globalSettings?.labels?.movements.es);
    // //response.result = response.result.replace(new RegExp('\\bMovements\\b'), globalSettings?.labels?.movements.es);
    // //response.result = response.result.replaceAll('Movement', globalSettings?.labels?.movement.es);
    // //response.result = response.result.replace(new RegExp('\\bMovement\\b'), globalSettings?.labels?.movement.es);
    // //response.result = response.result.replace(new RegExp('\\bmovement\\b'), globalSettings?.labels?.movement.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.previousBalance.en, globalSettings?.labels?.previousBalance.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.documents.en, globalSettings?.labels?.documents.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.tax.es, globalSettings?.labels?.tax.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.tax.es}\\b`), globalSettings?.labels?.tax.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.taxes.en, globalSettings?.labels?.taxes.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.taxes.en}\\b`), globalSettings?.labels?.taxes.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.files.en, globalSettings?.labels?.files.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.reason.en, globalSettings?.labels?.reason.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.building.en, globalSettings?.labels?.building.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.phone.en, globalSettings?.labels?.phone.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.address.en, globalSettings?.labels?.address.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.email.en, globalSettings?.labels?.email.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.receipt.en}\\b`), globalSettings?.labels?.receipt.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.receipt.en, globalSettings?.labels?.receipt.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.email.en}\\b`), globalSettings?.labels?.email.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.table.en, globalSettings?.labels?.table.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.initialBalance.en, globalSettings?.labels?.initialBalance.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.account.en, globalSettings?.labels?.account.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.account.en}\\b`), globalSettings?.labels?.account.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.currentBalance.en, globalSettings?.labels?.currentBalance.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.name.en, globalSettings?.labels?.name.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.hierarchy.en, globalSettings?.labels?.hierarchy.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.created.en, globalSettings?.labels?.created.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.opened.en, globalSettings?.labels?.opened.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.paused.en, globalSettings?.labels?.paused.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.closed.en, globalSettings?.labels?.closed.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.user.en, globalSettings?.labels?.user.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.role.en, globalSettings?.labels?.role.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.identifier.en, globalSettings?.labels?.identifier.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.date.en, globalSettings?.labels?.date.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.date.en}\\b`), globalSettings?.labels?.date.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.invoice.en, globalSettings?.labels?.invoice.es);
    // response.result = response.result.replaceAll(globalSettings?.labels?.previousBalance.en, globalSettings?.labels?.previousBalance.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.payment.en}\\b`), globalSettings?.labels?.payment.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.active.en}\\b`), globalSettings?.labels?.active.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.inactive.en}\\b`), globalSettings?.labels?.inactive.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.balance.en}\\b`), globalSettings?.labels?.balance.es);
    // response.result = response.result.replaceAll('BSaldo', globalSettings?.labels?.balance.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.total.en}\\b`), globalSettings?.labels?.total.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.bankAccountMovement.en}\\b`), globalSettings?.labels?.bankAccountMovement.es);
    // //response.result = response.result.replaceAll(globalSettings?.labels?.bankAccountMovement.en, globalSettings?.labels?.bankAccountMovement.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.bankAccountMovements.en}\\b`), globalSettings?.labels?.bankAccountMovements.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.user.en}\\b`), globalSettings?.labels?.user.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.users.en}\\b`), globalSettings?.labels?.users.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.apartment.en}\\b`), globalSettings?.labels?.apartment.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.apartments.en}\\b`), globalSettings?.labels?.apartments.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.coin.en}\\b`), globalSettings?.labels?.coin.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.coins.en}\\b`), globalSettings?.labels?.coins.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.rates.en}\\b`), globalSettings?.labels?.rates.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.rate.en}\\b`), globalSettings?.labels?.rate.es);
    // response.result = response.result.replace(new RegExp(`\\${globalSettings?.labels?.contract.en}\\b`), globalSettings?.labels?.contract.es);

    // //#endregion Replace labels
    //#endregion old code
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    //response.result = '';
    response.msgText = `Method: replaceMessages<br/>`;
    response.msgText += `Error: ${ex?.message}`;
    response.result = response.msgText;
  }
  return response;
}

export const dataMachineGetAsync = async ({ subMethod = '', }) => {
  const currentMethod = 'dataMachineGetAsync';
  let response = responseGet();
  try {
    //#region variables
    //#region responseIsWarning
    let responseIsWarning = responseGet();
    responseIsWarning.isWarning = true;
    responseIsWarning.msgType = 1;
    responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
    }
    //#endregion responseIsWarning
    //#endregion variables
    //#region Old code
    // $.get('https://www.cloudflare.com/cdn-cgi/trace', function(data) {
    //   // Convert key-value pairs to JSON
    //   // https://stackoverflow.com/a/39284735/452587
    //   data = data.trim().split('\n').reduce(function(obj, pair) {
    //     pair = pair.split('=');
    //     return obj[pair[0]] = pair[1], obj;
    //   }, {});
    //   console.log(data);
    // });
    //#endregion Old code

    //#region process
    const url = 'https://www.cloudflare.com/cdn-cgi/trace';
    const result = await axios?.get(url);

    if (result.status !== 200) {
      responseIsWarning.result = result;
      responseIsWarning.msgText += `Status: ${result.status}<br/>`;
      responseIsWarning.msgText += `Error: ${result.statusText}`;
      return responseIsWarning;
    }

    let data = result.data;
    data = data.trim().split('\n').reduce(function (obj, pair) {
      pair = pair.split('=');
      return obj[pair[0]] = pair[1], obj; // eslint-disable-line no-sequences
    }, {});

    response.result = data;
    //#endregion process
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const checkIfCallPrinterAsync = async ({ checkIfOnlyIsMobile = false, subMethod = '', }) => {
  const currentMethod = 'checkIfCallPrinterAsync';
  let response = responseGet();
  try {
    //#region initialize
    const device = 'Android';
    const deviceTwo = 'X11';
    const iExplorer = 'Firefox';
    const type = 'Mobile';
    const typeTwo = 'Linux x86_64';
    response.result = false;
    //#endregion initialize

    //#region data machine get
    response = await dataMachineGetAsync({ subMethod: currentMethod, });
    if (!response.isSuccess) {
      return response;
    }

    const dataObj = !isUndNullEmp({ data: response?.result?.uag, subMethod: currentMethod, })?.result ? response?.result?.uag : '';
    //#endregion data machine get

    //#region check if call promt promp
    if (!isUndNullEmp({ data: dataObj, subMethod: currentMethod, })?.result) {
      //#region old code
      // if(localData.indexOf(localDevice) >= 0  && localData.indexOf(localType) >= 0 && localData.indexOf(localIexplorer) >= 0){
      //   //response.result = true;
      // } else {
      //   response.result = true;
      // }
      // if((localData.indexOf(localDevice) < 0 || localData.indexOf(localType) < 0  || localData.indexOf(localIexplorer) < 0) ||
      //   (localData.indexOf(localDeviceTwo) < 0 || localData.indexOf(localTypeTwo) < 0  || localData.indexOf(localIexplorer) < 0)){
      //   response.result = true;
      // }
      //#endregion old code

      if (checkIfOnlyIsMobile) {
        //#region old code
        // if (localData.indexOf(localType) >= 0) {
        //   response.result = true;
        // } else {
        //   response.result = false;
        // }
        //#endregion old code
        response.result = dataObj?.indexOf(type) >= 0;
      } else {
        if (dataObj?.indexOf(device) >= 0 && dataObj?.indexOf(type) >= 0 && dataObj?.indexOf(iExplorer) >= 0) {
          response.result = false;
        } else if (dataObj?.indexOf(deviceTwo) >= 0 && dataObj?.indexOf(typeTwo) >= 0 && dataObj?.indexOf(iExplorer) >= 0) {
          response.result = false;
        } else {
          response.result = true;
        }
      }
    }
    //#endregion check if call printer promp
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const customFileNameGet = ({
  fileName = {},
  lengthStart = 0,
  lengthReturn = 0,
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'customFileNameGet';
  let response = responseGet();
  try {
    if (fileName?.length > lengthReturn) {
      response.result = `${fileName?.substr(lengthStart, lengthReturn)}...`;
    } else {
      response.result = fileName;
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const formatBytes = ({
  bytes = 0,
  decimals = globalSettings?.numberPositions?.decimalPlaces,
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'formatBytes';
  let response = responseGet();
  try {
    if (bytes === 0) {
      response.result = '0 Bytes';
    } else {
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math?.floor(Math?.log(bytes) / Math?.log(k));

      //return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      response.result = parseFloat((bytes / Math?.pow(k, i))?.toFixed(dm)) + ' ' + sizes?.[i];
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const checkFile = ({ fileType = '', fileSize = 0, fileAllowedTypes = [], fileMaxSize = 0, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'checkFile';
  let response = responseGet();
  try {
    //#region check file type
    const fileTypeFind = fileAllowedTypes?.find((detail) => detail === fileType);
    if (isUndNullEmp({ data: fileTypeFind, subMethod: currentMethod, })?.result) {
      response = fileNameByExtensionGet({ fileTypes: fileAllowedTypes, fileMaxSize: fileMaxSize, languageId: languageId, subMethod: currentMethod, });
      if (!response?.isSuccess || response?.isWarning) {
        if (response.isSuccess) {
          response.msgText += `<br/>${globalSettings?.messages?.pleaseTryAgain?.[languageId]}`;
        }
        return response;
      }
    }
    //#endregion check file type

    //#region check file size
    if (fileSize > fileMaxSize) {
      response = fileNameByExtensionGet({ fileTypes: fileAllowedTypes, fileMaxSize: fileMaxSize, languageId: languageId, subMethod: currentMethod, });
      if (!response?.isSuccess || response?.isWarning) {
        if (response.isSuccess) {
          response.msgText += `<br/>${globalSettings?.messages?.pleaseTryAgain?.[languageId]}`;
        }
        return response;
      }
    }
    //#endregion check file size
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
  }
  return response;
}

export const fileNameByExtensionGet = ({ fileTypes = [], fileMaxSize = 0, languageId = 'en', subMethod = '' }) => {
  const currentMethod = 'fileNameByExtensionGet';
  let response = responseGet();
  try {
    //#region check file type (object)
    response.isWarning = true;
    response.msgType = 1;

    if (isUndNullEmp({ data: fileTypes, subMethod: currentMethod, })?.result || fileTypes?.length <= 0) {
      response.msgText = `${globalSettings?.messages?.youMustDefineFileTypes?.[languageId]}<br/>`;
      response.msgText += `Method: fileNameByExtensionGet<br/>`;
      response.msgText += `${globalSettings?.messages?.pleaseTryAgain?.[languageId]}`;
      return response;
    }
    //#endregion check file type (object)

    //#region check file types (get names)
    response.msgText = `${globalSettings?.messages?.onlyTheFollowingFilesAreAllowed?.[languageId]}:<br/>`;
    fileTypes?.forEach((type) => {
      switch (type) {
        //#region Images
        case 'image/png':
          response.msgText += 'PNG, '
          break;
        case 'image/jpeg':
          response.msgText += 'JPEG, '
          break;
        case 'image/jpg':
          response.msgText += 'JPG, '
          break;
        case 'image/bmp':
          response.msgText += 'BMP, '
          break;
        //#endregion Images

        //#region Files
        case 'application/msword':
          if (response.msgText.indexOf('Word', response.msgText) <= -1) {
            response.msgText += 'Word, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          if (response.msgText.indexOf('Word', response.msgText) <= -1) {
            response.msgText += 'Word, '
          }
          break;
        case 'application/vnd.ms-excel':
          if (response.msgText.indexOf('Excel', response.msgText) <= -1) {
            response.msgText += 'Excel, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          if (response.msgText.indexOf('Excel', response.msgText) <= -1) {
            response.msgText += 'Excel, '
          }
          break;
        case 'application/vnd.ms-powerpoint':
          if (response.msgText.indexOf('Power point', response.msgText) <= -1) {
            response.msgText += 'Power point, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          if (response.msgText.indexOf('Power point', response.msgText) <= -1) {
            response.msgText += 'Power point, '
          }
          break;

        case 'application/pdf':
          response.msgText += 'PDF, ';
          break;

        case 'text/plain':
          response.msgText += 'TXT, ';
          break;
        //#endregion Files

        default:
          break;
      }
    });
    //#endregion check file types (get names)

    //#region add leyend max size
    if (fileMaxSize > 0) {
      response.msgText += `<br/>${globalSettings?.messages?.maximunWeightAllowed?.[languageId]}: <b>${formatBytes({ bytes: fileMaxSize, decimals: 0, languageId: languageId, subMethod: currentMethod, })?.result}</b>`;
    }
    //#region add leyend max size
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
  }
  return response;
}

export const documentMaxFilesMessageGet = ({ maxFiles = 0, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'documentMaxFilesMessageGet';
  let response = responseGet();
  try {
    response.isWarning = true;
    response.msgType = 1;
    response.msgText = `${globalSettings?.messages?.onlyMaximumNumberOfFilesIsAllowed?.[languageId]}<br/>`
    response.msgText += `${globalSettings?.messages?.numberAllowed?.[languageId]}: <b>${maxFiles}</b><br/>`
    response.msgText += `${globalSettings?.messages?.pleaseTryAgain?.[languageId]}<br/>`
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
  }
  return response;
}

export const sufficientPrivilegesMessageGet = () => {
  let response = responseGet();
  try {
    response.isWarning = true;
    response.msgType = 1;
    response.msgText = `${globalSettings?.messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess.es}<br/>`;
    response.msgText += `${globalSettings?.messages?.pleaseTryAgain.es}`;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '';
    response.msgText = `Method: sufficientPrivilegesMessageGet<br/>Error: ${ex?.message}`;
  }
  return response;
}

export const appDataGet = ({ subMethod = '', }) => {
  const currentMethod = 'appDataGet';
  let response = responseGet();
  try {
    //#region old code
    // const localAppTitle = globalSettings?.app?.title;
    // const localAppYear = globalSettings?.app?.year;
    // const localAppAddress = globalSettings?.app?.address;
    // const localAppEmail = globalSettings?.app?.emails?.primary;
    // const localAppVersion = globalSettings?.app?.version;

    // response.result = {
    //   appTitle: localAppTitle,
    //   appYear: localAppYear,
    //   appAddress: localAppAddress,
    //   appEmail: localAppEmail,
    //   appVersion: localAppVersion,
    // };
    //#endregion old code

    response.result = {
      appTitle: globalSettings?.app?.title,
      appYear: globalSettings?.app?.year,
      appAddress: globalSettings?.app?.address,
      appEmail: globalSettings?.app?.emails?.primary,
      appVersion: globalSettings?.app?.version,
    };
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = { appTitle: '', appYear: '', appAddress: '', appEmail: '', appVersion: '' };
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const welcomenMessage02Get = ({ languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'welcomenMessage02Get';
  let response = responseGet();
  try {
    switch (languageId) {
      case 'en':
        response.result = `Please, if you have any concerns, do not hesitate to let us know through this email `;
        response.result += `<a href='mailto${globalSettings?.app?.emails?.primary}?subject=$${globalSettings?.labels?.consultSupport?.[languageId]?.replace(' ', '%20')}'>${globalSettings?.labels?.support?.[languageId]}</a> `;
        response.result += `that we will gladly assist you as soon as possible`
        break;
      case 'es':
        response.result = `Por favor si tienes alguna inquietud no dudes en consultarnos a este correo `;
        response.result += `<a href='mailto:${globalSettings?.app?.emails?.primary}?subject=${globalSettings?.labels?.consultSupport?.[languageId].replace(' ', '%20')}'>${globalSettings?.labels?.support?.[languageId]}</a> `;
        response.result += `que con gusto te atenderemos lo antes posible`;
        break;
      default:
        response.result = 'Error language code';
        break;
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = 'Error method';
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

// export const checkUserRole = (user = {}) => {
//   let response = responseGet();
//   try {
//     //#region check if user is master

//     response = checkIfUserIsMaster(user.email);
//     if (!response.isSuccess) {
//       return response;
//     }

//     //#endregion check if user is master

//     //#region check privileges user

//     if (response.result === globalSettings?.roles?.admin) {
//     } else {
//       response.isWarning = true;
//       response.msgType = 1;
//       response.msgText = `${globalSettings?.messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess.es}<br/>`;
//       response.msgText += `${globalSettings?.messages?.pleaseContactTheSupportDepartment.es}`;
//     }

//     //#endregion check privileges user
//   } catch (ex) {
//     response.isSuccess = false;
//     response.msgType = -1;
//     response.result = 'Error method';
//     response.msgText = `Method: checkUserRole<br/>`;
//     response.msgText += `Error: ${ex?.message}`;
//   }
//   return response;
// }

// export const checkUserRoleTwo = (user = {}) => {
//   let response = responseGet();
//   try {
//     //#region variables

//     let localResult = {
//       isMaster: false,
//       isUser: false,
//       isAdmin: false,
//       isAnonimus: false,
//     };

//     //#endregion variables

//     //#region check if user is master

//     response = checkIfUserIsMaster(user.email);
//     if (!response.isSuccess) {
//       return response;
//     }

//     //#endregion check if user is master

//     //#region check privileges user

//     if (response.result === globalSettings?.roles?.admin) {
//       localResult.isMaster = true;
//     } else if (response.result === globalSettings?.roles?.admon) {
//       localResult.isAdmin = true;
//     } else if (response.result === globalSettings?.roles?.user) {
//       localResult.isUser = true;
//     } else {
//       localResult.isAnonimus = true;
//     }

//     //#endregion check privileges user

//     response.result = localResult;
//   } catch (ex) {
//     response.isSuccess = false;
//     response.msgType = -1;
//     response.result = 'Error method';
//     response.msgText = `Method: checkUserRoleTwo<br/>`;
//     response.msgText += `Error: ${ex?.message}`;
//   }
//   return response;
// }

export const statusByNumberGet = ({ status = 0, languageId = 'en', subMethod = '', }) => {
  const currentMethod = 'statusByNumberGet';
  let response = responseGet();
  try {
    switch (status) {
      case 0:
        response.result = globalSettings?.labels?.created?.[languageId];
        break;
      case 1:
        response.result = globalSettings?.labels?.opened?.[languageId];
        break;
      case 2:
        response.result = globalSettings?.labels?.paused?.[languageId];
        break;
      case 3:
        response.result = globalSettings?.labels?.closed?.[languageId];
        break;
      default:
        response.result = 'No option';
        break;
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = 'Status - error'
  }
  return response;
}

export const awaitDelay = ({ delayTimer = 0, }) => new Promise(
  //await new Promise(r => setTimeout(r, globalSettings?.timers?.oneSecond));
  resolve => setTimeout(resolve, delayTimer)
);

export const textByNumericStatus = ({ languageId = 'en', subMethod = '', }) => {
  return [
    { id: '0', type: 'text-black', description: globalSettings?.labels?.dark[languageId], },
    { id: '1', type: 'text-primary', description: globalSettings?.labels?.blue[languageId], },
    { id: '2', type: 'text-success', description: globalSettings?.labels?.green[languageId], },
    { id: '3', type: 'text-warning', description: globalSettings?.labels?.yellow[languageId], },
    { id: '4', type: 'text-info', description: globalSettings?.labels?.lightBlue[languageId], },
    { id: '5', type: 'text-danger', description: globalSettings?.labels?.red[languageId], },
    { id: '6', type: 'text-secondary', description: globalSettings?.labels?.gray[languageId], },
  ];
}

export const iconsGet = ({ languageId = 'en', subMethod = '', }) => {
  return [
    { id: '0', name: 'advertising.png', description: globalSettings?.labels?.advertising?.[languageId], descriptionTwo: globalSettings?.labels?.advertising?.[languageId], },
    { id: '1', name: 'barbeque.png', description: globalSettings?.labels?.barbeque?.[languageId], descriptionTwo: globalSettings?.labels?.barbeque?.[languageId], },
    { id: '2', name: 'bats.png', description: globalSettings?.labels?.bats?.[languageId], descriptionTwo: globalSettings?.labels?.batsNotAccent?.[languageId], },
    { id: '3', name: 'beagle.png', description: globalSettings?.labels?.beagle?.[languageId], descriptionTwo: globalSettings?.labels?.beagle?.[languageId], },
    { id: '4', name: 'breast-cancer.png', description: globalSettings?.labels?.breastCancer?.[languageId], descriptionTwo: globalSettings?.labels?.breastCancerNotAccent?.[languageId], },
    { id: '5', name: 'campaign.png', description: globalSettings?.labels?.campaign?.[languageId], descriptionTwo: globalSettings?.labels?.campaign?.[languageId], },
    { id: '6', name: 'candy-cane.png', description: globalSettings?.labels?.candyCane?.[languageId], descriptionTwo: globalSettings?.labels?.candyCaneNotAccent?.[languageId], },
    { id: '7', name: 'car-key.png', description: globalSettings?.labels?.carKey?.[languageId], descriptionTwo: globalSettings?.labels?.carKey?.[languageId], },
    { id: '8', name: 'car.png', description: globalSettings?.labels?.car?.[languageId], descriptionTwo: globalSettings?.labels?.car?.[languageId], },
    { id: '9', name: 'cat.png', description: globalSettings?.labels?.cat?.[languageId], descriptionTwo: globalSettings?.labels?.cat?.[languageId], },
    { id: '10', name: 'cement.png', description: globalSettings?.labels?.cement?.[languageId], descriptionTwo: globalSettings?.labels?.cement?.[languageId], },
    { id: '11', name: 'christmas-tree.png', description: globalSettings?.labels?.christmasTree?.[languageId], descriptionTwo: globalSettings?.labels?.christmasTreeNotAccent?.[languageId], },
    { id: '12', name: 'complain.png', description: globalSettings?.labels?.complain?.[languageId], descriptionTwo: globalSettings?.labels?.complain?.[languageId], },
    { id: '13', name: 'cone.png', description: globalSettings?.labels?.cone?.[languageId], descriptionTwo: globalSettings?.labels?.cone?.[languageId], },
    { id: '14', name: 'dog.png', description: globalSettings?.labels?.dog?.[languageId], descriptionTwo: globalSettings?.labels?.dog?.[languageId], },
    { id: '15', name: 'dog2.png', description: `${globalSettings?.labels?.dog?.[languageId]} 2`, descriptionTwo: `${globalSettings?.labels?.dog?.[languageId]} 2`, },
    { id: '16', name: 'easter-bunny.png', description: globalSettings?.labels?.easterBunny?.[languageId], descriptionTwo: globalSettings?.labels?.easterBunny?.[languageId], },
    { id: '17', name: 'escalator-up.png', description: globalSettings?.labels?.stairs?.[languageId], descriptionTwo: globalSettings?.labels?.stairs?.[languageId], },
    { id: '18', name: 'face-mask.png', description: globalSettings?.labels?.faceMask?.[languageId], descriptionTwo: globalSettings?.labels?.faceMask?.[languageId], },
    { id: '19', name: 'fast-delivery.png', description: globalSettings?.labels?.fastDelivery?.[languageId], descriptionTwo: globalSettings?.labels?.fastDeliveryNotAccent?.[languageId], },
    { id: '20', name: 'fertilizer.png', description: globalSettings?.labels?.fertilizer?.[languageId], descriptionTwo: globalSettings?.labels?.fertilizer?.[languageId], },
    { id: '21', name: 'fish-bowl.png', description: globalSettings?.labels?.fishBowl?.[languageId], descriptionTwo: globalSettings?.labels?.fishBowl?.[languageId], },
    { id: '22', name: 'gallon.png', description: globalSettings?.labels?.gallon?.[languageId], descriptionTwo: globalSettings?.labels?.gallonNotAccent?.[languageId], },
    { id: '23', name: 'happy-birthday.png', description: globalSettings?.labels?.happyBirthday?.[languageId], descriptionTwo: globalSettings?.labels?.happyBirthday?.[languageId], },
    { id: '24', name: 'happy-new-year.png', description: globalSettings?.labels?.happyNewYear?.[languageId], descriptionTwo: globalSettings?.labels?.happyNewYear?.[languageId], },
    { id: '25', name: 'key.png', description: globalSettings?.labels?.key?.[languageId], descriptionTwo: globalSettings?.labels?.key?.[languageId], },
    { id: '26', name: 'keys.png', description: globalSettings?.labels?.keys?.[languageId], descriptionTwo: globalSettings?.labels?.keys?.[languageId], },
    { id: '27', name: 'lift.png', description: globalSettings?.labels?.lift?.[languageId], descriptionTwo: globalSettings?.labels?.lift?.[languageId], },
    { id: '28', name: 'listening.png', description: globalSettings?.labels?.listening?.[languageId], descriptionTwo: globalSettings?.labels?.listening?.[languageId], },
    { id: '29', name: 'matches.png', description: globalSettings?.labels?.matches?.[languageId], descriptionTwo: globalSettings?.labels?.matches?.[languageId], },
    { id: '30', name: 'megaphone.png', description: globalSettings?.labels?.megaphone?.[languageId], descriptionTwo: globalSettings?.labels?.megaphoneNotAccent?.[languageId], },
    { id: '31', name: 'news.png', description: globalSettings?.labels?.news?.[languageId], descriptionTwo: globalSettings?.labels?.news?.[languageId], },
    { id: '32', name: 'no-connection.png', description: globalSettings?.labels?.noConnection?.[languageId], descriptionTwo: globalSettings?.labels?.noConnectionNotAccent?.[languageId], },
    { id: '33', name: 'no-pets.png', description: globalSettings?.labels?.noPets?.[languageId], descriptionTwo: globalSettings?.labels?.noPets?.[languageId], },
    { id: '34', name: 'notes.png', description: globalSettings?.labels?.notes?.[languageId], descriptionTwo: globalSettings?.labels?.notes?.[languageId], },
    { id: '35', name: 'online-shop.png', description: globalSettings?.labels?.onlineShop?.[languageId], descriptionTwo: globalSettings?.labels?.onlineShop?.[languageId], },
    { id: '36', name: 'palette.png', description: globalSettings?.labels?.palette?.[languageId], descriptionTwo: globalSettings?.labels?.palette?.[languageId], },
    { id: '37', name: 'patient.png', description: globalSettings?.labels?.patient?.[languageId], descriptionTwo: globalSettings?.labels?.patient?.[languageId], },
    { id: '38', name: 'pet.png', description: globalSettings?.labels?.pet?.[languageId], descriptionTwo: globalSettings?.labels?.pet?.[languageId], },
    { id: '39', name: 'pig.png', description: globalSettings?.labels?.pig?.[languageId], descriptionTwo: globalSettings?.labels?.pig?.[languageId], },
    { id: '40', name: 'pin.png', description: globalSettings?.labels?.pin?.[languageId], descriptionTwo: globalSettings?.labels?.pin?.[languageId], },
    { id: '41', name: 'pine.png', description: globalSettings?.labels?.pine?.[languageId], descriptionTwo: globalSettings?.labels?.pine?.[languageId], },
    { id: '42', name: 'popcorn.png', description: globalSettings?.labels?.popcorn?.[languageId], descriptionTwo: globalSettings?.labels?.popcorn?.[languageId], },
    { id: '43', name: 'promo.png', description: globalSettings?.labels?.promo?.[languageId], descriptionTwo: globalSettings?.labels?.promoNotAccente?.[languageId], },
    { id: '44', name: 'pumpkin.png', description: globalSettings?.labels?.pumpkin?.[languageId], descriptionTwo: globalSettings?.labels?.pumpkin?.[languageId], },
    { id: '45', name: 'santa.png', description: globalSettings?.labels?.santa?.[languageId], descriptionTwo: globalSettings?.labels?.santa?.[languageId], },
    { id: '46', name: 'seesaw.png', description: globalSettings?.labels?.seesaw?.[languageId], descriptionTwo: globalSettings?.labels?.seesawNotAccente?.[languageId], },
    { id: '47', name: 'silent.png', description: globalSettings?.labels?.silent?.[languageId], descriptionTwo: globalSettings?.labels?.silent?.[languageId], },
    { id: '49', name: 'skull.png', description: globalSettings?.labels?.skull?.[languageId], descriptionTwo: globalSettings?.labels?.skullNotAccente?.[languageId], },
    { id: '50', name: 'smart-light.png', description: globalSettings?.labels?.smartLight?.[languageId], descriptionTwo: globalSettings?.labels?.smartLight?.[languageId], },
    { id: '51', name: 'sore-throat.png', description: globalSettings?.labels?.soreThroat?.[languageId], descriptionTwo: globalSettings?.labels?.soreThroat?.[languageId], },
    { id: '52', name: 'soup.png', description: globalSettings?.labels?.soup?.[languageId], descriptionTwo: globalSettings?.labels?.soup?.[languageId], },
    { id: '53', name: 'spotlight.png', description: globalSettings?.labels?.spotlight?.[languageId], descriptionTwo: globalSettings?.labels?.spotlight?.[languageId], },
    { id: '54', name: 'street-light.png', description: globalSettings?.labels?.streetLight?.[languageId], descriptionTwo: globalSettings?.labels?.streetLight?.[languageId], },
    { id: '55', name: 'street-lights.png', description: globalSettings?.labels?.streetLights?.[languageId], descriptionTwo: globalSettings?.labels?.streetLights?.[languageId], },
    { id: '56', name: 'swimming-pool.png', description: globalSettings?.labels?.swimmingPool?.[languageId], descriptionTwo: globalSettings?.labels?.swimmingPool?.[languageId], },
    { id: '57', name: 'theatre.png', description: globalSettings?.labels?.theatre?.[languageId], descriptionTwo: globalSettings?.labels?.theatre?.[languageId], },
    { id: '58', name: 'trash-bin.png', description: globalSettings?.labels?.trashBin?.[languageId], descriptionTwo: globalSettings?.labels?.trashBin?.[languageId], },
    { id: '59', name: 'trash.png', description: globalSettings?.labels?.trash?.[languageId], descriptionTwo: globalSettings?.labels?.trash?.[languageId], },
    { id: '60', name: 'trolley.png', description: globalSettings?.labels?.trolley?.[languageId], descriptionTwo: globalSettings?.labels?.trolley?.[languageId], },
    { id: '61', name: 'trophy.png', description: globalSettings?.labels?.trophy?.[languageId], descriptionTwo: globalSettings?.labels?.trophy?.[languageId], },
    { id: '62', name: 'water-tap.png', description: globalSettings?.labels?.waterTap?.[languageId], descriptionTwo: globalSettings?.labels?.waterTap?.[languageId], },
    { id: '63', name: 'wireless.png', description: globalSettings?.labels?.wireless?.[languageId], descriptionTwo: globalSettings?.labels?.wirelessNotAccent?.[languageId], },
  ];
}

export const charactersRemainingGet = ({ text = '', maxLength = 0, msgText = '', subMethod = '', }) => {
  const currentMethod = 'charactersRemainingGet';
  let response = responseGet();
  try {
    //response.result = `${text.length - maxLength} ${msgText}`;
    response.result = `${msgText} <b>${maxLength - text?.length}</b>`;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = `${currentMethod} - error`;
    console?.error(response);
  }
  return response;
}

export const statusGet = ({ languageId = 'en', subMethod = '', }) => {
  return [
    { id: '0', description: globalSettings?.labels?.created?.[languageId], },
    { id: '1', description: globalSettings?.labels?.approved?.[languageId], },
    { id: '2', description: globalSettings?.labels?.modify?.[languageId], },
    { id: '3', description: globalSettings?.labels?.notApproved?.[languageId], },
  ];
}

export const processEvaluateGet = ({ object = {}, property = '', process = '', subMethod = '', }) => {
  const currentMethod = 'processEvaluateGet';
  let response = responseGet();
  try {
    response.result = false;
    if (!isUndNullEmp({ data: object, subMethod: currentMethod, })?.result) {
      if (!isUndNullEmp({ data: object?.[property], subMethod: currentMethod, })?.result) {
        if (!isUndNullEmp({ data: object?.[property]?.[process], subMethod: currentMethod, })?.result) {
          response.result = object?.[property]?.[process];
        }
      }
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = `${currentMethod} - error`;
    console?.error(response);
  }
  return response;
}

//#region old code
// export const modalFormsSetAttributesInBody = (showModal = false, subMethod = '',) => {
//   let response = responseGet();
//   try {
//     const localBodyId = 'bodyMainId';
//     const bodyMainClass = 'hold-transition sidebar-mini layout-fixed;';
//     const bodyShowModalClass = 'hold-transition sidebar-mini layout-fixed modal-open';
//     const bodyMainAttrStyle = 'height: auto;';
//     const bodyShowModalAttrStyle = 'height: auto; overflow: hidden; padding-right: 15px;';

//     const localBodyObj = $(`#${localBodyId}`);

//     localBodyObj.attr(
//       { 'class': (showModal ? bodyShowModalClass : bodyMainClass) },
//       { 'style': (showModal ? bodyShowModalAttrStyle : bodyMainAttrStyle) },
//       //{'data-rr-ui-modal-open': '',}
//     );
//   } catch (ex) {
//     response.isSuccess = false;
//     response.msgType = -1;
//     response.msgText = `Method: modalFormsSetAttributesInBody<br/>`;
//     if (!isEmpty(subMethod)) {
//       response.msgText += `Sub method: ${subMethod}<br/>`
//     }
//     response.msgText += `Error: ${ex?.message}`;
//   }
//   return response;
// }
//#endregion old code

export const isUndNull = ({ data = undefined, subMethod = '', }) => {
  let response = responseGet();
  const currentMethod = 'isUndNull';
  try {
    response.result = (data === undefined || data === null);
  } catch (ex) {
    response.isSuccess = false;
    response.msgType = -1;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    console?.error(response);
  }
  return response;
}

export const isUndNullEmp = ({ data = undefined, subMethod = '', }) => {
  let response = responseGet();
  const currentMethod = 'isUndNullEmp';
  try {
    response.result = (data === undefined || data === null || data === '' ||
      (Object.keys(data).length <= 0 && data.constructor === Object)
      || (Array.isArray(data) && data?.length <= 0));
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (subMethod !== undefined && subMethod !== null && subMethod !== '') {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    console?.error(response);
  }
  return response;
}

export function globalFormat() {
  return {
    code: '',
    id: '',
    format: {
      date: {
        f1: '',
        f2: '',
        f3: '',
        f4: '',
        f5: '',
        f6: '',
        f7: '',
        f8: '',
        f9: '',
        f10: '',
        f11: '',
        f12: '',
        f13: '',
      },
      time: {
        f1: '',
        f2: '',
        f3: '',
        f4: '',
        picker: {
          hhmm: '',
          hhmmss: '',
        },
        type: 0,
      },
    },
    numbers: {
      separators: {
        decimals: '',
        thousands: '',
      },
    },
  };
}

export const languageObjGet = ({ subMethod = '', }) => {
  let response = responseGet();
  const currentMethod = 'languageObjGet';
  const formatLocal = globalFormat();
  try {
    //#region variables
    const languageId = navigator?.language || navigator?.uerLanguage || navigator?.userLanguage;
    //#endregion variables

    const {languages, } = globalSettings;
    //#region process
    if (isUndNullEmp({ data: languageId, subMethod: currentMethod })?.result) {
      response.result = languages?.enUS;
    } else {
      switch (languageId) {
        case languages?.enUS?.code:
          response.result = languages?.enUS;
          break;
        case languages?.es?.code:
          response.result = languages?.es;
          break;
          case languages?.esES?.code:
          response.result = languages?.esES;
          break;
        case languages?.esAR?.code:
          response.result = languages?.esAR;
          break;
        case languages?.esCL?.code:
          response.result = languages?.esCL;
          break;
        case languages?.esCO?.code:
          response.result = languages?.esCO;
          break;
        case languages?.esMX?.code:
          response.result = languages?.esMX;
          break;
        case languages?.esUS?.code:
          response.result = languages?.esUS;
          break;
        case languages?.esVE?.code:
          response.result = languages?.esVE;
          break;
        case languages?.es419?.code:
          response.result = languages?.es419;
          break;
        default:
          response.result = languages?.enUS;
          break;
      }
    }
    //#endregion process
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}</br>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = formatLocal;
    console?.error(response);
  }
  return response;
}

export const LoadingSection = ({
  alt = '',
  className = '',
  showText = true,
  text = '',
  height = 16,
  hidden = false,
  languageId = 'en',
  width = 16,
  subMethod = '',
}) => {
  let response = responseGet();
  const currentMethod = 'LoadingSection';
  try {
    text = isUndNullEmp({ data: text, subMethod: currentMethod, })?.result ?
      globalSettings?.labels?.loading?.[languageId] :
      text;
    return (
      <div className={className}
        hidden={hidden}>
        <img alt={alt}
          //#region old code
          // src={resumeValues?.amination?.src}
          // height={resumeValues?.amination?.height}
          // width={resumeValues?.amination?.whidth} /> {resumeValues?.label}
          //#endregion old code
          //#region old code
          // src={settings?.gifs?.normal?.circle}
          // height={16}
          // width={16} /> {showText ? `${settings?.labels?.loading?.[languageId]}...` : ''}
          //#endregion old code
          src={globalSettings?.gifs?.normal?.circle}
          height={height}
          width={width} /> {showText ? `${text}...` : ``}
      </div>
    );
  } catch (ex) {
    response.isSuccess = false;
    response.msgType = -1;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    console?.error(response);
  }
}

export const lodash = {
  //#region decrypt
  //#region old code
  // decrypt: async ({
  //   data = '',
  //   secretKey = globalSettings?.cryptr?.secretKey,
  //   encoding = globalSettings?.cryptr?.encoding?.base64,
  //   pbkdf2Iterations = globalSettings?.cryptr?.pbkdf2Iterations,
  //   saltLength = globalSettings?.cryptr?.saltLength,
  //   subMethod = '',
  //   languageId = 'en',
  // }) => {
  //   let response = responseGet();
  //   const currentMethod = 'lodash / decrypt';
  //   try {
  //     const cryptr = new Cryptr(
  //       secretKey,
  //       {
  //         pbkdf2Iterations: pbkdf2Iterations,
  //         saltLength: saltLength,
  //         encoding: encoding,
  //       }
  //     );
  //     response.result = await cryptr?.decrypt(data);
  //   } catch (ex) {
  //     response.msgType = -1;
  //     response.isSuccess = false;
  //     response.msgText = `Method: ${currentMethod}<br/>`;
  //     if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
  //       response.msgText += `Sub method: ${subMethod}<br/>`;
  //     }
  //     response.msgText += `Error: ${ex?.message}`;
  //   }
  //   return response;
  // },
  //#endregion old code
  //#endregion decrypt

  //#region encrypt
  //#region old code
  // encrypt: async ({
  //   data = '',
  //   secretKey = globalSettings?.cryptr?.secretKey,
  //   encoding = globalSettings?.cryptr?.encoding?.base64,
  //   pbkdf2Iterations = globalSettings?.cryptr?.pbkdf2Iterations,
  //   saltLength = globalSettings?.cryptr?.saltLength,
  //   subMethod = '',
  //   languageId = 'en',
  // }) => {
  //   let response = responseGet();
  //   const currentMethod = 'lodash / encrypt';
  //   try {
  //     //response.result = await bcrypt.hashSync(data, saltOrRounds);
  //     const cryptr = new Cryptr(
  //       secretKey,
  //       {
  //         pbkdf2Iterations: pbkdf2Iterations,
  //         saltLength: saltLength,
  //         encoding: encoding,
  //       }
  //     );
  //     response.result = await cryptr?.encrypt(data);
  //   } catch (ex) {
  //     response.msgType = -1;
  //     response.isSuccess = false;
  //     response.msgText = `Method: ${currentMethod}<br/>`;
  //     if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
  //       response.msgText += `Sub method: ${subMethod}<br/>`;
  //     }
  //     response.msgText += `Error: ${ex?.message}`;
  //   }
  //   return response;
  // },
  //#endregion old code
  //#endregion encrypt

  //#region hasIn
  hasIn: ({ obj = {}, data = '', subMethod = '', }) => {
    let response = responseGet();
    const currentMethod = 'lodash / hasIn';
    try {
      response.result = obj.hasOwnProperty(data);
    } catch (ex) {
      response.msgType = -1;
      response.isSuccess = false;
      response.msgText = `Method: ${currentMethod}<br/>`;
      if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`;
      }
      response.msgText += `Error: ${ex?.message}`;
      console.error(response);
    }
    return response;
  },
  //#endregion hasIn

  //#region unique
  unique: ({ data = [], key = '', subMethod = '', }) => {
    let response = responseGet();
    const currentMethod = 'lodash / unique';
    try {
      if (!isUndNullEmp({ data: key, subMethod: currentMethod })?.result) {
        response.result = data.filter((value, index) => data.findIndex((fi) => value[key] === fi[key]) === index);
      } else {
        response.result = data.filter((value, index, array) => array.indexOf(value) === index);
      }

      //#region Examples
      // let localArray = [
      //     { 'name': 'Joe', 'age': 17 },
      //     { 'name': 'Bob', 'age': 17 },
      //     { 'name': 'Carl', 'age': 35 }
      // ]
      // let localUniques = localArray.filter((value, index) => localArray.findIndex((fi) => value.age === fi.age) === index)
      // console.log(localUniques); // [{'name':'Joe', 'age':17}, {'name':'Carl', 'age': 35}]

      // localArray = ['a', 1, 'a', 2, '1'];
      // localUniques = localArray.filter((value, index, array) => array.indexOf(value) === index);
      // console.log(localUniques); //['a', 1, 2, '1']
      //#endregion Examples
    } catch (ex) {
      response.msgType = -1;
      response.isSuccess = false;
      response.msgText = `Method: ${currentMethod}<br/>`;
      if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`
      }
      response.msgText += `Error: ${ex?.message}`;
      response.result = [];
    }
    return response;
  },
  //#endregion unique

  //#region sum
  sum: ({ data = [], key = '', consoleLogErrorShow = false, subMethod = '', }) => {
    let response = responseGet();
    const currentMethod = 'lodash / sum';
    try {
      response.result = data?.reduce((acumulator, object) => {
        return acumulator + object[key];
      }, 0);
    } catch (ex) {
      response.msgType = -1;
      response.isSuccess = false;
      response.msgText = `Method: ${currentMethod}<br/>`;
      if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`
      }
      response.msgText += `Error: ${ex?.message}`;
      response.result = [];
      if (consoleLogErrorShow) {
        console?.error(response);
      }
    }
    return response;
  },
  //#endregion sum
}

//#region methods
//#region building contracts
export const buildingContractShowDetails = ({
  contract = buildingContractModelGet({}),
  auth = {},
  showInfoAudit = false,
  languageObj = GlobalFormats?.class(languageObjGet({ subMethod: 'buildingContractShowDetails', })?.result),
  subMethod = '',
}) => {
  const currentMethod = 'buildingContractShowDetails';
  let response = responseGet();
  try {
    //#region variables
    const dateTimeObj = {
      start: dateTimeFormatGlobalSet({
        date: contract?.dateStart,
        type: languageObj?.format?.date?.f1,
        format: languageObj?.format?.time?.type,
        addTime: false,
        languageId: languageObj?.id,
        subMethod: currentMethod,
      })?.result,
      end: dateTimeFormatGlobalSet({
        date: contract?.dateEnd,
        type: languageObj?.format?.date?.f1,
        format: languageObj?.format?.time?.type,
        addTime: false,
        languageId: languageObj?.id,
        subMethod: currentMethod,
      })?.result,
      created: dateTimeFormatGlobalSet({
        date: contract?.created,
        type: languageObj?.format?.date?.f1,
        format: languageObj?.format?.time?.type,
        addTime: false,
        languageId: languageObj?.id,
        subMethod: currentMethod,
      })?.result,
    };
    //#endregion variables

    //#region methods
    response.result = `<div class='table-responsive' style='font-size:14px'>`;
    //response.result += `   <div>${msgText}</div>`;
    //response.result += `  <br/>`;
    response.result += `    <table class='table table-sm'>`;
    response.result += `       <col width='20px'/>`;
    response.result += `       <col width='80px'/>`;
    response.result += `       <tbody class='text-left'>`;
    response.result += `           <tr>`;
    response.result += `               <td>${globalSettings?.labels?.code?.[languageObj?.id]}:</td>`;
    response.result += `               <td><b>${contract.subContractId}</b></td>`;
    response.result += `           </tr>`;
    response.result += `           <tr>`;
    response.result += `               <td>${globalSettings?.labels?.startDate?.[languageObj?.id]}:</td>`;
    response.result += `               <td><b>${dateTimeObj?.start}</b></td>`;
    response.result += `           </tr>`;
    response.result += `           <tr>`;
    response.result += `               <td>${globalSettings?.labels?.endDate?.[languageObj?.id]}:</td>`;
    response.result += `               <td><b>${dateTimeObj?.end}</b></td>`;
    response.result += `           </tr>`;
    response.result += `           <tr>`;
    response.result += `               <td>${globalSettings?.labels?.remark?.[languageObj?.id]}:</td>`;
    response.result += `               <td><b>${contract.remark}</b></td>`;
    response.result += `           </tr>`;
    if (showInfoAudit) {
      response.result += `           <tr>`;
      response.result += `               <td>${globalSettings?.labels?.user?.[languageObj?.id]}:</td>`;
      response.result += `               <td><b>${!isUndNullEmp({ data: contract?.user, subMethod: currentMethod, })?.result ? `${contract?.user?.firstName}, ${contract?.user?.lastName}` : `${contract?.userId}`}</b></td>`;
      response.result += `           </tr>`;
      response.result += `           <tr>`;
      response.result += `               <td>${globalSettings?.labels?.remark?.[languageObj?.id]}:</td>`;
      response.result += `               <td><b>${dateTimeObj?.created}</b></td>`;
      response.result += `           </tr>`;
    }
    response.result += `       </tbody>`;
    response.result += `   </table>`;
    response.result += `</div>`;
    //#endregion methods
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const expenseCenceptTypesGet = ({
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'expenseCenceptTypesGet';
  let response = responseGet();
  try {
    response.result = [
      { id: 1, description: globalSettings?.labels?.fixed?.[languageId], },
      { id: 2, description: globalSettings?.labels?.variable?.[languageId], },
      { id: 3, description: globalSettings?.labels?.others?.[languageId], },
    ];
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
    response.result = [];
  }
  return response;
}
//#endregion building contracts
//#endregion methods